/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * BreedLogic - Core
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AcknowledgedWarningRequest
 */
export interface AcknowledgedWarningRequest {
    /**
     * 
     * @type {number}
     * @memberof AcknowledgedWarningRequest
     */
    'ruleId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AcknowledgedWarningRequest
     */
    'entityDetailId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AcknowledgedWarningRequest
     */
    'ruleKey'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AcknowledgedWarningRequest
     */
    'reason'?: string | null;
}
/**
 * 
 * @export
 * @interface ActionInstruction
 */
export interface ActionInstruction {
    /**
     * 
     * @type {RuleActionType}
     * @memberof ActionInstruction
     */
    'type'?: RuleActionType;
    /**
     * 
     * @type {number}
     * @memberof ActionInstruction
     */
    'targetFieldId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ActionInstruction
     */
    'value'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ActionInstruction
     */
    'overwriteExisting'?: boolean | null;
    /**
     * 
     * @type {MessageLevel}
     * @memberof ActionInstruction
     */
    'level'?: MessageLevel;
    /**
     * 
     * @type {string}
     * @memberof ActionInstruction
     */
    'description'?: string | null;
}


/**
 * 
 * @export
 * @enum {number}
 */

export const ActionType = {
    Create: 0,
    Edit: 1,
    Delete: 2,
    Studbook: 3,
    QuickSearch: 4
} as const;

export type ActionType = typeof ActionType[keyof typeof ActionType];


/**
 * 
 * @export
 * @interface AddFeesRequest
 */
export interface AddFeesRequest {
    /**
     * 
     * @type {Array<FeeDto>}
     * @memberof AddFeesRequest
     */
    'items'?: Array<FeeDto> | null;
}
/**
 * 
 * @export
 * @interface AddOrganisationRequest
 */
export interface AddOrganisationRequest {
    /**
     * 
     * @type {string}
     * @memberof AddOrganisationRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddOrganisationRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddOrganisationRequest
     */
    'currency'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddOrganisationRequest
     */
    'country'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AddOrganisationRequest
     */
    'isFreeMembership'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AddOrganisationRequest
     */
    'constitutionUrl'?: string | null;
    /**
     * 
     * @type {Array<OrganisationServiceOption>}
     * @memberof AddOrganisationRequest
     */
    'organisationServiceOptions'?: Array<OrganisationServiceOption> | null;
}
/**
 * 
 * @export
 * @interface AddRoleRequest
 */
export interface AddRoleRequest {
    /**
     * 
     * @type {string}
     * @memberof AddRoleRequest
     */
    'roleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddRoleRequest
     */
    'roleDescription'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AddRoleRequest
     */
    'isSystemRole'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AddRoleRequest
     */
    'isDefaultRole'?: boolean;
}
/**
 * 
 * @export
 * @interface AddRuleRequest
 */
export interface AddRuleRequest {
    /**
     * 
     * @type {string}
     * @memberof AddRuleRequest
     */
    'ruleName': string;
    /**
     * 
     * @type {string}
     * @memberof AddRuleRequest
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof AddRuleRequest
     */
    'ruleJson'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddRuleRequest
     */
    'triggerConfigJson'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddRuleRequest
     */
    'errorMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddRuleRequest
     */
    'ruleEntityId'?: string | null;
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof AddRuleRequest
     */
    'ruleEntityType'?: EntityTypeCode;
    /**
     * 
     * @type {boolean}
     * @memberof AddRuleRequest
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AddRuleRequest
     */
    'canOverride'?: boolean;
    /**
     * 
     * @type {Array<ActionType>}
     * @memberof AddRuleRequest
     */
    'actionTypes'?: Array<ActionType> | null;
    /**
     * 
     * @type {boolean}
     * @memberof AddRuleRequest
     */
    'isPreUpdateCheck'?: boolean | null;
    /**
     * 
     * @type {Array<AnimalType>}
     * @memberof AddRuleRequest
     */
    'animalType'?: Array<AnimalType> | null;
    /**
     * 
     * @type {Array<UpdateRuleConfigurationRequest>}
     * @memberof AddRuleRequest
     */
    'roleOverrides'?: Array<UpdateRuleConfigurationRequest> | null;
}


/**
 * 
 * @export
 * @interface AdditionalInfoDto
 */
export interface AdditionalInfoDto {
    /**
     * 
     * @type {string}
     * @memberof AdditionalInfoDto
     */
    'entityId'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdditionalInfoDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdditionalInfoDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdditionalInfoDto
     */
    'ident'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdditionalInfoDto
     */
    'isStudbookOptedOut'?: boolean;
}
/**
 * 
 * @export
 * @interface AnimalDetailFilterInput
 */
export interface AnimalDetailFilterInput {
    /**
     * 
     * @type {string}
     * @memberof AnimalDetailFilterInput
     */
    'detailName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnimalDetailFilterInput
     */
    'value'?: string | null;
    /**
     * 
     * @type {EntityDetailType}
     * @memberof AnimalDetailFilterInput
     */
    'type'?: EntityDetailType;
    /**
     * 
     * @type {ComparisonOperator}
     * @memberof AnimalDetailFilterInput
     */
    'operator'?: ComparisonOperator;
}


/**
 * 
 * @export
 * @interface AnimalSpeciesBreedDto
 */
export interface AnimalSpeciesBreedDto {
    /**
     * 
     * @type {number}
     * @memberof AnimalSpeciesBreedDto
     */
    'animalSpeciesBreedId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AnimalSpeciesBreedDto
     */
    'animalSpeciesBreedEntityId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AnimalSpeciesBreedDto
     */
    'animalSpeciesId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AnimalSpeciesBreedDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnimalSpeciesBreedDto
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface AnimalSpeciesDto
 */
export interface AnimalSpeciesDto {
    /**
     * 
     * @type {number}
     * @memberof AnimalSpeciesDto
     */
    'animalSpeciesId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AnimalSpeciesDto
     */
    'animalSpeciesEntityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnimalSpeciesDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnimalSpeciesDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {Array<AnimalSpeciesBreedDto>}
     * @memberof AnimalSpeciesDto
     */
    'animalSpeciesBreeds'?: Array<AnimalSpeciesBreedDto> | null;
}
/**
 * 
 * @export
 * @enum {number}
 */

export const AnimalType = {
    Standard: 0,
    Foundation: 1,
    Imported: 2,
    Commercial: 3
} as const;

export type AnimalType = typeof AnimalType[keyof typeof AnimalType];


/**
 * 
 * @export
 * @interface AppendWorkOrderItemRequest
 */
export interface AppendWorkOrderItemRequest {
    /**
     * 
     * @type {string}
     * @memberof AppendWorkOrderItemRequest
     */
    'itemDescription': string;
    /**
     * 
     * @type {FeeSection}
     * @memberof AppendWorkOrderItemRequest
     */
    'itemType': FeeSection;
    /**
     * 
     * @type {number}
     * @memberof AppendWorkOrderItemRequest
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof AppendWorkOrderItemRequest
     */
    'feeId': number;
    /**
     * 
     * @type {number}
     * @memberof AppendWorkOrderItemRequest
     */
    'rate'?: number;
    /**
     * 
     * @type {string}
     * @memberof AppendWorkOrderItemRequest
     */
    'itemTypeEntityId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AppendWorkOrderItemRequest
     */
    'itemEntityId'?: string | null;
}


/**
 * 
 * @export
 * @interface AppendWorkOrderItemsRequest
 */
export interface AppendWorkOrderItemsRequest {
    /**
     * 
     * @type {number}
     * @memberof AppendWorkOrderItemsRequest
     */
    'enterpriseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AppendWorkOrderItemsRequest
     */
    'organisationId'?: number;
    /**
     * 
     * @type {Array<AppendWorkOrderItemRequest>}
     * @memberof AppendWorkOrderItemsRequest
     */
    'items'?: Array<AppendWorkOrderItemRequest> | null;
}
/**
 * 
 * @export
 * @interface AuthorisedRepresentativeDto
 */
export interface AuthorisedRepresentativeDto {
    /**
     * 
     * @type {number}
     * @memberof AuthorisedRepresentativeDto
     */
    'authorisedRepresentativeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AuthorisedRepresentativeDto
     */
    'authorisedRepresentativeEntityId'?: string;
    /**
     * 
     * @type {number}
     * @memberof AuthorisedRepresentativeDto
     */
    'memberId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AuthorisedRepresentativeDto
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuthorisedRepresentativeDto
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuthorisedRepresentativeDto
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface BillableEventDto
 */
export interface BillableEventDto {
    /**
     * 
     * @type {string}
     * @memberof BillableEventDto
     */
    'billableEventIdent'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BillableEventDto
     */
    'billableEventId'?: number;
    /**
     * 
     * @type {number}
     * @memberof BillableEventDto
     */
    'orgId'?: number;
    /**
     * 
     * @type {number}
     * @memberof BillableEventDto
     */
    'entityId'?: number;
    /**
     * 
     * @type {number}
     * @memberof BillableEventDto
     */
    'grossAmount'?: number;
    /**
     * 
     * @type {string}
     * @memberof BillableEventDto
     */
    'date'?: string;
    /**
     * 
     * @type {number}
     * @memberof BillableEventDto
     */
    'batchId'?: number | null;
    /**
     * 
     * @type {Array<ItemCodeDto>}
     * @memberof BillableEventDto
     */
    'itemCodes'?: Array<ItemCodeDto> | null;
}
/**
 * 
 * @export
 * @interface BillableEventDtoPagedResult
 */
export interface BillableEventDtoPagedResult {
    /**
     * 
     * @type {Array<BillableEventDto>}
     * @memberof BillableEventDtoPagedResult
     */
    'queryable'?: Array<BillableEventDto> | null;
    /**
     * 
     * @type {number}
     * @memberof BillableEventDtoPagedResult
     */
    'currentPage'?: number;
    /**
     * 
     * @type {number}
     * @memberof BillableEventDtoPagedResult
     */
    'pageCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof BillableEventDtoPagedResult
     */
    'pageSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof BillableEventDtoPagedResult
     */
    'rowCount'?: number;
}
/**
 * 
 * @export
 * @interface BillableEventFilter
 */
export interface BillableEventFilter {
    /**
     * 
     * @type {string}
     * @memberof BillableEventFilter
     */
    'status'?: string | null;
}
/**
 * 
 * @export
 * @enum {number}
 */

export const BreedlogicSyncEntityType = {
    Animal: 0,
    Member: 1
} as const;

export type BreedlogicSyncEntityType = typeof BreedlogicSyncEntityType[keyof typeof BreedlogicSyncEntityType];


/**
 * 
 * @export
 * @interface BulkAssignUsersToOrganisationRequest
 */
export interface BulkAssignUsersToOrganisationRequest {
    /**
     * 
     * @type {number}
     * @memberof BulkAssignUsersToOrganisationRequest
     */
    'organisationId'?: number;
    /**
     * 
     * @type {Array<UserRoleAssignment>}
     * @memberof BulkAssignUsersToOrganisationRequest
     */
    'userRoleAssignments'?: Array<UserRoleAssignment> | null;
}
/**
 * 
 * @export
 * @interface BulkDisposeErrorDto
 */
export interface BulkDisposeErrorDto {
    /**
     * 
     * @type {number}
     * @memberof BulkDisposeErrorDto
     */
    'animalId'?: number;
    /**
     * 
     * @type {string}
     * @memberof BulkDisposeErrorDto
     */
    'error'?: string | null;
}
/**
 * 
 * @export
 * @interface BulkDisposeRequest
 */
export interface BulkDisposeRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof BulkDisposeRequest
     */
    'animalIds'?: Array<number> | null;
    /**
     * 
     * @type {DisposalRecord}
     * @memberof BulkDisposeRequest
     */
    'disposalRecord'?: DisposalRecord;
}
/**
 * 
 * @export
 * @interface BulkDisposeResultDto
 */
export interface BulkDisposeResultDto {
    /**
     * 
     * @type {Array<BulkDisposeSuccessDto>}
     * @memberof BulkDisposeResultDto
     */
    'successResults'?: Array<BulkDisposeSuccessDto> | null;
    /**
     * 
     * @type {Array<BulkDisposeErrorDto>}
     * @memberof BulkDisposeResultDto
     */
    'errors'?: Array<BulkDisposeErrorDto> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof BulkDisposeResultDto
     */
    'successIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface BulkDisposeSuccessDto
 */
export interface BulkDisposeSuccessDto {
    /**
     * 
     * @type {number}
     * @memberof BulkDisposeSuccessDto
     */
    'animalId'?: number;
    /**
     * 
     * @type {DisposalRecord}
     * @memberof BulkDisposeSuccessDto
     */
    'disposalRecord'?: DisposalRecord;
}
/**
 * 
 * @export
 * @interface BulkRuleEnabledFailureDto
 */
export interface BulkRuleEnabledFailureDto {
    /**
     * 
     * @type {number}
     * @memberof BulkRuleEnabledFailureDto
     */
    'ruleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof BulkRuleEnabledFailureDto
     */
    'reason'?: string | null;
}
/**
 * 
 * @export
 * @interface BulkSetRuleEnabledRequest
 */
export interface BulkSetRuleEnabledRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof BulkSetRuleEnabledRequest
     */
    'ruleIds'?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof BulkSetRuleEnabledRequest
     */
    'enabled'?: boolean;
}
/**
 * 
 * @export
 * @interface BulkSetRuleEnabledResponseDto
 */
export interface BulkSetRuleEnabledResponseDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof BulkSetRuleEnabledResponseDto
     */
    'updatedRuleIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<BulkRuleEnabledFailureDto>}
     * @memberof BulkSetRuleEnabledResponseDto
     */
    'failures'?: Array<BulkRuleEnabledFailureDto> | null;
}
/**
 * 
 * @export
 * @interface BulkSuspendMemberRequest
 */
export interface BulkSuspendMemberRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof BulkSuspendMemberRequest
     */
    'entityIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface BulkUploadDocumentRequest
 */
export interface BulkUploadDocumentRequest {
    /**
     * 
     * @type {string}
     * @memberof BulkUploadDocumentRequest
     */
    'entityId'?: string;
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof BulkUploadDocumentRequest
     */
    'entityType'?: EntityTypeCode;
    /**
     * 
     * @type {DocumentTypeCode}
     * @memberof BulkUploadDocumentRequest
     */
    'documentType'?: DocumentTypeCode;
    /**
     * 
     * @type {Array<number>}
     * @memberof BulkUploadDocumentRequest
     */
    'documentIds'?: Array<number> | null;
}


/**
 * 
 * @export
 * @interface CheckValidIdentForOrganisationRequest
 */
export interface CheckValidIdentForOrganisationRequest {
    /**
     * 
     * @type {string}
     * @memberof CheckValidIdentForOrganisationRequest
     */
    'identValue'?: string | null;
}
/**
 * 
 * @export
 * @interface CheckValidPrefixForOrganisationRequest
 */
export interface CheckValidPrefixForOrganisationRequest {
    /**
     * 
     * @type {PrefixType}
     * @memberof CheckValidPrefixForOrganisationRequest
     */
    'prefixType'?: PrefixType;
    /**
     * 
     * @type {string}
     * @memberof CheckValidPrefixForOrganisationRequest
     */
    'prefix'?: string | null;
}


/**
 * 
 * @export
 * @enum {number}
 */

export const ComparisonOperator = {
    Equals: 0,
    GreaterThan: 1,
    LessThan: 2,
    Contains: 3,
    NotEquals: 4,
    NotNull: 5,
    StartWith: 6,
    EndsWith: 7
} as const;

export type ComparisonOperator = typeof ComparisonOperator[keyof typeof ComparisonOperator];


/**
 * 
 * @export
 * @interface DeleteFeesRequest
 */
export interface DeleteFeesRequest {
    /**
     * 
     * @type {number}
     * @memberof DeleteFeesRequest
     */
    'organisationId'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof DeleteFeesRequest
     */
    'itemIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface DeleteWorkOrderItemsRequest
 */
export interface DeleteWorkOrderItemsRequest {
    /**
     * 
     * @type {number}
     * @memberof DeleteWorkOrderItemsRequest
     */
    'workOrderId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DeleteWorkOrderItemsRequest
     */
    'enterpriseId'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof DeleteWorkOrderItemsRequest
     */
    'itemIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface DetailFailure
 */
export interface DetailFailure {
    /**
     * 
     * @type {number}
     * @memberof DetailFailure
     */
    'ruleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DetailFailure
     */
    'ruleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailFailure
     */
    'ruleKey'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailFailure
     */
    'severity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailFailure
     */
    'message'?: string | null;
}
/**
 * 
 * @export
 * @interface DisposalRecord
 */
export interface DisposalRecord {
    /**
     * 
     * @type {string}
     * @memberof DisposalRecord
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DisposalRecord
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DisposalRecord
     */
    'id'?: string | null;
}
/**
 * 
 * @export
 * @interface Document
 */
export interface Document {
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'createdByProfileId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'modifiedByProfileId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'modifiedDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Document
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'timeStamp'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Document
     */
    'documentId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'documentEntityId'?: string;
    /**
     * 
     * @type {DocumentTypeCode}
     * @memberof Document
     */
    'documentType'?: DocumentTypeCode;
    /**
     * 
     * @type {DocumentSourceType}
     * @memberof Document
     */
    'sourceType'?: DocumentSourceType;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'entityId': string;
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof Document
     */
    'entityType'?: EntityTypeCode;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'location': string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'extension'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'contentType'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Document
     */
    'documentSize'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof Document
     */
    'isPrimary'?: boolean;
}


/**
 * 
 * @export
 * @interface DocumentDto
 */
export interface DocumentDto {
    /**
     * 
     * @type {number}
     * @memberof DocumentDto
     */
    'documentId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    'documentEntityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    'entityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    'documentName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    'documentLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    'contentType'?: string | null;
    /**
     * 
     * @type {DocumentTypeCode}
     * @memberof DocumentDto
     */
    'documentType'?: DocumentTypeCode;
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof DocumentDto
     */
    'entityType'?: EntityTypeCode;
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    'documentBytes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentDto
     */
    'documentSize'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    'createdDate'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentDto
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentDto
     */
    'isPrimary'?: boolean;
}


/**
 * 
 * @export
 * @interface DocumentPagedResult
 */
export interface DocumentPagedResult {
    /**
     * 
     * @type {number}
     * @memberof DocumentPagedResult
     */
    'currentPage': number;
    /**
     * 
     * @type {number}
     * @memberof DocumentPagedResult
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof DocumentPagedResult
     */
    'pageCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DocumentPagedResult
     */
    'rowCount'?: number;
    /**
     * 
     * @type {Array<Document>}
     * @memberof DocumentPagedResult
     */
    'results'?: Array<Document> | null;
}
/**
 * 
 * @export
 * @enum {number}
 */

export const DocumentSourceType = {
    BlobStorage: 0,
    FileShare: 1
} as const;

export type DocumentSourceType = typeof DocumentSourceType[keyof typeof DocumentSourceType];


/**
 * 
 * @export
 * @enum {number}
 */

export const DocumentTypeCode = {
    Avatar: 1,
    Banner: 2,
    Logo: 3,
    Document: 4,
    Image: 5,
    UploadAnimal: 6,
    Template: 7,
    Certificate: 8
} as const;

export type DocumentTypeCode = typeof DocumentTypeCode[keyof typeof DocumentTypeCode];


/**
 * 
 * @export
 * @interface DuplicateFormRequest
 */
export interface DuplicateFormRequest {
    /**
     * 
     * @type {number}
     * @memberof DuplicateFormRequest
     */
    'sourceFormId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DuplicateFormRequest
     */
    'organisationId'?: number;
}
/**
 * 
 * @export
 * @enum {number}
 */

export const EnhancerType = {
    Individual: 0,
    ComplementaryPrevious: 1,
    HideIfPreviousEmpty: 2
} as const;

export type EnhancerType = typeof EnhancerType[keyof typeof EnhancerType];


/**
 * 
 * @export
 * @interface Entity
 */
export interface Entity {
    /**
     * 
     * @type {string}
     * @memberof Entity
     */
    'createdByProfileId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Entity
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Entity
     */
    'modifiedByProfileId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Entity
     */
    'modifiedDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Entity
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Entity
     */
    'timeStamp'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Entity
     */
    'entityId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Entity
     */
    'entityGuid'?: string;
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof Entity
     */
    'entityTypeCode'?: EntityTypeCode;
    /**
     * 
     * @type {RecordStatus}
     * @memberof Entity
     */
    'recordStatus'?: RecordStatus;
    /**
     * 
     * @type {Array<EntityOrganisationAssociation>}
     * @memberof Entity
     */
    'entityOrganisationAssociations'?: Array<EntityOrganisationAssociation> | null;
    /**
     * 
     * @type {Array<EntityTransfer>}
     * @memberof Entity
     */
    'entityTransfers'?: Array<EntityTransfer> | null;
    /**
     * 
     * @type {Array<EntityDetailValue>}
     * @memberof Entity
     */
    'entityDetailValues'?: Array<EntityDetailValue> | null;
}


/**
 * 
 * @export
 * @interface EntityDetail
 */
export interface EntityDetail {
    /**
     * 
     * @type {string}
     * @memberof EntityDetail
     */
    'createdByProfileId'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityDetail
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityDetail
     */
    'modifiedByProfileId'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityDetail
     */
    'modifiedDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EntityDetail
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EntityDetail
     */
    'timeStamp'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EntityDetail
     */
    'entityDetailId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EntityDetail
     */
    'entityDetailEntityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityDetail
     */
    'entityDetailName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityDetail
     */
    'entityDetailDescription'?: string | null;
    /**
     * 
     * @type {EntityDetailType}
     * @memberof EntityDetail
     */
    'entityDetailType'?: EntityDetailType;
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof EntityDetail
     */
    'entityTypeCode'?: EntityTypeCode;
    /**
     * 
     * @type {boolean}
     * @memberof EntityDetail
     */
    'isMandatoryEnable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EntityDetail
     */
    'isDatabaseSearchEnable'?: boolean;
    /**
     * 
     * @type {Array<EntityDetailConfig>}
     * @memberof EntityDetail
     */
    'entityDetailConfigs'?: Array<EntityDetailConfig> | null;
    /**
     * 
     * @type {Array<EntityDetailValue>}
     * @memberof EntityDetail
     */
    'entityDetailValues'?: Array<EntityDetailValue> | null;
}


/**
 * 
 * @export
 * @interface EntityDetailCategoryAssociationDto
 */
export interface EntityDetailCategoryAssociationDto {
    /**
     * 
     * @type {number}
     * @memberof EntityDetailCategoryAssociationDto
     */
    'entityDetailCategoryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EntityDetailCategoryAssociationDto
     */
    'entityDetailId'?: number;
}
/**
 * 
 * @export
 * @interface EntityDetailCategoryDto
 */
export interface EntityDetailCategoryDto {
    /**
     * 
     * @type {number}
     * @memberof EntityDetailCategoryDto
     */
    'entityDetailCategoryId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailCategoryDto
     */
    'entityDetailCategoryName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailCategoryDto
     */
    'entityDetailCategoryDescription'?: string | null;
    /**
     * 
     * @type {Array<EntityDetailCategoryAssociationDto>}
     * @memberof EntityDetailCategoryDto
     */
    'entityDetailCategoryAssociations'?: Array<EntityDetailCategoryAssociationDto> | null;
}
/**
 * 
 * @export
 * @interface EntityDetailConfig
 */
export interface EntityDetailConfig {
    /**
     * 
     * @type {string}
     * @memberof EntityDetailConfig
     */
    'createdByProfileId'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailConfig
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailConfig
     */
    'modifiedByProfileId'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailConfig
     */
    'modifiedDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EntityDetailConfig
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailConfig
     */
    'timeStamp'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EntityDetailConfig
     */
    'entityDetailConfigId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailConfig
     */
    'entityDetailConfigEntityId'?: string;
    /**
     * 
     * @type {number}
     * @memberof EntityDetailConfig
     */
    'entityDetailId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EntityDetailConfig
     */
    'organisationId'?: number | null;
    /**
     * 
     * @type {EntityDetailUnitOfMeasurement}
     * @memberof EntityDetailConfig
     */
    'entityDetailUnitOfMeasurement'?: EntityDetailUnitOfMeasurement;
    /**
     * 
     * @type {number}
     * @memberof EntityDetailConfig
     */
    'entityDetailUnitOfMeasureScale'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailConfig
     */
    'labelText': string;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailConfig
     */
    'detailName': string;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailConfig
     */
    'detailDescription': string;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailConfig
     */
    'placeholder'?: string | null;
    /**
     * 
     * @type {EntityDetailType}
     * @memberof EntityDetailConfig
     */
    'entityDetailType'?: EntityDetailType;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailConfig
     */
    'defaultValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailConfig
     */
    'category'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EntityDetailConfig
     */
    'order'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof EntityDetailConfig
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EntityDetailConfig
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailConfig
     */
    'custom'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EntityDetailConfig
     */
    'isVisible'?: boolean;
    /**
     * 
     * @type {ReactiveEntityValidationRule}
     * @memberof EntityDetailConfig
     */
    'validation'?: ReactiveEntityValidationRule;
    /**
     * 
     * @type {Array<EntityDetailOption>}
     * @memberof EntityDetailConfig
     */
    'options'?: Array<EntityDetailOption> | null;
    /**
     * 
     * @type {boolean}
     * @memberof EntityDetailConfig
     */
    'isAutoCalculatedEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EntityDetailConfig
     */
    'isDatabaseSearchEnable'?: boolean;
    /**
     * 
     * @type {EntityDetail}
     * @memberof EntityDetailConfig
     */
    'entityDetail'?: EntityDetail;
}


/**
 * 
 * @export
 * @interface EntityDetailConfigDto
 */
export interface EntityDetailConfigDto {
    /**
     * 
     * @type {number}
     * @memberof EntityDetailConfigDto
     */
    'entityDetailConfigId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailConfigDto
     */
    'entityDetailConfigEntityId'?: string;
    /**
     * 
     * @type {number}
     * @memberof EntityDetailConfigDto
     */
    'entityDetailId'?: number;
    /**
     * 
     * @type {EntityDetailUnitOfMeasurement}
     * @memberof EntityDetailConfigDto
     */
    'entityDetailUnitOfMeasurement'?: EntityDetailUnitOfMeasurement;
    /**
     * 
     * @type {number}
     * @memberof EntityDetailConfigDto
     */
    'entityDetailUnitOfMeasureScale'?: number;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailConfigDto
     */
    'labelText': string;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailConfigDto
     */
    'detailName': string;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailConfigDto
     */
    'detailDescription': string;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailConfigDto
     */
    'placeholder'?: string | null;
    /**
     * 
     * @type {EntityDetailType}
     * @memberof EntityDetailConfigDto
     */
    'entityDetailType'?: EntityDetailType;
    /**
     * 
     * @type {Array<EntityDetailOption>}
     * @memberof EntityDetailConfigDto
     */
    'options'?: Array<EntityDetailOption> | null;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailConfigDto
     */
    'defaultValue'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EntityDetailConfigDto
     */
    'order'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof EntityDetailConfigDto
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailConfigDto
     */
    'category'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EntityDetailConfigDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof EntityDetailConfigDto
     */
    'organisationId'?: number | null;
    /**
     * 
     * @type {ValidationRuleDto}
     * @memberof EntityDetailConfigDto
     */
    'validation'?: ValidationRuleDto;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailConfigDto
     */
    'custom'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EntityDetailConfigDto
     */
    'isVisible'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EntityDetailConfigDto
     */
    'isMandatoryEnable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EntityDetailConfigDto
     */
    'isDatabaseSearchEnable'?: boolean;
}


/**
 * 
 * @export
 * @interface EntityDetailData
 */
export interface EntityDetailData {
    /**
     * 
     * @type {number}
     * @memberof EntityDetailData
     */
    'entityDetailId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailData
     */
    'entityDetailName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EntityDetailData
     */
    'isVisible'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EntityDetailData
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {EntityDetailConfigDto}
     * @memberof EntityDetailData
     */
    'entityDetailConfig'?: EntityDetailConfigDto;
    /**
     * 
     * @type {boolean}
     * @memberof EntityDetailData
     */
    'isDatabaseSearchEnable'?: boolean;
}
/**
 * 
 * @export
 * @interface EntityDetailDto
 */
export interface EntityDetailDto {
    /**
     * 
     * @type {number}
     * @memberof EntityDetailDto
     */
    'entityDetailId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailDto
     */
    'entityDetailEntityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailDto
     */
    'entityDetailName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailDto
     */
    'entityDetailDescription'?: string | null;
    /**
     * 
     * @type {EntityDetailType}
     * @memberof EntityDetailDto
     */
    'entityDetailType'?: EntityDetailType;
    /**
     * 
     * @type {boolean}
     * @memberof EntityDetailDto
     */
    'isMandatoryEnable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EntityDetailDto
     */
    'isEnhancer'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EntityDetailDto
     */
    'isDatabaseSearchEnable'?: boolean;
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof EntityDetailDto
     */
    'entityTypeCode'?: EntityTypeCode;
    /**
     * 
     * @type {EntityDetailConfigDto}
     * @memberof EntityDetailDto
     */
    'entityDetailConfigs'?: EntityDetailConfigDto;
    /**
     * 
     * @type {Array<EntityDetailValueDto>}
     * @memberof EntityDetailDto
     */
    'entityDetailValues'?: Array<EntityDetailValueDto> | null;
    /**
     * 
     * @type {Array<EntityDetailCategoryDto>}
     * @memberof EntityDetailDto
     */
    'entityDetailCategories'?: Array<EntityDetailCategoryDto> | null;
}


/**
 * 
 * @export
 * @interface EntityDetailDtoPagedResult
 */
export interface EntityDetailDtoPagedResult {
    /**
     * 
     * @type {number}
     * @memberof EntityDetailDtoPagedResult
     */
    'currentPage': number;
    /**
     * 
     * @type {number}
     * @memberof EntityDetailDtoPagedResult
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof EntityDetailDtoPagedResult
     */
    'pageCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof EntityDetailDtoPagedResult
     */
    'rowCount'?: number;
    /**
     * 
     * @type {Array<EntityDetailDto>}
     * @memberof EntityDetailDtoPagedResult
     */
    'results'?: Array<EntityDetailDto> | null;
}
/**
 * 
 * @export
 * @interface EntityDetailEnhancerConfiguration
 */
export interface EntityDetailEnhancerConfiguration {
    /**
     * 
     * @type {number}
     * @memberof EntityDetailEnhancerConfiguration
     */
    'order'?: number;
    /**
     * 
     * @type {number}
     * @memberof EntityDetailEnhancerConfiguration
     */
    'entityDetailId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailEnhancerConfiguration
     */
    'defaultValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailEnhancerConfiguration
     */
    'prefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailEnhancerConfiguration
     */
    'postfix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailEnhancerConfiguration
     */
    'customRegex'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailEnhancerConfiguration
     */
    'customFormat'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailEnhancerConfiguration
     */
    'joinCharacters'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailEnhancerConfiguration
     */
    'previousJoinCharacters'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof EntityDetailEnhancerConfiguration
     */
    'lookupProperties'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof EntityDetailEnhancerConfiguration
     */
    'customMapping'?: Array<string> | null;
    /**
     * 
     * @type {EnhancerType}
     * @memberof EntityDetailEnhancerConfiguration
     */
    'type'?: EnhancerType;
    /**
     * 
     * @type {OutputFormatStyle}
     * @memberof EntityDetailEnhancerConfiguration
     */
    'outputFormatStyle'?: OutputFormatStyle;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailEnhancerConfiguration
     */
    'exampleValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailEnhancerConfiguration
     */
    'conditionalValues'?: string | null;
}


/**
 * 
 * @export
 * @interface EntityDetailEnhancerDto
 */
export interface EntityDetailEnhancerDto {
    /**
     * 
     * @type {string}
     * @memberof EntityDetailEnhancerDto
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailEnhancerDto
     */
    'value': string | null;
}
/**
 * 
 * @export
 * @interface EntityDetailEnum
 */
export interface EntityDetailEnum {
    /**
     * 
     * @type {number}
     * @memberof EntityDetailEnum
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailEnum
     */
    'guid'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailEnum
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EntityDetailEnum
     */
    'order'?: number | null;
    /**
     * 
     * @type {EntityDetailType}
     * @memberof EntityDetailEnum
     */
    'entityDetailType'?: EntityDetailType;
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof EntityDetailEnum
     */
    'entityTypeCode'?: EntityTypeCode;
    /**
     * 
     * @type {boolean}
     * @memberof EntityDetailEnum
     */
    'isDatabaseSearchEnable'?: boolean;
}


/**
 * 
 * @export
 * @interface EntityDetailFilter
 */
export interface EntityDetailFilter {
    /**
     * 
     * @type {string}
     * @memberof EntityDetailFilter
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailFilter
     */
    'description'?: string | null;
    /**
     * 
     * @type {EntityDetailType}
     * @memberof EntityDetailFilter
     */
    'type'?: EntityDetailType;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailFilter
     */
    'group'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailFilter
     */
    'category'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EntityDetailFilter
     */
    'price'?: number | null;
}


/**
 * 
 * @export
 * @interface EntityDetailFilterInput
 */
export interface EntityDetailFilterInput {
    /**
     * 
     * @type {number}
     * @memberof EntityDetailFilterInput
     */
    'entityDetailId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailFilterInput
     */
    'entityDetailName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailFilterInput
     */
    'value'?: string | null;
    /**
     * 
     * @type {ComparisonOperator}
     * @memberof EntityDetailFilterInput
     */
    'operator'?: ComparisonOperator;
    /**
     * 
     * @type {LogicalOperator}
     * @memberof EntityDetailFilterInput
     */
    'logicalOperator'?: LogicalOperator;
}


/**
 * 
 * @export
 * @interface EntityDetailOption
 */
export interface EntityDetailOption {
    /**
     * 
     * @type {string}
     * @memberof EntityDetailOption
     */
    'label'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailOption
     */
    'value'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailOption
     */
    'category'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailOption
     */
    'data'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EntityDetailOption
     */
    'isArchived'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof EntityDetailOption
     */
    'sortOrder'?: number;
}
/**
 * 
 * @export
 * @interface EntityDetailSortInput
 */
export interface EntityDetailSortInput {
    /**
     * 
     * @type {number}
     * @memberof EntityDetailSortInput
     */
    'entityDetailId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailSortInput
     */
    'entityDetailName'?: string | null;
    /**
     * 
     * @type {SortDirectionOrder}
     * @memberof EntityDetailSortInput
     */
    'sortDirection'?: SortDirectionOrder;
}


/**
 * 
 * @export
 * @enum {number}
 */

export const EntityDetailType = {
    Enhancer: 0,
    Text: 1,
    Date: 2,
    Dropdown: 3,
    Radio: 4,
    Checkbox: 5,
    Textarea: 6,
    Number: 7,
    Range: 8,
    Select: 9,
    File: 10,
    Image: 11,
    BreedSelector: 12,
    AnimalSelector: 13,
    MemberSelector: 14,
    AnimalIdent: 15,
    EnterpriseIdent: 16,
    Email: 17,
    Phone: 18,
    Address: 19,
    Prefix: 20,
    Membership: 21,
    Acceptor: 22,
    DisposalRecord: 23,
    AlternateIdents: 24,
    MultipleChoiceCheckbox: 25,
    Attachment: 26,
    MemberLinks: 27,
    Syndicate: 28,
    SexCode: 29,
    Trait: 30
} as const;

export type EntityDetailType = typeof EntityDetailType[keyof typeof EntityDetailType];


/**
 * 
 * @export
 * @enum {number}
 */

export const EntityDetailUnitOfMeasurement = {
    None: 0,
    Kilograms: 1,
    Grams: 2,
    Liters: 3,
    Milliliters: 4,
    Meters: 5,
    Centimeters: 6,
    Millimeters: 7,
    Inches: 8,
    Feet: 9,
    Yards: 10,
    Miles: 11,
    Kilometers: 12,
    Pounds: 13,
    Ounces: 14,
    Gallons: 15,
    Quarts: 16,
    Pints: 17,
    Cups: 18,
    Tablespoons: 19,
    Teaspoons: 20,
    FluidOunces: 21,
    Milligrams: 22,
    Micrograms: 23,
    SquareMeters: 24,
    SquareCentimeters: 25,
    SquareMillimeters: 26,
    SquareInches: 27,
    SquareFeet: 28,
    SquareYards: 29,
    SquareMiles: 30,
    SquareKilometers: 31,
    CubicMeters: 32,
    CubicCentimeters: 33,
    CubicMillimeters: 34,
    CubicInches: 35,
    CubicFeet: 36,
    CubicYards: 37,
    CubicMiles: 38,
    CubicKilometers: 39,
    Degrees: 40,
    Radians: 41,
    Minutes: 42,
    Seconds: 43,
    Hours: 44,
    Days: 45,
    Weeks: 46,
    Months: 47,
    Years: 48,
    Decades: 49,
    Centuries: 50,
    Millenia: 51,
    Kelvin: 52,
    Celsius: 53,
    Fahrenheit: 54
} as const;

export type EntityDetailUnitOfMeasurement = typeof EntityDetailUnitOfMeasurement[keyof typeof EntityDetailUnitOfMeasurement];


/**
 * 
 * @export
 * @interface EntityDetailValue
 */
export interface EntityDetailValue {
    /**
     * 
     * @type {string}
     * @memberof EntityDetailValue
     */
    'createdByProfileId'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailValue
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailValue
     */
    'modifiedByProfileId'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailValue
     */
    'modifiedDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EntityDetailValue
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailValue
     */
    'timeStamp'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EntityDetailValue
     */
    'entityDetailValueId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EntityDetailValue
     */
    'entityId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EntityDetailValue
     */
    'entityDetailId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EntityDetailValue
     */
    'organisationId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailValue
     */
    'value'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof EntityDetailValue
     */
    'recordStatus'?: RecordStatus;
    /**
     * 
     * @type {EntityDetail}
     * @memberof EntityDetailValue
     */
    'entityDetail'?: EntityDetail;
    /**
     * 
     * @type {Entity}
     * @memberof EntityDetailValue
     */
    'entity'?: Entity;
}


/**
 * 
 * @export
 * @interface EntityDetailValueDto
 */
export interface EntityDetailValueDto {
    /**
     * 
     * @type {number}
     * @memberof EntityDetailValueDto
     */
    'entityDetailValueId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EntityDetailValueDto
     */
    'entityId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EntityDetailValueDto
     */
    'entityDetailId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailValueDto
     */
    'value'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EntityDetailValueDto
     */
    'organisationId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailValueDto
     */
    'entityDetailName'?: string | null;
    /**
     * 
     * @type {EntityDetailType}
     * @memberof EntityDetailValueDto
     */
    'entityDetailType'?: EntityDetailType;
    /**
     * 
     * @type {AdditionalInfoDto}
     * @memberof EntityDetailValueDto
     */
    'additionalInfo'?: AdditionalInfoDto;
}


/**
 * 
 * @export
 * @interface EntityDetailsSearchSortFilterRequest
 */
export interface EntityDetailsSearchSortFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof EntityDetailsSearchSortFilterRequest
     */
    'organisationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailsSearchSortFilterRequest
     */
    'searchPhrase'?: string | null;
    /**
     * 
     * @type {SortByRequest}
     * @memberof EntityDetailsSearchSortFilterRequest
     */
    'sortBySettings'?: SortByRequest;
    /**
     * 
     * @type {EntityDetailFilter}
     * @memberof EntityDetailsSearchSortFilterRequest
     */
    'filter'?: EntityDetailFilter;
    /**
     * 
     * @type {PagedEntityDetailsRequest}
     * @memberof EntityDetailsSearchSortFilterRequest
     */
    'pageSettings'?: PagedEntityDetailsRequest;
}
/**
 * 
 * @export
 * @interface EntityDto
 */
export interface EntityDto {
    /**
     * 
     * @type {number}
     * @memberof EntityDto
     */
    'entityId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EntityDto
     */
    'entityGuid'?: string;
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof EntityDto
     */
    'entityTypeCode'?: EntityTypeCode;
    /**
     * 
     * @type {RecordStatus}
     * @memberof EntityDto
     */
    'recordStatus'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof EntityDto
     */
    'isTemporary'?: boolean;
    /**
     * 
     * @type {Array<EntityDetailValueDto>}
     * @memberof EntityDto
     */
    'entityDetailValues'?: Array<EntityDetailValueDto> | null;
    /**
     * 
     * @type {Array<EntityDetailEnhancerDto>}
     * @memberof EntityDto
     */
    'entityDetailEnhancers'?: Array<EntityDetailEnhancerDto> | null;
    /**
     * 
     * @type {Array<DocumentDto>}
     * @memberof EntityDto
     */
    'documents'?: Array<DocumentDto> | null;
}


/**
 * 
 * @export
 * @interface EntityDtoPagedResult
 */
export interface EntityDtoPagedResult {
    /**
     * 
     * @type {number}
     * @memberof EntityDtoPagedResult
     */
    'currentPage': number;
    /**
     * 
     * @type {number}
     * @memberof EntityDtoPagedResult
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof EntityDtoPagedResult
     */
    'pageCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof EntityDtoPagedResult
     */
    'rowCount'?: number;
    /**
     * 
     * @type {Array<EntityDto>}
     * @memberof EntityDtoPagedResult
     */
    'results'?: Array<EntityDto> | null;
}
/**
 * 
 * @export
 * @interface EntityEnhancerDto
 */
export interface EntityEnhancerDto {
    /**
     * 
     * @type {number}
     * @memberof EntityEnhancerDto
     */
    'entityDetailEnhancerId'?: number;
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof EntityEnhancerDto
     */
    'entityTypeCode'?: EntityTypeCode;
    /**
     * 
     * @type {number}
     * @memberof EntityEnhancerDto
     */
    'organisationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EntityEnhancerDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityEnhancerDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityEnhancerDto
     */
    'shortDisplayConfiguration'?: string | null;
    /**
     * 
     * @type {Array<EntityDetailEnhancerConfiguration>}
     * @memberof EntityEnhancerDto
     */
    'configurations'?: Array<EntityDetailEnhancerConfiguration> | null;
    /**
     * 
     * @type {string}
     * @memberof EntityEnhancerDto
     */
    'configurationString'?: string | null;
}


/**
 * 
 * @export
 * @interface EntityFilterByDetailRequest
 */
export interface EntityFilterByDetailRequest {
    /**
     * 
     * @type {Pagination}
     * @memberof EntityFilterByDetailRequest
     */
    'pagination'?: Pagination;
    /**
     * 
     * @type {Array<AnimalDetailFilterInput>}
     * @memberof EntityFilterByDetailRequest
     */
    'filterInputs'?: Array<AnimalDetailFilterInput> | null;
}
/**
 * 
 * @export
 * @interface EntityKeyDto
 */
export interface EntityKeyDto {
    /**
     * 
     * @type {number}
     * @memberof EntityKeyDto
     */
    'entityKeyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EntityKeyDto
     */
    'entityKeyEntityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityKeyDto
     */
    'entityId'?: string;
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof EntityKeyDto
     */
    'entityType'?: EntityTypeCode;
    /**
     * 
     * @type {string}
     * @memberof EntityKeyDto
     */
    'externalKey'?: string | null;
    /**
     * 
     * @type {ExternalSourceType}
     * @memberof EntityKeyDto
     */
    'externalKeySource'?: ExternalSourceType;
}


/**
 * 
 * @export
 * @interface EntityOrganisationAssociation
 */
export interface EntityOrganisationAssociation {
    /**
     * 
     * @type {string}
     * @memberof EntityOrganisationAssociation
     */
    'createdByProfileId'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityOrganisationAssociation
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityOrganisationAssociation
     */
    'modifiedByProfileId'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityOrganisationAssociation
     */
    'modifiedDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EntityOrganisationAssociation
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EntityOrganisationAssociation
     */
    'timeStamp'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EntityOrganisationAssociation
     */
    'entityId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EntityOrganisationAssociation
     */
    'organisationId'?: number;
    /**
     * 
     * @type {Entity}
     * @memberof EntityOrganisationAssociation
     */
    'entity'?: Entity;
    /**
     * 
     * @type {Organisation}
     * @memberof EntityOrganisationAssociation
     */
    'organisation'?: Organisation;
}
/**
 * 
 * @export
 * @interface EntityTransfer
 */
export interface EntityTransfer {
    /**
     * 
     * @type {string}
     * @memberof EntityTransfer
     */
    'createdByProfileId'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityTransfer
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityTransfer
     */
    'modifiedByProfileId'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityTransfer
     */
    'modifiedDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EntityTransfer
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EntityTransfer
     */
    'timeStamp'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EntityTransfer
     */
    'entityTransferId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EntityTransfer
     */
    'entityTransferEntityId'?: string;
    /**
     * 
     * @type {number}
     * @memberof EntityTransfer
     */
    'entityId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EntityTransfer
     */
    'transferFromEntityId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EntityTransfer
     */
    'transferToEntityId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EntityTransfer
     */
    'transferFromDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityTransfer
     */
    'transferToDate'?: string | null;
    /**
     * 
     * @type {TransferType}
     * @memberof EntityTransfer
     */
    'transferType'?: TransferType;
    /**
     * 
     * @type {Entity}
     * @memberof EntityTransfer
     */
    'fromEntity'?: Entity;
    /**
     * 
     * @type {Entity}
     * @memberof EntityTransfer
     */
    'toEntity'?: Entity;
    /**
     * 
     * @type {number}
     * @memberof EntityTransfer
     */
    'transferPercent'?: number;
    /**
     * 
     * @type {Entity}
     * @memberof EntityTransfer
     */
    'entity'?: Entity;
}


/**
 * 
 * @export
 * @interface EntityTransferDto
 */
export interface EntityTransferDto {
    /**
     * 
     * @type {number}
     * @memberof EntityTransferDto
     */
    'entityTransferId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EntityTransferDto
     */
    'entityTransferEntityId'?: string;
    /**
     * 
     * @type {number}
     * @memberof EntityTransferDto
     */
    'transferFromEnterpriseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EntityTransferDto
     */
    'transferToEnterpriseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EntityTransferDto
     */
    'transferPercent'?: number;
    /**
     * 
     * @type {string}
     * @memberof EntityTransferDto
     */
    'transferFromDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityTransferDto
     */
    'transferToDate'?: string | null;
    /**
     * 
     * @type {TransferType}
     * @memberof EntityTransferDto
     */
    'transferType'?: TransferType;
    /**
     * 
     * @type {string}
     * @memberof EntityTransferDto
     */
    'fromEnterpriseName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityTransferDto
     */
    'toEnterpriseName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityTransferDto
     */
    'fromEnterpriseIdent'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityTransferDto
     */
    'toEnterpriseIdent'?: string | null;
}


/**
 * 
 * @export
 * @interface EntityTransferDtoPagedResult
 */
export interface EntityTransferDtoPagedResult {
    /**
     * 
     * @type {number}
     * @memberof EntityTransferDtoPagedResult
     */
    'currentPage': number;
    /**
     * 
     * @type {number}
     * @memberof EntityTransferDtoPagedResult
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof EntityTransferDtoPagedResult
     */
    'pageCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof EntityTransferDtoPagedResult
     */
    'rowCount'?: number;
    /**
     * 
     * @type {Array<EntityTransferDto>}
     * @memberof EntityTransferDtoPagedResult
     */
    'results'?: Array<EntityTransferDto> | null;
}
/**
 * 
 * @export
 * @interface EntityTransferSearchRequest
 */
export interface EntityTransferSearchRequest {
    /**
     * 
     * @type {number}
     * @memberof EntityTransferSearchRequest
     */
    'entityId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EntityTransferSearchRequest
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirectionOrder}
     * @memberof EntityTransferSearchRequest
     */
    'sortDirection'?: SortDirectionOrder;
    /**
     * 
     * @type {Pagination}
     * @memberof EntityTransferSearchRequest
     */
    'pagination'?: Pagination;
}


/**
 * 
 * @export
 * @enum {number}
 */

export const EntityTypeCode = {
    AnimalGroup: 1,
    UserProfile: 2,
    Organisation: 3,
    OrganisationBrand: 4,
    Member: 5,
    Animal: 6,
    WorkOrder: 7,
    Note: 8,
    Person: 18,
    CertificateTemplate: 19,
    Syndicate: 20
} as const;

export type EntityTypeCode = typeof EntityTypeCode[keyof typeof EntityTypeCode];


/**
 * 
 * @export
 * @interface ErrorDetail
 */
export interface ErrorDetail {
    /**
     * 
     * @type {number}
     * @memberof ErrorDetail
     */
    'detailId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ErrorDetail
     */
    'detailName'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ErrorDetail
     */
    'errorMessage'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ErrorDetail
     */
    'severity'?: string | null;
    /**
     * 
     * @type {Array<DetailFailure>}
     * @memberof ErrorDetail
     */
    'failures'?: Array<DetailFailure> | null;
}
/**
 * 
 * @export
 * @interface EvaluateJsonRuleRequest
 */
export interface EvaluateJsonRuleRequest {
    /**
     * 
     * @type {string}
     * @memberof EvaluateJsonRuleRequest
     */
    'ruleJson'?: string | null;
    /**
     * 
     * @type {Entity}
     * @memberof EvaluateJsonRuleRequest
     */
    'testEntity'?: Entity;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof EvaluateJsonRuleRequest
     */
    'testValues'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof EvaluateJsonRuleRequest
     */
    'testStringJson'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EvaluateJsonRuleRequest
     */
    'organisationId'?: number;
}
/**
 * 
 * @export
 * @interface EvaluateRuleByFunctionBatchRequestBody
 */
export interface EvaluateRuleByFunctionBatchRequestBody {
    /**
     * 
     * @type {Array<EvaluateRuleByFunctionTestCaseRequest>}
     * @memberof EvaluateRuleByFunctionBatchRequestBody
     */
    'tests'?: Array<EvaluateRuleByFunctionTestCaseRequest> | null;
}
/**
 * 
 * @export
 * @interface EvaluateRuleByFunctionTestCaseRequest
 */
export interface EvaluateRuleByFunctionTestCaseRequest {
    /**
     * 
     * @type {string}
     * @memberof EvaluateRuleByFunctionTestCaseRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EvaluateRuleByFunctionTestCaseRequest
     */
    'expectedPass'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof EvaluateRuleByFunctionTestCaseRequest
     */
    'validationNamePattern'?: string | null;
    /**
     * 
     * @type {Array<UpsertEntityDetailValueFormRequest>}
     * @memberof EvaluateRuleByFunctionTestCaseRequest
     */
    'entityDetailValues'?: Array<UpsertEntityDetailValueFormRequest> | null;
    /**
     * 
     * @type {number}
     * @memberof EvaluateRuleByFunctionTestCaseRequest
     */
    'entityId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EvaluateRuleByFunctionTestCaseRequest
     */
    'entityGuid'?: string | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof EvaluateRuleByFunctionTestCaseRequest
     */
    'lookupOverrides'?: { [key: string]: string; } | null;
}
/**
 * 
 * @export
 * @enum {number}
 */

export const ExternalSourceType = {
    ILRX: 1
} as const;

export type ExternalSourceType = typeof ExternalSourceType[keyof typeof ExternalSourceType];


/**
 * 
 * @export
 * @interface FeeDto
 */
export interface FeeDto {
    /**
     * 
     * @type {number}
     * @memberof FeeDto
     */
    'feeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FeeDto
     */
    'organisationId': number;
    /**
     * 
     * @type {string}
     * @memberof FeeDto
     */
    'itemDescription': string;
    /**
     * 
     * @type {FeeSection}
     * @memberof FeeDto
     */
    'itemType': FeeSection;
    /**
     * 
     * @type {number}
     * @memberof FeeDto
     */
    'rate': number;
}


/**
 * 
 * @export
 * @enum {number}
 */

export const FeeSection = {
    MembershipType: 1,
    Animal: 2,
    FeeOverride: 3
} as const;

export type FeeSection = typeof FeeSection[keyof typeof FeeSection];


/**
 * 
 * @export
 * @interface FieldCondition
 */
export interface FieldCondition {
    /**
     * 
     * @type {EntityDetailEnum}
     * @memberof FieldCondition
     */
    'fieldEnum'?: EntityDetailEnum;
    /**
     * 
     * @type {LogicalComparisonOperator}
     * @memberof FieldCondition
     */
    'Operator'?: LogicalComparisonOperator;
    /**
     * 
     * @type {LogicalComparisonOperator}
     * @memberof FieldCondition
     */
    'CompareOperator'?: LogicalComparisonOperator;
    /**
     * 
     * @type {any}
     * @memberof FieldCondition
     */
    'value'?: any | null;
    /**
     * 
     * @type {any}
     * @memberof FieldCondition
     */
    'ComparisonLiteral'?: any | null;
    /**
     * 
     * @type {any}
     * @memberof FieldCondition
     */
    'ExpectedValue'?: any | null;
    /**
     * 
     * @type {EntityDetailEnum}
     * @memberof FieldCondition
     */
    'compareToFieldEnum'?: EntityDetailEnum;
    /**
     * 
     * @type {FieldDataType}
     * @memberof FieldCondition
     */
    'dataType'?: FieldDataType;
    /**
     * 
     * @type {boolean}
     * @memberof FieldCondition
     */
    'caseSensitive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FieldCondition
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldCondition
     */
    'customFunction'?: string | null;
}


/**
 * 
 * @export
 * @enum {number}
 */

export const FieldDataType = {
    String: 0,
    Integer: 1,
    Decimal: 2,
    Boolean: 3,
    DateTime: 4,
    Date: 5,
    Time: 6,
    Guid: 7,
    Enum: 8,
    Array: 9,
    Object: 10,
    DateYear: 11
} as const;

export type FieldDataType = typeof FieldDataType[keyof typeof FieldDataType];


/**
 * 
 * @export
 * @enum {number}
 */

export const FileImportFormat = {
    Json: 0,
    Csv: 1
} as const;

export type FileImportFormat = typeof FileImportFormat[keyof typeof FileImportFormat];


/**
 * 
 * @export
 * @interface FinaliseImportBatchRequest
 */
export interface FinaliseImportBatchRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof FinaliseImportBatchRequest
     */
    'importedEntityIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface Form
 */
export interface Form {
    /**
     * 
     * @type {string}
     * @memberof Form
     */
    'createdByProfileId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Form
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Form
     */
    'modifiedByProfileId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Form
     */
    'modifiedDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Form
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Form
     */
    'timeStamp'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Form
     */
    'formId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Form
     */
    'value': string;
    /**
     * 
     * @type {number}
     * @memberof Form
     */
    'screenId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Form
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Form
     */
    'formName'?: string | null;
    /**
     * 
     * @type {Screen}
     * @memberof Form
     */
    'screen'?: Screen;
    /**
     * 
     * @type {Array<FormActionAssociation>}
     * @memberof Form
     */
    'formActionAssociations'?: Array<FormActionAssociation> | null;
}
/**
 * 
 * @export
 * @interface FormActionAssociation
 */
export interface FormActionAssociation {
    /**
     * 
     * @type {string}
     * @memberof FormActionAssociation
     */
    'createdByProfileId'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormActionAssociation
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormActionAssociation
     */
    'modifiedByProfileId'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormActionAssociation
     */
    'modifiedDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FormActionAssociation
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FormActionAssociation
     */
    'timeStamp'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FormActionAssociation
     */
    'formActionAssociationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FormActionAssociation
     */
    'formId': number;
    /**
     * 
     * @type {ActionType}
     * @memberof FormActionAssociation
     */
    'actionType': ActionType;
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof FormActionAssociation
     */
    'entityTypeCode': EntityTypeCode;
    /**
     * 
     * @type {number}
     * @memberof FormActionAssociation
     */
    'organisationId'?: number | null;
    /**
     * 
     * @type {Form}
     * @memberof FormActionAssociation
     */
    'form'?: Form;
    /**
     * 
     * @type {Organisation}
     * @memberof FormActionAssociation
     */
    'organisation'?: Organisation;
}


/**
 * 
 * @export
 * @interface FormActionAssociationDto
 */
export interface FormActionAssociationDto {
    /**
     * 
     * @type {number}
     * @memberof FormActionAssociationDto
     */
    'formId'?: number;
    /**
     * 
     * @type {ActionType}
     * @memberof FormActionAssociationDto
     */
    'actionType'?: ActionType;
    /**
     * 
     * @type {number}
     * @memberof FormActionAssociationDto
     */
    'organisationId'?: number | null;
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof FormActionAssociationDto
     */
    'entityTypeCode'?: EntityTypeCode;
}


/**
 * 
 * @export
 * @interface FormDto
 */
export interface FormDto {
    /**
     * 
     * @type {number}
     * @memberof FormDto
     */
    'formId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FormDto
     */
    'screenId'?: number;
    /**
     * 
     * @type {ActionType}
     * @memberof FormDto
     */
    'actionType'?: ActionType;
    /**
     * 
     * @type {string}
     * @memberof FormDto
     */
    'value'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FormDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FormDto
     */
    'screenName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FormDto
     */
    'formName'?: string | null;
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof FormDto
     */
    'entityType'?: EntityTypeCode;
    /**
     * 
     * @type {boolean}
     * @memberof FormDto
     */
    'isEditable'?: boolean;
}


/**
 * 
 * @export
 * @interface GenerateAnimalRequest
 */
export interface GenerateAnimalRequest {
    /**
     * 
     * @type {number}
     * @memberof GenerateAnimalRequest
     */
    'organisationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof GenerateAnimalRequest
     */
    'number'?: number;
    /**
     * 
     * @type {number}
     * @memberof GenerateAnimalRequest
     */
    'numberOld'?: number;
}
/**
 * 
 * @export
 * @interface GenerateCertificateRequest
 */
export interface GenerateCertificateRequest {
    /**
     * 
     * @type {number}
     * @memberof GenerateCertificateRequest
     */
    'entityId'?: number;
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof GenerateCertificateRequest
     */
    'entityTypeCode'?: EntityTypeCode;
}


/**
 * 
 * @export
 * @interface GenerateMemberRequest
 */
export interface GenerateMemberRequest {
    /**
     * 
     * @type {number}
     * @memberof GenerateMemberRequest
     */
    'organisationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof GenerateMemberRequest
     */
    'number'?: number;
}
/**
 * 
 * @export
 * @interface GenerateRequest
 */
export interface GenerateRequest {
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof GenerateRequest
     */
    'entityTypeCode'?: EntityTypeCode;
    /**
     * 
     * @type {number}
     * @memberof GenerateRequest
     */
    'organisationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof GenerateRequest
     */
    'number'?: number;
    /**
     * 
     * @type {number}
     * @memberof GenerateRequest
     */
    'numberOld'?: number | null;
}


/**
 * 
 * @export
 * @interface GetAnimalProgenyRequest
 */
export interface GetAnimalProgenyRequest {
    /**
     * 
     * @type {Pagination}
     * @memberof GetAnimalProgenyRequest
     */
    'pagination'?: Pagination;
    /**
     * 
     * @type {string}
     * @memberof GetAnimalProgenyRequest
     */
    'entityGuid'?: string;
    /**
     * 
     * @type {Array<EntityDetailFilterInput>}
     * @memberof GetAnimalProgenyRequest
     */
    'filterInputs'?: Array<EntityDetailFilterInput> | null;
    /**
     * 
     * @type {EntityDetailSortInput}
     * @memberof GetAnimalProgenyRequest
     */
    'sortInput'?: EntityDetailSortInput;
    /**
     * 
     * @type {RecordStatus}
     * @memberof GetAnimalProgenyRequest
     */
    'recordStatus'?: RecordStatus;
}


/**
 * 
 * @export
 * @interface GetSettingsByOrganisationAndSettingTypesRequest
 */
export interface GetSettingsByOrganisationAndSettingTypesRequest {
    /**
     * 
     * @type {number}
     * @memberof GetSettingsByOrganisationAndSettingTypesRequest
     */
    'organisationId'?: number;
    /**
     * 
     * @type {Array<OrganisationSettingTypeCode>}
     * @memberof GetSettingsByOrganisationAndSettingTypesRequest
     */
    'settingTypeCodes'?: Array<OrganisationSettingTypeCode> | null;
}
/**
 * 
 * @export
 * @interface IdentGenerationRule
 */
export interface IdentGenerationRule {
    /**
     * 
     * @type {string}
     * @memberof IdentGenerationRule
     */
    'createdByProfileId'?: string;
    /**
     * 
     * @type {string}
     * @memberof IdentGenerationRule
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof IdentGenerationRule
     */
    'modifiedByProfileId'?: string;
    /**
     * 
     * @type {string}
     * @memberof IdentGenerationRule
     */
    'modifiedDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IdentGenerationRule
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IdentGenerationRule
     */
    'timeStamp'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof IdentGenerationRule
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof IdentGenerationRule
     */
    'organisationId'?: number;
    /**
     * 
     * @type {Organisation}
     * @memberof IdentGenerationRule
     */
    'organisation'?: Organisation;
    /**
     * 
     * @type {string}
     * @memberof IdentGenerationRule
     */
    'format': string;
    /**
     * 
     * @type {string}
     * @memberof IdentGenerationRule
     */
    'requiredFieldsJson': string;
    /**
     * 
     * @type {string}
     * @memberof IdentGenerationRule
     */
    'gradeAbbreviationMapJson'?: string | null;
}
/**
 * 
 * @export
 * @interface IdentGenerationRuleDto
 */
export interface IdentGenerationRuleDto {
    /**
     * 
     * @type {number}
     * @memberof IdentGenerationRuleDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof IdentGenerationRuleDto
     */
    'organisationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof IdentGenerationRuleDto
     */
    'format'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentGenerationRuleDto
     */
    'requiredFieldsJson'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentGenerationRuleDto
     */
    'gradeAbbreviationMapJson'?: string | null;
}
/**
 * 
 * @export
 * @interface ImportBatchDto
 */
export interface ImportBatchDto {
    /**
     * 
     * @type {number}
     * @memberof ImportBatchDto
     */
    'importBatchId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ImportBatchDto
     */
    'importBatchGuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportBatchDto
     */
    'importDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportBatchDto
     */
    'documentGuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportBatchDto
     */
    'type'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ImportBatchDto
     */
    'enterpriseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ImportBatchDto
     */
    'numberOfRecords'?: number;
    /**
     * 
     * @type {string}
     * @memberof ImportBatchDto
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {ImportBatchStatus}
     * @memberof ImportBatchDto
     */
    'status'?: ImportBatchStatus;
    /**
     * 
     * @type {number}
     * @memberof ImportBatchDto
     */
    'documentId'?: number | null;
    /**
     * 
     * @type {DocumentTypeCode}
     * @memberof ImportBatchDto
     */
    'documentType'?: DocumentTypeCode;
    /**
     * 
     * @type {string}
     * @memberof ImportBatchDto
     */
    'documentTypeName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportBatchDto
     */
    'enterpriseName'?: string | null;
}


/**
 * 
 * @export
 * @interface ImportBatchDtoPagedResult
 */
export interface ImportBatchDtoPagedResult {
    /**
     * 
     * @type {number}
     * @memberof ImportBatchDtoPagedResult
     */
    'currentPage': number;
    /**
     * 
     * @type {number}
     * @memberof ImportBatchDtoPagedResult
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof ImportBatchDtoPagedResult
     */
    'pageCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ImportBatchDtoPagedResult
     */
    'rowCount'?: number;
    /**
     * 
     * @type {Array<ImportBatchDto>}
     * @memberof ImportBatchDtoPagedResult
     */
    'results'?: Array<ImportBatchDto> | null;
}
/**
 * 
 * @export
 * @interface ImportBatchDtoResult
 */
export interface ImportBatchDtoResult {
    /**
     * 
     * @type {ReturnStatus}
     * @memberof ImportBatchDtoResult
     */
    'status'?: ReturnStatus;
    /**
     * 
     * @type {string}
     * @memberof ImportBatchDtoResult
     */
    'message'?: string | null;
    /**
     * 
     * @type {ImportBatchDto}
     * @memberof ImportBatchDtoResult
     */
    'data'?: ImportBatchDto;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof ImportBatchDtoResult
     */
    'errorDetails'?: Array<ErrorDetail> | null;
}


/**
 * 
 * @export
 * @enum {number}
 */

export const ImportBatchStatus = {
    Pending: 0,
    Validated: 1,
    Complete: 2,
    Cancelled: 3
} as const;

export type ImportBatchStatus = typeof ImportBatchStatus[keyof typeof ImportBatchStatus];


/**
 * 
 * @export
 * @interface ItemCodeDto
 */
export interface ItemCodeDto {
    /**
     * 
     * @type {number}
     * @memberof ItemCodeDto
     */
    'itemCodeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ItemCodeDto
     */
    'orgId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ItemCodeDto
     */
    'itemCodeValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ItemCodeDto
     */
    'externalId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ItemCodeDto
     */
    'grossPrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof ItemCodeDto
     */
    'defaultDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ItemCodeDto
     */
    'status'?: string | null;
}
/**
 * 
 * @export
 * @interface LinkOptionData
 */
export interface LinkOptionData {
    /**
     * 
     * @type {string}
     * @memberof LinkOptionData
     */
    'value'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LinkOptionData
     */
    'linkedEntityDetailId'?: number;
    /**
     * 
     * @type {number}
     * @memberof LinkOptionData
     */
    'linkedEntityId'?: number | null;
}
/**
 * 
 * @export
 * @interface LinkOptionsByEntityDetailsRequest
 */
export interface LinkOptionsByEntityDetailsRequest {
    /**
     * 
     * @type {number}
     * @memberof LinkOptionsByEntityDetailsRequest
     */
    'optionsEntityDetailId'?: number;
    /**
     * 
     * @type {number}
     * @memberof LinkOptionsByEntityDetailsRequest
     */
    'linkedEntityDetailId'?: number;
}
/**
 * 
 * @export
 * @interface LinkOptionsByEntityDetailsResponse
 */
export interface LinkOptionsByEntityDetailsResponse {
    /**
     * 
     * @type {Array<LinkOptionData>}
     * @memberof LinkOptionsByEntityDetailsResponse
     */
    'linkOptions'?: Array<LinkOptionData> | null;
}
/**
 * 
 * @export
 * @enum {number}
 */

export const LogicalComparisonOperator = {
    Equals: 0,
    NotEquals: 1,
    GreaterThan: 2,
    GreaterThanOrEqual: 3,
    LessThan: 4,
    LessThanOrEqual: 5,
    Contains: 6,
    NotContains: 7,
    StartsWith: 8,
    EndsWith: 9,
    IsNull: 10,
    IsNotNull: 11,
    IsEmpty: 12,
    IsNotEmpty: 13,
    In: 14,
    NotIn: 15,
    Between: 16,
    NotBetween: 17,
    Regex: 18,
    Length: 19,
    DateDifference: 20,
    AdjustedCalvingYearEquals: 21,
    EqualsYearLetterCode: 22,
    StartsWithYearLetter: 23,
    EndsWithYearLetter: 24
} as const;

export type LogicalComparisonOperator = typeof LogicalComparisonOperator[keyof typeof LogicalComparisonOperator];


/**
 * 
 * @export
 * @enum {number}
 */

export const LogicalOperator = {
    And: 0,
    Or: 1
} as const;

export type LogicalOperator = typeof LogicalOperator[keyof typeof LogicalOperator];


/**
 * 
 * @export
 * @interface MergeEntityDetailCategoryAssociationRequest
 */
export interface MergeEntityDetailCategoryAssociationRequest {
    /**
     * 
     * @type {number}
     * @memberof MergeEntityDetailCategoryAssociationRequest
     */
    'detailId'?: number;
    /**
     * 
     * @type {Array<number | null>}
     * @memberof MergeEntityDetailCategoryAssociationRequest
     */
    'entityDetailCategoryIds'?: Array<number | null> | null;
}
/**
 * 
 * @export
 * @enum {number}
 */

export const MessageLevel = {
    Info: 0,
    Warning: 1,
    Error: 2,
    Success: 3
} as const;

export type MessageLevel = typeof MessageLevel[keyof typeof MessageLevel];


/**
 * 
 * @export
 * @interface NamedSolrSyncResult
 */
export interface NamedSolrSyncResult {
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof NamedSolrSyncResult
     */
    'entityTypeCode'?: EntityTypeCode;
    /**
     * 
     * @type {SolrSyncResult}
     * @memberof NamedSolrSyncResult
     */
    'result'?: SolrSyncResult;
}


/**
 * 
 * @export
 * @interface NoteDto
 */
export interface NoteDto {
    /**
     * 
     * @type {number}
     * @memberof NoteDto
     */
    'noteId'?: number;
    /**
     * 
     * @type {string}
     * @memberof NoteDto
     */
    'noteEntityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof NoteDto
     */
    'entityGuid'?: string;
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof NoteDto
     */
    'entityType'?: EntityTypeCode;
    /**
     * 
     * @type {boolean}
     * @memberof NoteDto
     */
    'isImportant'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof NoteDto
     */
    'category'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NoteDto
     */
    'subject'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NoteDto
     */
    'body'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof NoteDto
     */
    'entityId'?: number;
    /**
     * 
     * @type {number}
     * @memberof NoteDto
     */
    'enterpriseId'?: number;
    /**
     * 
     * @type {string}
     * @memberof NoteDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NoteDto
     */
    'createdDate'?: string | null;
    /**
     * 
     * @type {Array<DocumentDto>}
     * @memberof NoteDto
     */
    'attachments'?: Array<DocumentDto> | null;
}


/**
 * 
 * @export
 * @interface NoteDtoPagedResult
 */
export interface NoteDtoPagedResult {
    /**
     * 
     * @type {number}
     * @memberof NoteDtoPagedResult
     */
    'currentPage': number;
    /**
     * 
     * @type {number}
     * @memberof NoteDtoPagedResult
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof NoteDtoPagedResult
     */
    'pageCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof NoteDtoPagedResult
     */
    'rowCount'?: number;
    /**
     * 
     * @type {Array<NoteDto>}
     * @memberof NoteDtoPagedResult
     */
    'results'?: Array<NoteDto> | null;
}
/**
 * 
 * @export
 * @interface NoteFilter
 */
export interface NoteFilter {
    /**
     * 
     * @type {string}
     * @memberof NoteFilter
     */
    'subject'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NoteFilter
     */
    'body'?: string | null;
}
/**
 * 
 * @export
 * @interface NoteSearchSortRequest
 */
export interface NoteSearchSortRequest {
    /**
     * 
     * @type {Pagination}
     * @memberof NoteSearchSortRequest
     */
    'pagination'?: Pagination;
    /**
     * 
     * @type {string}
     * @memberof NoteSearchSortRequest
     */
    'entityId'?: string;
    /**
     * 
     * @type {SortByRequest}
     * @memberof NoteSearchSortRequest
     */
    'sortBySettings'?: SortByRequest;
    /**
     * 
     * @type {NoteFilter}
     * @memberof NoteSearchSortRequest
     */
    'filter'?: NoteFilter;
    /**
     * 
     * @type {number}
     * @memberof NoteSearchSortRequest
     */
    'enterpriseId'?: number | null;
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof NoteSearchSortRequest
     */
    'entityType'?: EntityTypeCode;
}


/**
 * 
 * @export
 * @interface Organisation
 */
export interface Organisation {
    /**
     * 
     * @type {string}
     * @memberof Organisation
     */
    'createdByProfileId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Organisation
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Organisation
     */
    'modifiedByProfileId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Organisation
     */
    'modifiedDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Organisation
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Organisation
     */
    'timeStamp'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Organisation
     */
    'organisationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Organisation
     */
    'organisationEntityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Organisation
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Organisation
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Organisation
     */
    'currency'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Organisation
     */
    'country'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Organisation
     */
    'constitutionUrl'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Organisation
     */
    'isFreeMembership'?: boolean;
    /**
     * 
     * @type {Array<OrganisationServiceOption>}
     * @memberof Organisation
     */
    'organisationServiceOptions'?: Array<OrganisationServiceOption> | null;
    /**
     * 
     * @type {IdentGenerationRule}
     * @memberof Organisation
     */
    'identGenerationRule'?: IdentGenerationRule;
    /**
     * 
     * @type {Array<OrganisationSetting>}
     * @memberof Organisation
     */
    'organisationSettings'?: Array<OrganisationSetting> | null;
    /**
     * 
     * @type {Array<EntityOrganisationAssociation>}
     * @memberof Organisation
     */
    'animalOrganisationAssociations'?: Array<EntityOrganisationAssociation> | null;
    /**
     * 
     * @type {Array<Screen>}
     * @memberof Organisation
     */
    'screens'?: Array<Screen> | null;
    /**
     * 
     * @type {Array<FormActionAssociation>}
     * @memberof Organisation
     */
    'formActionAssociations'?: Array<FormActionAssociation> | null;
}
/**
 * 
 * @export
 * @interface OrganisationDto
 */
export interface OrganisationDto {
    /**
     * 
     * @type {number}
     * @memberof OrganisationDto
     */
    'organisationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrganisationDto
     */
    'organisationEntityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganisationDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganisationDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganisationDto
     */
    'currency'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganisationDto
     */
    'country'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OrganisationDto
     */
    'isFreeMembership'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrganisationDto
     */
    'constitutionUrl'?: string | null;
    /**
     * 
     * @type {Array<OrganisationSettingDto>}
     * @memberof OrganisationDto
     */
    'organisationSettings'?: Array<OrganisationSettingDto> | null;
    /**
     * 
     * @type {Array<OrganisationServiceOption>}
     * @memberof OrganisationDto
     */
    'organisationServiceOptions'?: Array<OrganisationServiceOption> | null;
}
/**
 * 
 * @export
 * @interface OrganisationGroupedWorkOrders
 */
export interface OrganisationGroupedWorkOrders {
    /**
     * 
     * @type {number}
     * @memberof OrganisationGroupedWorkOrders
     */
    'organisationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrganisationGroupedWorkOrders
     */
    'organisationName'?: string | null;
    /**
     * 
     * @type {Array<WorkOrderDto>}
     * @memberof OrganisationGroupedWorkOrders
     */
    'workOrders'?: Array<WorkOrderDto> | null;
}
/**
 * 
 * @export
 * @enum {number}
 */

export const OrganisationServiceOption = {
    Dairy: 0,
    Beef: 1,
    Sheep: 2,
    Goat: 3,
    Pig: 4,
    Poultry: 5,
    Other: 6
} as const;

export type OrganisationServiceOption = typeof OrganisationServiceOption[keyof typeof OrganisationServiceOption];


/**
 * 
 * @export
 * @interface OrganisationSetting
 */
export interface OrganisationSetting {
    /**
     * 
     * @type {string}
     * @memberof OrganisationSetting
     */
    'createdByProfileId'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganisationSetting
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganisationSetting
     */
    'modifiedByProfileId'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganisationSetting
     */
    'modifiedDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrganisationSetting
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrganisationSetting
     */
    'timeStamp'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OrganisationSetting
     */
    'organisationSettingId'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrganisationSetting
     */
    'organisationId'?: number;
    /**
     * 
     * @type {OrganisationSettingTypeCode}
     * @memberof OrganisationSetting
     */
    'settingTypeCode': OrganisationSettingTypeCode;
    /**
     * 
     * @type {OrganisationSettingDataType}
     * @memberof OrganisationSetting
     */
    'dataType': OrganisationSettingDataType;
    /**
     * 
     * @type {string}
     * @memberof OrganisationSetting
     */
    'value': string;
    /**
     * 
     * @type {number}
     * @memberof OrganisationSetting
     */
    'order': number;
    /**
     * 
     * @type {number}
     * @memberof OrganisationSetting
     */
    'characterLimit'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof OrganisationSetting
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OrganisationSetting
     */
    'requiredByDefault': boolean;
    /**
     * 
     * @type {Organisation}
     * @memberof OrganisationSetting
     */
    'organisation'?: Organisation;
}


/**
 * 
 * @export
 * @enum {number}
 */

export const OrganisationSettingDataType = {
    Int: 0,
    Decimal: 1,
    Bool: 2,
    DateTime: 3,
    String: 4
} as const;

export type OrganisationSettingDataType = typeof OrganisationSettingDataType[keyof typeof OrganisationSettingDataType];


/**
 * 
 * @export
 * @interface OrganisationSettingDto
 */
export interface OrganisationSettingDto {
    /**
     * 
     * @type {number}
     * @memberof OrganisationSettingDto
     */
    'organisationSettingId'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrganisationSettingDto
     */
    'organisationId'?: number;
    /**
     * 
     * @type {OrganisationSettingTypeCode}
     * @memberof OrganisationSettingDto
     */
    'settingTypeCode'?: OrganisationSettingTypeCode;
    /**
     * 
     * @type {string}
     * @memberof OrganisationSettingDto
     */
    'settingTypeName'?: string | null;
    /**
     * 
     * @type {OrganisationSettingDataType}
     * @memberof OrganisationSettingDto
     */
    'dataType'?: OrganisationSettingDataType;
    /**
     * 
     * @type {string}
     * @memberof OrganisationSettingDto
     */
    'value'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OrganisationSettingDto
     */
    'order'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrganisationSettingDto
     */
    'characterLimit'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof OrganisationSettingDto
     */
    'requiredByDefault'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrganisationSettingDto
     */
    'description'?: string | null;
}


/**
 * 
 * @export
 * @enum {number}
 */

export const OrganisationSettingTypeCode = {
    HerdIdent: 1,
    StudName: 2,
    HerdPrefix: 3,
    MailToAddress: 4,
    FacebookPageLink: 5,
    EnterpriseIdentPrefix: 6,
    EnterpriseIdentSeed: 7,
    EnterpriseIdentAuto: 8,
    MembershipDateSeedDay: 9,
    MembershipDateSeedMonth: 10,
    RenewalPeriod: 11,
    GracePeriod: 12,
    EnterpriseIdentAutoCalcType: 13,
    AnimalForm: 14,
    MemberForm: 15,
    MembershipSettingForm: 16,
    AnimalFormField: 17,
    MemberFormField: 18,
    MembershipSettingFormField: 19,
    AnimalSpecieIds: 20,
    CalvingYearStartMonth: 21,
    CalvingYearEndMonth: 22,
    YearLetterMappings: 23,
    MaxDropNo: 24,
    DamMinAgeAtBirth: 25,
    GestationLength: 26,
    NumberInBirth: 27,
    BirthWeightDecimalPlaces: 28,
    MinBirthWeight: 29,
    MaxBirthWeight: 30,
    SequenceNumber: 31,
    StudbookEnabled: 32,
    DateDisplayFormat: 33,
    BillableEventIdentPrefix: 34,
    MaximumImageOfAnimals: 35,
    EntityIdentSeed: 36,
    MainAnimalSpecieId: 37,
    InvalidRecipDamStatuses: 38,
    InvalidSireStatuses: 40,
    InvalidFosterDamStatuses: 41,
    InvalidDamRegoStatuses: 43,
    InvalidSireRegoStatuses: 44,
    AnimalTypeIgnore: 46,
    BirthWeightFormat: 47,
    MinBirthWeightWarn: 48,
    MaxBirthWeightWarn: 49,
    MultipleBirthGracePeriod: 51,
    InvalidNameCharacters: 52,
    ParentAnimalTypesExcludedFromStatusChecks: 53,
    YearsTattooReusable: 54,
    RecipMinAgeBirth: 56,
    RecipMinAgeImplant: 57,
    LateRegoAge: 58,
    InvalidGradesForCommercialAnimal: 59,
    InvalidGradesWhenRegisteredWithCommercialParent: 60,
    CalvingYearAdj: 61,
    InvalidMembershipTypes: 62,
    InvalidMembershipStatuses: 63,
    RegoStatusesConsideredRegistered: 67,
    RegoStatusesConsideredUnRegistered: 68,
    RegoStatusesConsideredCommercial: 69,
    AgeConsideredInactive: 70,
    InvalidDNACaseIdCharacters: 71,
    RidiculouslyOldDate: 72,
    YearLetterBase: 73,
    GestationLengthErrorRange: 74,
    SireMinAgeConception: 75,
    SireMinAgeConceptionAi: 76,
    DamMinAgeConception: 77,
    GestationLengthErrorRangeEt: 78,
    MatingClashRange: 79,
    MatingClashRangeError: 80,
    SireMaxAgeConception: 81,
    PedigreeGradeRuleFunctionCode: 82
} as const;

export type OrganisationSettingTypeCode = typeof OrganisationSettingTypeCode[keyof typeof OrganisationSettingTypeCode];


/**
 * 
 * @export
 * @enum {number}
 */

export const OutputFormatStyle = {
    None: 0,
    LowerCase: 1,
    SentenceCase: 2,
    TitleCase: 3,
    UpperCase: 4
} as const;

export type OutputFormatStyle = typeof OutputFormatStyle[keyof typeof OutputFormatStyle];


/**
 * 
 * @export
 * @interface PagedEntityDetailsRequest
 */
export interface PagedEntityDetailsRequest {
    /**
     * 
     * @type {number}
     * @memberof PagedEntityDetailsRequest
     */
    'organisationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedEntityDetailsRequest
     */
    'currentPage'?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedEntityDetailsRequest
     */
    'pageSize'?: number;
}
/**
 * 
 * @export
 * @interface PagedWorkOrderRequest
 */
export interface PagedWorkOrderRequest {
    /**
     * 
     * @type {Pagination}
     * @memberof PagedWorkOrderRequest
     */
    'pagination'?: Pagination;
    /**
     * 
     * @type {number}
     * @memberof PagedWorkOrderRequest
     */
    'enterpriseId'?: number;
}
/**
 * 
 * @export
 * @interface Pagination
 */
export interface Pagination {
    /**
     * 
     * @type {number}
     * @memberof Pagination
     */
    'currentPage': number;
    /**
     * 
     * @type {number}
     * @memberof Pagination
     */
    'pageSize': number;
}
/**
 * 
 * @export
 * @enum {number}
 */

export const PaymentStatus = {
    Draft: 1,
    Submitted: 2,
    Paid: 3,
    Expired: 4,
    Cancelled: 5,
    Failed: 6
} as const;

export type PaymentStatus = typeof PaymentStatus[keyof typeof PaymentStatus];


/**
 * 
 * @export
 * @interface PedigreeNodeDto
 */
export interface PedigreeNodeDto {
    /**
     * 
     * @type {string}
     * @memberof PedigreeNodeDto
     */
    'entityGuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PedigreeNodeDto
     */
    'animalName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PedigreeNodeDto
     */
    'ownerName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PedigreeNodeDto
     */
    'ownerIdent'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PedigreeNodeDto
     */
    'ownerIsStudbookOptedOut'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PedigreeNodeDto
     */
    'ownerHerdIdent'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PedigreeNodeDto
     */
    'ownerHerdPrefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PedigreeNodeDto
     */
    'ownerStudName'?: string | null;
    /**
     * 
     * @type {PedigreeNodeDto}
     * @memberof PedigreeNodeDto
     */
    'sire'?: PedigreeNodeDto;
    /**
     * 
     * @type {PedigreeNodeDto}
     * @memberof PedigreeNodeDto
     */
    'dam'?: PedigreeNodeDto;
    /**
     * 
     * @type {DocumentDto}
     * @memberof PedigreeNodeDto
     */
    'profilePicture'?: DocumentDto;
    /**
     * 
     * @type {Array<EntityDetailValueDto>}
     * @memberof PedigreeNodeDto
     */
    'tags'?: Array<EntityDetailValueDto> | null;
    /**
     * 
     * @type {Array<EntityDetailEnhancerDto>}
     * @memberof PedigreeNodeDto
     */
    'entityDetailEnhancers'?: Array<EntityDetailEnhancerDto> | null;
}
/**
 * 
 * @export
 * @enum {number}
 */

export const Permissions = {
    EntityView: 11001,
    EntityModify: 11002,
    AddressView: 12001,
    AddressModify: 12002,
    AnimalSpeciesBreedView: 13001,
    AnimalSpeciesBreedModify: 13002,
    AnimalSpeciesView: 14001,
    AnimalSpeciesModify: 14002,
    EntityDetailCategoryAssociationModify: 15002,
    EntityDetailCategoryView: 16001,
    EntityDetailCategoryModify: 16002,
    EntityDetailConfigView: 17001,
    EntityDetailConfigModify: 17002,
    EntityDetailView: 18001,
    EntityDetailModify: 18002,
    EntityDetailValueView: 19001,
    EntityDetailValueModify: 19002,
    AuthorisedRepresentativeView: 20001,
    AuthorisedRepresentativeModify: 20002,
    CustomFieldView: 21001,
    CustomFieldModify: 21002,
    CustomFormView: 22001,
    CustomFormModify: 22002,
    DocumentView: 23001,
    DocumentModify: 23002,
    EnterpriseView: 24001,
    EnterpriseModify: 24002,
    EnterpriseActionView: 25001,
    EnterpriseActionModify: 25002,
    EnterprisePrefixView: 26001,
    EnterprisePrefixModify: 26002,
    FeeView: 27001,
    FeeModify: 27002,
    InvitationView: 28001,
    InvitationModify: 28002,
    MembershipView: 29001,
    MembershipModify: 29002,
    MembershipApprove: 29003,
    MembershipBenefitView: 30001,
    MembershipBenefitModify: 30002,
    MembershipBenefitAssociationView: 31001,
    MembershipBenefitAssociationModify: 31002,
    MembershipTypeView: 32001,
    MembershipTypeModify: 32002,
    MembershipTypeDurationView: 33001,
    MembershipTypeDurationModify: 33002,
    OrganisationView: 34001,
    OrganisationModify: 34002,
    OrganisationSettingsView: 35001,
    OrganisationSettingsModify: 35002,
    RegistrationView: 36001,
    RegistrationModify: 36002,
    RoleView: 37001,
    RoleModify: 37002,
    RoleUserOrgAssociationView: 38001,
    RoleUserOrgAssociationModify: 38002,
    TimelineView: 39001,
    TimelineModify: 39002,
    UserView: 40001,
    UserModify: 40002,
    WorkOrderView: 41001,
    WorkOrderModify: 41002,
    EntityEnterpriseAssociationView: 42001,
    EntityEnterpriseAssociationModify: 42002,
    EntityDetailEnhancerView: 43001,
    EntityDetailEnhancerModify: 43002
} as const;

export type Permissions = typeof Permissions[keyof typeof Permissions];


/**
 * 
 * @export
 * @enum {number}
 */

export const PrefixType = {
    HerdIdent: 1,
    StudName: 2,
    HerdPrefix: 3,
    StudLetters: 4
} as const;

export type PrefixType = typeof PrefixType[keyof typeof PrefixType];


/**
 * 
 * @export
 * @interface PreviewValueEntityDetailEnhancerRequest
 */
export interface PreviewValueEntityDetailEnhancerRequest {
    /**
     * 
     * @type {string}
     * @memberof PreviewValueEntityDetailEnhancerRequest
     */
    'configurationString'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PreviewValueEntityDetailEnhancerRequest
     */
    'entityDetailEnhancerId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PreviewValueEntityDetailEnhancerRequest
     */
    'entityId'?: number;
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof PreviewValueEntityDetailEnhancerRequest
     */
    'entityTypeCode'?: EntityTypeCode;
}


/**
 * 
 * @export
 * @interface ProblemDetails
 */
export interface ProblemDetails {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'title'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProblemDetails
     */
    'status'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'detail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'instance'?: string | null;
}
/**
 * 
 * @export
 * @interface ProcessInvitationRequest
 */
export interface ProcessInvitationRequest {
    /**
     * 
     * @type {string}
     * @memberof ProcessInvitationRequest
     */
    'invitationGuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProcessInvitationRequest
     */
    'userEmail'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProcessInvitationRequest
     */
    'userId'?: number;
}
/**
 * 
 * @export
 * @interface QuickSearchRequest
 */
export interface QuickSearchRequest {
    /**
     * 
     * @type {Pagination}
     * @memberof QuickSearchRequest
     */
    'pagination'?: Pagination;
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof QuickSearchRequest
     */
    'entityTypeCode'?: EntityTypeCode;
    /**
     * 
     * @type {string}
     * @memberof QuickSearchRequest
     */
    'keywords': string | null;
    /**
     * 
     * @type {EntityDetailSortInput}
     * @memberof QuickSearchRequest
     */
    'sortInput'?: EntityDetailSortInput;
}


/**
 * 
 * @export
 * @interface ReactiveEntityValidationRule
 */
export interface ReactiveEntityValidationRule {
    /**
     * 
     * @type {boolean}
     * @memberof ReactiveEntityValidationRule
     */
    'required'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ReactiveEntityValidationRule
     */
    'min'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReactiveEntityValidationRule
     */
    'max'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReactiveEntityValidationRule
     */
    'regex'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReactiveEntityValidationRule
     */
    'minDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReactiveEntityValidationRule
     */
    'maxDate'?: string | null;
}
/**
 * 
 * @export
 * @enum {number}
 */

export const RecordStatus = {
    Initial: 0,
    Incomplete: 1,
    Unverified: 2,
    Verified: 3
} as const;

export type RecordStatus = typeof RecordStatus[keyof typeof RecordStatus];


/**
 * 
 * @export
 * @interface ResolveTestCaseRequest
 */
export interface ResolveTestCaseRequest {
    /**
     * 
     * @type {number}
     * @memberof ResolveTestCaseRequest
     */
    'ruleId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResolveTestCaseRequest
     */
    'caseIndex'?: number;
    /**
     * 
     * @type {ScreenActionType}
     * @memberof ResolveTestCaseRequest
     */
    'actionType'?: ScreenActionType;
    /**
     * 
     * @type {number}
     * @memberof ResolveTestCaseRequest
     */
    'pinnedEntityId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResolveTestCaseRequest
     */
    'pinnedEntityGuid'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResolveTestCaseRequest
     */
    'useCarrierDataOnly'?: boolean;
}


/**
 * 
 * @export
 * @interface ResolveTestCaseResponse
 */
export interface ResolveTestCaseResponse {
    /**
     * 
     * @type {ResolveTestCaseSource}
     * @memberof ResolveTestCaseResponse
     */
    'source'?: ResolveTestCaseSource;
    /**
     * 
     * @type {number}
     * @memberof ResolveTestCaseResponse
     */
    'entityId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResolveTestCaseResponse
     */
    'entityGuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResolveTestCaseResponse
     */
    'carrierIdent'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResolveTestCaseResponse
     */
    'reason'?: string | null;
    /**
     * 
     * @type {ValidateEntityDryRunRequest}
     * @memberof ResolveTestCaseResponse
     */
    'payload'?: ValidateEntityDryRunRequest;
    /**
     * 
     * @type {boolean}
     * @memberof ResolveTestCaseResponse
     */
    'expectedPassed'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ResolveTestCaseResponse
     */
    'caseName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResolveTestCaseResponse
     */
    'caseFieldOverlayOmitted'?: boolean;
}


/**
 * 
 * @export
 * @enum {number}
 */

export const ResolveTestCaseSource = {
    Pinned: 0,
    UserPinned: 1,
    CreateFlow: 2,
    Real: 3,
    Seed: 4,
    Synth: 5,
    NoData: 6
} as const;

export type ResolveTestCaseSource = typeof ResolveTestCaseSource[keyof typeof ResolveTestCaseSource];


/**
 * 
 * @export
 * @enum {number}
 */

export const ReturnStatus = {
    OK: 0,
    MultipleRecordsUpdated: 1,
    Error: 2,
    NotFound: 3,
    BadRequest: 4,
    Unauthorized: 5,
    Forbidden: 6,
    MethodNotAllowed: 7,
    Conflict: 8
} as const;

export type ReturnStatus = typeof ReturnStatus[keyof typeof ReturnStatus];


/**
 * 
 * @export
 * @interface RoleDto
 */
export interface RoleDto {
    /**
     * 
     * @type {number}
     * @memberof RoleDto
     */
    'roleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    'roleEntityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    'roleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    'roleDescription'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RoleDto
     */
    'isSystemRole'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RoleDto
     */
    'isDefaultRole'?: boolean;
}
/**
 * 
 * @export
 * @interface RolePermissionAssociationDto
 */
export interface RolePermissionAssociationDto {
    /**
     * 
     * @type {number}
     * @memberof RolePermissionAssociationDto
     */
    'roleId'?: number;
    /**
     * 
     * @type {Permissions}
     * @memberof RolePermissionAssociationDto
     */
    'permissionId'?: Permissions;
}


/**
 * 
 * @export
 * @interface RoleUserOrgAssociationDto
 */
export interface RoleUserOrgAssociationDto {
    /**
     * 
     * @type {number}
     * @memberof RoleUserOrgAssociationDto
     */
    'roleUserOrgAssociationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof RoleUserOrgAssociationDto
     */
    'roleUserOrgAssociationEntityId'?: string;
    /**
     * 
     * @type {number}
     * @memberof RoleUserOrgAssociationDto
     */
    'roleId'?: number;
    /**
     * 
     * @type {number}
     * @memberof RoleUserOrgAssociationDto
     */
    'userId'?: number;
    /**
     * 
     * @type {number}
     * @memberof RoleUserOrgAssociationDto
     */
    'organisationId'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RoleUserOrgAssociationDto
     */
    'roleNames'?: Array<string> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof RoleUserOrgAssociationDto
     */
    'roleIds'?: Array<number> | null;
    /**
     * 
     * @type {OrganisationDto}
     * @memberof RoleUserOrgAssociationDto
     */
    'organisation'?: OrganisationDto;
    /**
     * 
     * @type {RoleDto}
     * @memberof RoleUserOrgAssociationDto
     */
    'role'?: RoleDto;
    /**
     * 
     * @type {string}
     * @memberof RoleUserOrgAssociationDto
     */
    'modifiedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof RoleUserOrgAssociationDto
     */
    'modifiedByProfileId'?: string;
}
/**
 * 
 * @export
 * @interface RuleAction
 */
export interface RuleAction {
    /**
     * 
     * @type {RuleActionType}
     * @memberof RuleAction
     */
    'type'?: RuleActionType;
    /**
     * 
     * @type {number}
     * @memberof RuleAction
     */
    'targetFieldId'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RuleAction
     */
    'lookupNames'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof RuleAction
     */
    'staticValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RuleAction
     */
    'value'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RuleAction
     */
    'overwriteExisting'?: boolean | null;
    /**
     * 
     * @type {MessageLevel}
     * @memberof RuleAction
     */
    'level'?: MessageLevel;
    /**
     * 
     * @type {string}
     * @memberof RuleAction
     */
    'messageText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RuleAction
     */
    'description'?: string | null;
    /**
     * 
     * @type {RuleCondition}
     * @memberof RuleAction
     */
    'condition'?: RuleCondition;
}


/**
 * 
 * @export
 * @enum {number}
 */

export const RuleActionType = {
    SetValue: 0,
    SetReadonly: 1,
    SetRequired: 2,
    SetVisible: 3,
    ShowMessage: 4,
    ClearValue: 5
} as const;

export type RuleActionType = typeof RuleActionType[keyof typeof RuleActionType];


/**
 * 
 * @export
 * @interface RuleCondition
 */
export interface RuleCondition {
    /**
     * 
     * @type {LogicalOperator}
     * @memberof RuleCondition
     */
    'operator'?: LogicalOperator;
    /**
     * 
     * @type {Array<RuleCondition>}
     * @memberof RuleCondition
     */
    'conditionGroups'?: Array<RuleCondition> | null;
    /**
     * 
     * @type {Array<FieldCondition>}
     * @memberof RuleCondition
     */
    'conditions'?: Array<FieldCondition> | null;
    /**
     * 
     * @type {boolean}
     * @memberof RuleCondition
     */
    'negate'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RuleCondition
     */
    'description'?: string | null;
}


/**
 * 
 * @export
 * @interface RuleConfigurationDto
 */
export interface RuleConfigurationDto {
    /**
     * 
     * @type {number}
     * @memberof RuleConfigurationDto
     */
    'ruleConfigurationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof RuleConfigurationDto
     */
    'ruleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof RuleConfigurationDto
     */
    'ruleName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RuleConfigurationDto
     */
    'roleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof RuleConfigurationDto
     */
    'roleName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RuleConfigurationDto
     */
    'organisationId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RuleConfigurationDto
     */
    'organisationName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RuleConfigurationDto
     */
    'entityDetailId'?: number;
    /**
     * 
     * @type {string}
     * @memberof RuleConfigurationDto
     */
    'entityDetailName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RuleConfigurationDto
     */
    'entityDetailValue'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RuleConfigurationDto
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RuleConfigurationDto
     */
    'canOverride'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RuleConfigurationDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RuleConfigurationDto
     */
    'ruleJsonString'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RuleConfigurationDto
     */
    'triggerRuleJsonString'?: string | null;
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof RuleConfigurationDto
     */
    'ruleEntityType'?: EntityTypeCode;
}


/**
 * 
 * @export
 * @interface RuleDefinition
 */
export interface RuleDefinition {
    /**
     * 
     * @type {string}
     * @memberof RuleDefinition
     */
    'version'?: string | null;
    /**
     * 
     * @type {RuleCondition}
     * @memberof RuleDefinition
     */
    'rootCondition'?: RuleCondition;
    /**
     * 
     * @type {any}
     * @memberof RuleDefinition
     */
    'rootConditionExpr'?: any | null;
    /**
     * 
     * @type {RuleMetadata}
     * @memberof RuleDefinition
     */
    'metadata'?: RuleMetadata;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof RuleDefinition
     */
    'variables'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {Array<RuleLookup>}
     * @memberof RuleDefinition
     */
    'lookups'?: Array<RuleLookup> | null;
    /**
     * 
     * @type {Array<RuleAction>}
     * @memberof RuleDefinition
     */
    'actions'?: Array<RuleAction> | null;
}
/**
 * 
 * @export
 * @interface RuleDryRunFieldOverrideItem
 */
export interface RuleDryRunFieldOverrideItem {
    /**
     * 
     * @type {number}
     * @memberof RuleDryRunFieldOverrideItem
     */
    'entityDetailId'?: number;
    /**
     * 
     * @type {string}
     * @memberof RuleDryRunFieldOverrideItem
     */
    'entityDetailName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RuleDryRunFieldOverrideItem
     */
    'value'?: string | null;
}
/**
 * 
 * @export
 * @interface RuleDryRunTestOverrideDto
 */
export interface RuleDryRunTestOverrideDto {
    /**
     * 
     * @type {number}
     * @memberof RuleDryRunTestOverrideDto
     */
    'ruleDryRunTestOverrideId'?: number;
    /**
     * 
     * @type {number}
     * @memberof RuleDryRunTestOverrideDto
     */
    'organisationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof RuleDryRunTestOverrideDto
     */
    'ruleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof RuleDryRunTestOverrideDto
     */
    'ruleName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RuleDryRunTestOverrideDto
     */
    'scopeEntityId'?: number;
    /**
     * 
     * @type {Array<RuleDryRunFieldOverrideItem>}
     * @memberof RuleDryRunTestOverrideDto
     */
    'fieldOverrides'?: Array<RuleDryRunFieldOverrideItem> | null;
}
/**
 * 
 * @export
 * @interface RuleDto
 */
export interface RuleDto {
    /**
     * 
     * @type {number}
     * @memberof RuleDto
     */
    'ruleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof RuleDto
     */
    'ruleEntityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RuleDto
     */
    'ruleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RuleDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RuleDto
     */
    'ruleJson'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RuleDto
     */
    'triggerConfigJson'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RuleDto
     */
    'errorMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RuleDto
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof RuleDto
     */
    'modifiedDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof RuleDto
     */
    'createdByUserId'?: number;
    /**
     * 
     * @type {number}
     * @memberof RuleDto
     */
    'modifiedByUserId'?: number;
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof RuleDto
     */
    'ruleEntityType'?: EntityTypeCode;
    /**
     * 
     * @type {boolean}
     * @memberof RuleDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RuleDto
     */
    'canOverride'?: boolean;
    /**
     * 
     * @type {Array<ActionType>}
     * @memberof RuleDto
     */
    'actionTypes'?: Array<ActionType> | null;
    /**
     * 
     * @type {boolean}
     * @memberof RuleDto
     */
    'isPreUpdateCheck'?: boolean;
    /**
     * 
     * @type {Array<AnimalType>}
     * @memberof RuleDto
     */
    'animalType'?: Array<AnimalType> | null;
    /**
     * 
     * @type {Array<RuleConfigurationDto>}
     * @memberof RuleDto
     */
    'roleOverrides'?: Array<RuleConfigurationDto> | null;
}


/**
 * 
 * @export
 * @interface RuleDtoPagedResult
 */
export interface RuleDtoPagedResult {
    /**
     * 
     * @type {number}
     * @memberof RuleDtoPagedResult
     */
    'currentPage': number;
    /**
     * 
     * @type {number}
     * @memberof RuleDtoPagedResult
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof RuleDtoPagedResult
     */
    'pageCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof RuleDtoPagedResult
     */
    'rowCount'?: number;
    /**
     * 
     * @type {Array<RuleDto>}
     * @memberof RuleDtoPagedResult
     */
    'results'?: Array<RuleDto> | null;
}
/**
 * 
 * @export
 * @interface RuleEvaluationBatchResultDto
 */
export interface RuleEvaluationBatchResultDto {
    /**
     * 
     * @type {Array<RuleEvaluationTestCaseResultDto>}
     * @memberof RuleEvaluationBatchResultDto
     */
    'results'?: Array<RuleEvaluationTestCaseResultDto> | null;
    /**
     * 
     * @type {number}
     * @memberof RuleEvaluationBatchResultDto
     */
    'passedAssertions'?: number;
    /**
     * 
     * @type {number}
     * @memberof RuleEvaluationBatchResultDto
     */
    'failedAssertions'?: number;
}
/**
 * 
 * @export
 * @interface RuleEvaluationResultDto
 */
export interface RuleEvaluationResultDto {
    /**
     * 
     * @type {boolean}
     * @memberof RuleEvaluationResultDto
     */
    'isValid'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RuleEvaluationResultDto
     */
    'rulePassed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RuleEvaluationResultDto
     */
    'errorMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RuleEvaluationResultDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RuleEvaluationResultDto
     */
    'evaluationDetails'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof RuleEvaluationResultDto
     */
    'evaluationMetadata'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {Array<ActionInstruction>}
     * @memberof RuleEvaluationResultDto
     */
    'instructions'?: Array<ActionInstruction> | null;
}
/**
 * 
 * @export
 * @interface RuleEvaluationTestCaseResultDto
 */
export interface RuleEvaluationTestCaseResultDto {
    /**
     * 
     * @type {string}
     * @memberof RuleEvaluationTestCaseResultDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RuleEvaluationTestCaseResultDto
     */
    'expectedPass'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof RuleEvaluationTestCaseResultDto
     */
    'rulePassed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RuleEvaluationTestCaseResultDto
     */
    'matchesExpected'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof RuleEvaluationTestCaseResultDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RuleEvaluationTestCaseResultDto
     */
    'errorMessage'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RuleEvaluationTestCaseResultDto
     */
    'isValid'?: boolean;
}
/**
 * 
 * @export
 * @interface RuleExamplesDto
 */
export interface RuleExamplesDto {
    /**
     * 
     * @type {string}
     * @memberof RuleExamplesDto
     */
    'simpleRule'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RuleExamplesDto
     */
    'complexRule'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RuleExamplesDto
     */
    'fieldComparisonRule'?: string | null;
}
/**
 * 
 * @export
 * @interface RuleLookup
 */
export interface RuleLookup {
    /**
     * 
     * @type {string}
     * @memberof RuleLookup
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RuleLookup
     */
    'sourceFieldId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RuleLookup
     */
    'keyPath'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RuleLookup
     */
    'resultField'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RuleLookup
     */
    'fallback'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RuleLookup
     */
    'required'?: boolean;
    /**
     * 
     * @type {any}
     * @memberof RuleLookup
     */
    'staticData'?: any | null;
    /**
     * 
     * @type {string}
     * @memberof RuleLookup
     */
    'ruleLookupType'?: string | null;
}
/**
 * 
 * @export
 * @interface RuleMetadata
 */
export interface RuleMetadata {
    /**
     * 
     * @type {string}
     * @memberof RuleMetadata
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RuleMetadata
     */
    'author'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RuleMetadata
     */
    'createdDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RuleMetadata
     */
    'modifiedDate'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RuleMetadata
     */
    'tags'?: Array<string> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof RuleMetadata
     */
    'itemCodeIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface RuleOutcomeDto
 */
export interface RuleOutcomeDto {
    /**
     * 
     * @type {number}
     * @memberof RuleOutcomeDto
     */
    'ruleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof RuleOutcomeDto
     */
    'ruleName'?: string | null;
    /**
     * 
     * @type {RuleOutcomeStatus}
     * @memberof RuleOutcomeDto
     */
    'status'?: RuleOutcomeStatus;
    /**
     * 
     * @type {string}
     * @memberof RuleOutcomeDto
     */
    'skipReason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RuleOutcomeDto
     */
    'errorMessage'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof RuleOutcomeDto
     */
    'failureDetailIds'?: Array<number> | null;
}


/**
 * 
 * @export
 * @enum {number}
 */

export const RuleOutcomeStatus = {
    Fired: 0,
    Passed: 1,
    Skipped: 2,
    Errored: 3
} as const;

export type RuleOutcomeStatus = typeof RuleOutcomeStatus[keyof typeof RuleOutcomeStatus];


/**
 * 
 * @export
 * @interface RuleTestResultDto
 */
export interface RuleTestResultDto {
    /**
     * 
     * @type {boolean}
     * @memberof RuleTestResultDto
     */
    'isValid'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RuleTestResultDto
     */
    'errorMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RuleTestResultDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RuleTestResultDto
     */
    'rulePassed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RuleTestResultDto
     */
    'evaluationDetails'?: string | null;
}
/**
 * 
 * @export
 * @interface RuleTriggerRequest
 */
export interface RuleTriggerRequest {
    /**
     * 
     * @type {number}
     * @memberof RuleTriggerRequest
     */
    'organisationId'?: number;
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof RuleTriggerRequest
     */
    'entityTypeCode'?: EntityTypeCode;
    /**
     * 
     * @type {ActionType}
     * @memberof RuleTriggerRequest
     */
    'entityAction'?: ActionType;
    /**
     * 
     * @type {Array<number>}
     * @memberof RuleTriggerRequest
     */
    'triggeringDetailIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<UpsertEntityDetailValueFormRequest>}
     * @memberof RuleTriggerRequest
     */
    'formValues'?: Array<UpsertEntityDetailValueFormRequest> | null;
    /**
     * 
     * @type {Entity}
     * @memberof RuleTriggerRequest
     */
    'currentEntity'?: Entity;
}


/**
 * 
 * @export
 * @interface SampleCaseFileDiagnosticDto
 */
export interface SampleCaseFileDiagnosticDto {
    /**
     * 
     * @type {string}
     * @memberof SampleCaseFileDiagnosticDto
     */
    'ruleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SampleCaseFileDiagnosticDto
     */
    'relativePath'?: string | null;
    /**
     * 
     * @type {Array<SampleCaseIssueDto>}
     * @memberof SampleCaseFileDiagnosticDto
     */
    'issues'?: Array<SampleCaseIssueDto> | null;
}
/**
 * 
 * @export
 * @interface SampleCaseIssueDto
 */
export interface SampleCaseIssueDto {
    /**
     * 
     * @type {number}
     * @memberof SampleCaseIssueDto
     */
    'caseIndex'?: number;
    /**
     * 
     * @type {string}
     * @memberof SampleCaseIssueDto
     */
    'caseName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SampleCaseIssueDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SampleCaseIssueDto
     */
    'message'?: string | null;
}
/**
 * 
 * @export
 * @interface SampleCaseSchemaDiagnosticsDto
 */
export interface SampleCaseSchemaDiagnosticsDto {
    /**
     * 
     * @type {string}
     * @memberof SampleCaseSchemaDiagnosticsDto
     */
    'generatedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof SampleCaseSchemaDiagnosticsDto
     */
    'filesScanned'?: number;
    /**
     * 
     * @type {number}
     * @memberof SampleCaseSchemaDiagnosticsDto
     */
    'filesSkippedTrigger'?: number;
    /**
     * 
     * @type {number}
     * @memberof SampleCaseSchemaDiagnosticsDto
     */
    'caseCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof SampleCaseSchemaDiagnosticsDto
     */
    'issueCount'?: number;
    /**
     * 
     * @type {Array<SampleCaseFileDiagnosticDto>}
     * @memberof SampleCaseSchemaDiagnosticsDto
     */
    'files'?: Array<SampleCaseFileDiagnosticDto> | null;
}
/**
 * 
 * @export
 * @interface SampleRuleCaseDto
 */
export interface SampleRuleCaseDto {
    /**
     * 
     * @type {string}
     * @memberof SampleRuleCaseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SampleRuleCaseDto
     */
    'expectedPassed'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof SampleRuleCaseDto
     */
    'entityGuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SampleRuleCaseDto
     */
    'payloadJson'?: string | null;
    /**
     * 
     * @type {Array<SampleRuleCaseFieldDto>}
     * @memberof SampleRuleCaseDto
     */
    'fields'?: Array<SampleRuleCaseFieldDto> | null;
}
/**
 * 
 * @export
 * @interface SampleRuleCaseFieldDto
 */
export interface SampleRuleCaseFieldDto {
    /**
     * 
     * @type {number}
     * @memberof SampleRuleCaseFieldDto
     */
    'entityDetailId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SampleRuleCaseFieldDto
     */
    'entityDetailName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SampleRuleCaseFieldDto
     */
    'value'?: string | null;
}
/**
 * 
 * @export
 * @interface SaveRuleDryRunTestOverrideRequest
 */
export interface SaveRuleDryRunTestOverrideRequest {
    /**
     * 
     * @type {number}
     * @memberof SaveRuleDryRunTestOverrideRequest
     */
    'ruleId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SaveRuleDryRunTestOverrideRequest
     */
    'scopeEntityId'?: number;
    /**
     * 
     * @type {Array<RuleDryRunFieldOverrideItem>}
     * @memberof SaveRuleDryRunTestOverrideRequest
     */
    'fieldOverrides'?: Array<RuleDryRunFieldOverrideItem> | null;
}
/**
 * 
 * @export
 * @interface Screen
 */
export interface Screen {
    /**
     * 
     * @type {string}
     * @memberof Screen
     */
    'createdByProfileId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Screen
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Screen
     */
    'modifiedByProfileId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Screen
     */
    'modifiedDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Screen
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Screen
     */
    'timeStamp'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Screen
     */
    'screenId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Screen
     */
    'screenName': string;
    /**
     * 
     * @type {string}
     * @memberof Screen
     */
    'screenDescription'?: string | null;
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof Screen
     */
    'entityTypeCode': EntityTypeCode;
    /**
     * 
     * @type {number}
     * @memberof Screen
     */
    'organisationId'?: number | null;
    /**
     * 
     * @type {Organisation}
     * @memberof Screen
     */
    'organisation'?: Organisation;
    /**
     * 
     * @type {Array<Form>}
     * @memberof Screen
     */
    'forms'?: Array<Form> | null;
}


/**
 * 
 * @export
 * @enum {number}
 */

export const ScreenActionType = {
    Create: 0,
    Edit: 1,
    Delete: 2
} as const;

export type ScreenActionType = typeof ScreenActionType[keyof typeof ScreenActionType];


/**
 * 
 * @export
 * @interface ScreenDto
 */
export interface ScreenDto {
    /**
     * 
     * @type {number}
     * @memberof ScreenDto
     */
    'screenId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ScreenDto
     */
    'screenName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScreenDto
     */
    'screenDescription'?: string | null;
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof ScreenDto
     */
    'type'?: EntityTypeCode;
    /**
     * 
     * @type {number}
     * @memberof ScreenDto
     */
    'organisationId'?: number;
    /**
     * 
     * @type {Array<FormDto>}
     * @memberof ScreenDto
     */
    'forms'?: Array<FormDto> | null;
}


/**
 * 
 * @export
 * @interface SearchBillableEventsByEntityRequest
 */
export interface SearchBillableEventsByEntityRequest {
    /**
     * 
     * @type {string}
     * @memberof SearchBillableEventsByEntityRequest
     */
    'searchString'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SearchBillableEventsByEntityRequest
     */
    'organisationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchBillableEventsByEntityRequest
     */
    'entityId'?: number;
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof SearchBillableEventsByEntityRequest
     */
    'entityTypeCode'?: EntityTypeCode;
    /**
     * 
     * @type {SortByRequest}
     * @memberof SearchBillableEventsByEntityRequest
     */
    'sortBySettings'?: SortByRequest;
    /**
     * 
     * @type {BillableEventFilter}
     * @memberof SearchBillableEventsByEntityRequest
     */
    'filter'?: BillableEventFilter;
    /**
     * 
     * @type {Pagination}
     * @memberof SearchBillableEventsByEntityRequest
     */
    'pagination'?: Pagination;
}


/**
 * 
 * @export
 * @interface SearchByOrgIdRequest
 */
export interface SearchByOrgIdRequest {
    /**
     * 
     * @type {Pagination}
     * @memberof SearchByOrgIdRequest
     */
    'pagination'?: Pagination;
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof SearchByOrgIdRequest
     */
    'entityTypeCode'?: EntityTypeCode;
    /**
     * 
     * @type {boolean}
     * @memberof SearchByOrgIdRequest
     */
    'isOnlyActive'?: boolean;
    /**
     * 
     * @type {Array<EntityDetailFilterInput>}
     * @memberof SearchByOrgIdRequest
     */
    'filterInputs'?: Array<EntityDetailFilterInput> | null;
    /**
     * 
     * @type {EntityDetailSortInput}
     * @memberof SearchByOrgIdRequest
     */
    'sortInput'?: EntityDetailSortInput;
    /**
     * 
     * @type {boolean}
     * @memberof SearchByOrgIdRequest
     */
    'isStudBook'?: boolean;
    /**
     * 
     * @type {Array<DocumentTypeCode>}
     * @memberof SearchByOrgIdRequest
     */
    'includeDocumentTypes'?: Array<DocumentTypeCode> | null;
    /**
     * 
     * @type {Array<RecordStatus>}
     * @memberof SearchByOrgIdRequest
     */
    'recordStatuses'?: Array<RecordStatus> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchByOrgIdRequest
     */
    'statuses'?: Array<string> | null;
}


/**
 * 
 * @export
 * @interface SearchEntityByDetailRequest
 */
export interface SearchEntityByDetailRequest {
    /**
     * 
     * @type {string}
     * @memberof SearchEntityByDetailRequest
     */
    'searchString'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SearchEntityByDetailRequest
     */
    'organisationId'?: number;
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof SearchEntityByDetailRequest
     */
    'entityTypeCode'?: EntityTypeCode;
    /**
     * 
     * @type {RecordStatus}
     * @memberof SearchEntityByDetailRequest
     */
    'recordStatus'?: RecordStatus;
    /**
     * 
     * @type {SexType}
     * @memberof SearchEntityByDetailRequest
     */
    'sexType'?: SexType;
    /**
     * 
     * @type {Array<SexType>}
     * @memberof SearchEntityByDetailRequest
     */
    'sexTypes'?: Array<SexType> | null;
    /**
     * 
     * @type {Pagination}
     * @memberof SearchEntityByDetailRequest
     */
    'pagination'?: Pagination;
}


/**
 * 
 * @export
 * @interface SearchRuleRequest
 */
export interface SearchRuleRequest {
    /**
     * 
     * @type {Pagination}
     * @memberof SearchRuleRequest
     */
    'pagination'?: Pagination;
    /**
     * 
     * @type {TriggerType}
     * @memberof SearchRuleRequest
     */
    'triggerType'?: TriggerType;
    /**
     * 
     * @type {number}
     * @memberof SearchRuleRequest
     */
    'ruleType'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SearchRuleRequest
     */
    'keyword'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchRuleRequest
     */
    'sortBy'?: string | null;
    /**
     * 
     * @type {SortDirectionOrder}
     * @memberof SearchRuleRequest
     */
    'sortDirection'?: SortDirectionOrder;
}


/**
 * 
 * @export
 * @interface SendSocietyInvitationEmailRequest
 */
export interface SendSocietyInvitationEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof SendSocietyInvitationEmailRequest
     */
    'invitationEmail'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SendSocietyInvitationEmailRequest
     */
    'organisationId'?: number;
}
/**
 * 
 * @export
 * @interface SetVisibleConfigRequest
 */
export interface SetVisibleConfigRequest {
    /**
     * 
     * @type {number}
     * @memberof SetVisibleConfigRequest
     */
    'entityDetailConfigId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SetVisibleConfigRequest
     */
    'isVisible'?: boolean;
}
/**
 * 
 * @export
 * @enum {number}
 */

export const SexType = {
    Male: 1,
    Female: 2,
    DesexedMale: 3,
    Unknown: 4
} as const;

export type SexType = typeof SexType[keyof typeof SexType];


/**
 * 
 * @export
 * @interface SingleUploadDocumentRequest
 */
export interface SingleUploadDocumentRequest {
    /**
     * 
     * @type {number}
     * @memberof SingleUploadDocumentRequest
     */
    'documentId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SingleUploadDocumentRequest
     */
    'entityId'?: string;
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof SingleUploadDocumentRequest
     */
    'entityType'?: EntityTypeCode;
    /**
     * 
     * @type {DocumentTypeCode}
     * @memberof SingleUploadDocumentRequest
     */
    'documentType'?: DocumentTypeCode;
}


/**
 * 
 * @export
 * @interface SolrSyncAllRequest
 */
export interface SolrSyncAllRequest {
    /**
     * 
     * @type {number}
     * @memberof SolrSyncAllRequest
     */
    'organisationId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SolrSyncAllRequest
     */
    'batchSize'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof SolrSyncAllRequest
     */
    'useFileImport'?: boolean | null;
    /**
     * 
     * @type {FileImportFormat}
     * @memberof SolrSyncAllRequest
     */
    'importFormat'?: FileImportFormat;
    /**
     * 
     * @type {Array<RecordStatus>}
     * @memberof SolrSyncAllRequest
     */
    'recordStatuses'?: Array<RecordStatus> | null;
    /**
     * 
     * @type {boolean}
     * @memberof SolrSyncAllRequest
     */
    'clearOldData'?: boolean | null;
}


/**
 * 
 * @export
 * @interface SolrSyncApiRequest
 */
export interface SolrSyncApiRequest {
    /**
     * 
     * @type {number}
     * @memberof SolrSyncApiRequest
     */
    'organisationId'?: number | null;
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof SolrSyncApiRequest
     */
    'entityTypeCode'?: EntityTypeCode;
    /**
     * 
     * @type {number}
     * @memberof SolrSyncApiRequest
     */
    'batchSize'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof SolrSyncApiRequest
     */
    'useFileImport'?: boolean | null;
    /**
     * 
     * @type {FileImportFormat}
     * @memberof SolrSyncApiRequest
     */
    'importFormat'?: FileImportFormat;
    /**
     * 
     * @type {Array<RecordStatus>}
     * @memberof SolrSyncApiRequest
     */
    'recordStatuses'?: Array<RecordStatus> | null;
    /**
     * 
     * @type {boolean}
     * @memberof SolrSyncApiRequest
     */
    'clearOldData'?: boolean | null;
}


/**
 * 
 * @export
 * @interface SolrSyncJob
 */
export interface SolrSyncJob {
    /**
     * 
     * @type {string}
     * @memberof SolrSyncJob
     */
    'jobId'?: string;
    /**
     * 
     * @type {number}
     * @memberof SolrSyncJob
     */
    'organisationId'?: number;
    /**
     * 
     * @type {SolrSyncJobStatus}
     * @memberof SolrSyncJob
     */
    'status'?: SolrSyncJobStatus;
    /**
     * 
     * @type {boolean}
     * @memberof SolrSyncJob
     */
    'isAll'?: boolean;
    /**
     * 
     * @type {Array<EntityTypeCode>}
     * @memberof SolrSyncJob
     */
    'entityTypes'?: Array<EntityTypeCode> | null;
    /**
     * 
     * @type {number}
     * @memberof SolrSyncJob
     */
    'currentEntityIndex'?: number;
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof SolrSyncJob
     */
    'currentEntityType'?: EntityTypeCode;
    /**
     * 
     * @type {string}
     * @memberof SolrSyncJob
     */
    'createdAtUtc'?: string;
    /**
     * 
     * @type {string}
     * @memberof SolrSyncJob
     */
    'startedAtUtc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SolrSyncJob
     */
    'completedAtUtc'?: string | null;
    /**
     * 
     * @type {Array<NamedSolrSyncResult>}
     * @memberof SolrSyncJob
     */
    'results'?: Array<NamedSolrSyncResult> | null;
    /**
     * 
     * @type {string}
     * @memberof SolrSyncJob
     */
    'errorMessage'?: string | null;
}


/**
 * 
 * @export
 * @enum {number}
 */

export const SolrSyncJobStatus = {
    Queued: 0,
    Running: 1,
    Succeeded: 2,
    Failed: 3,
    Cancelled: 4
} as const;

export type SolrSyncJobStatus = typeof SolrSyncJobStatus[keyof typeof SolrSyncJobStatus];


/**
 * 
 * @export
 * @interface SolrSyncResult
 */
export interface SolrSyncResult {
    /**
     * 
     * @type {boolean}
     * @memberof SolrSyncResult
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SolrSyncResult
     */
    'totalEntitiesProcessed'?: number;
    /**
     * 
     * @type {number}
     * @memberof SolrSyncResult
     */
    'totalEntitiesSynced'?: number;
    /**
     * 
     * @type {number}
     * @memberof SolrSyncResult
     */
    'totalErrors'?: number;
    /**
     * 
     * @type {number}
     * @memberof SolrSyncResult
     */
    'oldDataDeleted'?: number;
    /**
     * 
     * @type {string}
     * @memberof SolrSyncResult
     */
    'duration'?: string;
    /**
     * 
     * @type {string}
     * @memberof SolrSyncResult
     */
    'message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SolrSyncResult
     */
    'errorMessage'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SolrSyncResult
     */
    'warnings'?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof SolrSyncResult
     */
    'cacheHits'?: number;
    /**
     * 
     * @type {number}
     * @memberof SolrSyncResult
     */
    'cacheMisses'?: number;
}
/**
 * 
 * @export
 * @interface SortByRequest
 */
export interface SortByRequest {
    /**
     * 
     * @type {string}
     * @memberof SortByRequest
     */
    'sortBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SortByRequest
     */
    'sortDirection'?: string | null;
}
/**
 * 
 * @export
 * @enum {number}
 */

export const SortDirectionOrder = {
    Ascending: 0,
    Descending: 1
} as const;

export type SortDirectionOrder = typeof SortDirectionOrder[keyof typeof SortDirectionOrder];


/**
 * 
 * @export
 * @interface SubmitWorkOrdersRequest
 */
export interface SubmitWorkOrdersRequest {
    /**
     * 
     * @type {number}
     * @memberof SubmitWorkOrdersRequest
     */
    'enterpriseId'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof SubmitWorkOrdersRequest
     */
    'workOrderIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface TestJsonRuleRequest
 */
export interface TestJsonRuleRequest {
    /**
     * 
     * @type {string}
     * @memberof TestJsonRuleRequest
     */
    'ruleJson'?: string | null;
}
/**
 * 
 * @export
 * @interface TestRuleDefinitionRequest
 */
export interface TestRuleDefinitionRequest {
    /**
     * 
     * @type {RuleDefinition}
     * @memberof TestRuleDefinitionRequest
     */
    'ruleDefinition': RuleDefinition;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof TestRuleDefinitionRequest
     */
    'testData'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {number}
     * @memberof TestRuleDefinitionRequest
     */
    'organizationId'?: number | null;
}
/**
 * 
 * @export
 * @interface TimelineDto
 */
export interface TimelineDto {
    /**
     * 
     * @type {string}
     * @memberof TimelineDto
     */
    'eventHeading'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TimelineDto
     */
    'eventDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TimelineDto
     */
    'capturedByUserName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TimelineDto
     */
    'timelineDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimelineDto
     */
    'capturedByUserProfileEntityId'?: string;
}
/**
 * 
 * @export
 * @enum {number}
 */

export const TransferType = {
    Lease: 1,
    Sale: 2,
    Transfer: 3
} as const;

export type TransferType = typeof TransferType[keyof typeof TransferType];


/**
 * 
 * @export
 * @enum {number}
 */

export const TriggerType = {
    FieldChange: 0,
    EntityAction: 1
} as const;

export type TriggerType = typeof TriggerType[keyof typeof TriggerType];


/**
 * 
 * @export
 * @interface UpdateMemberMembershipRequest
 */
export interface UpdateMemberMembershipRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateMemberMembershipRequest
     */
    'entityId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateMemberMembershipRequest
     */
    'membershipValue'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateMemberMembershipRequest
     */
    'annualPrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateMemberMembershipRequest
     */
    'effectiveDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMemberMembershipRequest
     */
    'expiryDate'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateMemberMembershipRequest
     */
    'isAutoRenewal'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateMemberMembershipRequest
     */
    'isAppendWorkOrder'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateOrganisationRequest
 */
export interface UpdateOrganisationRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateOrganisationRequest
     */
    'organisationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganisationRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganisationRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganisationRequest
     */
    'currency'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganisationRequest
     */
    'country'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateOrganisationRequest
     */
    'isFreeMembership'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganisationRequest
     */
    'constitutionUrl'?: string | null;
    /**
     * 
     * @type {Array<OrganisationServiceOption>}
     * @memberof UpdateOrganisationRequest
     */
    'organisationServiceOptions'?: Array<OrganisationServiceOption> | null;
}
/**
 * 
 * @export
 * @interface UpdateRoleRequest
 */
export interface UpdateRoleRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateRoleRequest
     */
    'roleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateRoleRequest
     */
    'roleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateRoleRequest
     */
    'roleDescription'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRoleRequest
     */
    'isSystemRole'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRoleRequest
     */
    'isDefaultRole'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateRuleConfigurationRequest
 */
export interface UpdateRuleConfigurationRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateRuleConfigurationRequest
     */
    'roleId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRuleConfigurationRequest
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateRuleConfigurationRequest
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRuleConfigurationRequest
     */
    'canOverride'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateRuleRequest
 */
export interface UpdateRuleRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateRuleRequest
     */
    'ruleId': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateRuleRequest
     */
    'ruleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateRuleRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateRuleRequest
     */
    'ruleJson'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateRuleRequest
     */
    'triggerConfigJson'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateRuleRequest
     */
    'errorMessage'?: string | null;
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof UpdateRuleRequest
     */
    'ruleEntityType'?: EntityTypeCode;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRuleRequest
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRuleRequest
     */
    'canOverride'?: boolean;
    /**
     * 
     * @type {Array<ActionType>}
     * @memberof UpdateRuleRequest
     */
    'actionTypes'?: Array<ActionType> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRuleRequest
     */
    'isPreUpdateCheck'?: boolean | null;
    /**
     * 
     * @type {Array<AnimalType>}
     * @memberof UpdateRuleRequest
     */
    'animalType'?: Array<AnimalType> | null;
    /**
     * 
     * @type {Array<UpdateRuleConfigurationRequest>}
     * @memberof UpdateRuleRequest
     */
    'roleOverrides'?: Array<UpdateRuleConfigurationRequest> | null;
}


/**
 * 
 * @export
 * @interface UpsertAnimalSpecies
 */
export interface UpsertAnimalSpecies {
    /**
     * 
     * @type {number}
     * @memberof UpsertAnimalSpecies
     */
    'animalSpeciesId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpsertAnimalSpecies
     */
    'animalSpeciesEntityId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertAnimalSpecies
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertAnimalSpecies
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface UpsertAnimalSpeciesBreed
 */
export interface UpsertAnimalSpeciesBreed {
    /**
     * 
     * @type {number}
     * @memberof UpsertAnimalSpeciesBreed
     */
    'animalSpeciesBreedId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpsertAnimalSpeciesBreed
     */
    'animalSpeciesBreedEntityId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertAnimalSpeciesBreed
     */
    'animalSpeciesId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpsertAnimalSpeciesBreed
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertAnimalSpeciesBreed
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface UpsertAnimalSpeciesBreedRequest
 */
export interface UpsertAnimalSpeciesBreedRequest {
    /**
     * 
     * @type {Array<UpsertAnimalSpeciesBreed>}
     * @memberof UpsertAnimalSpeciesBreedRequest
     */
    'animalSpeciesBreeds'?: Array<UpsertAnimalSpeciesBreed> | null;
}
/**
 * 
 * @export
 * @interface UpsertAnimalSpeciesRequest
 */
export interface UpsertAnimalSpeciesRequest {
    /**
     * 
     * @type {Array<UpsertAnimalSpecies>}
     * @memberof UpsertAnimalSpeciesRequest
     */
    'animalSpecies'?: Array<UpsertAnimalSpecies> | null;
}
/**
 * 
 * @export
 * @interface UpsertAuthorisedRepresentativesRequest
 */
export interface UpsertAuthorisedRepresentativesRequest {
    /**
     * 
     * @type {number}
     * @memberof UpsertAuthorisedRepresentativesRequest
     */
    'authorisedRepresentativeId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertAuthorisedRepresentativesRequest
     */
    'enterpriseId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpsertAuthorisedRepresentativesRequest
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof UpsertAuthorisedRepresentativesRequest
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertAuthorisedRepresentativesRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface UpsertDetailValuesRequest
 */
export interface UpsertDetailValuesRequest {
    /**
     * 
     * @type {Array<UpsertEntityDetailValueFormData>}
     * @memberof UpsertDetailValuesRequest
     */
    'detailValues'?: Array<UpsertEntityDetailValueFormData> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertDetailValuesRequest
     */
    'isOverridePreviousValue'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertDetailValuesRequest
     */
    'isCleanOldLinkEntityDetailId'?: boolean;
}
/**
 * 
 * @export
 * @interface UpsertEntityDetailCategoryRequest
 */
export interface UpsertEntityDetailCategoryRequest {
    /**
     * 
     * @type {number}
     * @memberof UpsertEntityDetailCategoryRequest
     */
    'entityDetailCategoryId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertEntityDetailCategoryRequest
     */
    'entityDetailCategoryName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertEntityDetailCategoryRequest
     */
    'entityDetailCategoryDescription'?: string | null;
}
/**
 * 
 * @export
 * @interface UpsertEntityDetailConfigRequest
 */
export interface UpsertEntityDetailConfigRequest {
    /**
     * 
     * @type {number}
     * @memberof UpsertEntityDetailConfigRequest
     */
    'entityDetailConfigId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertEntityDetailConfigRequest
     */
    'entityDetailConfigEntityId'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpsertEntityDetailConfigRequest
     */
    'entityDetailId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpsertEntityDetailConfigRequest
     */
    'category'?: string | null;
    /**
     * 
     * @type {EntityDetailUnitOfMeasurement}
     * @memberof UpsertEntityDetailConfigRequest
     */
    'entityDetailUnitOfMeasurement'?: EntityDetailUnitOfMeasurement;
    /**
     * 
     * @type {number}
     * @memberof UpsertEntityDetailConfigRequest
     */
    'entityDetailUnitOfMeasureScale'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertEntityDetailConfigRequest
     */
    'labelText': string;
    /**
     * 
     * @type {string}
     * @memberof UpsertEntityDetailConfigRequest
     */
    'detailName': string;
    /**
     * 
     * @type {string}
     * @memberof UpsertEntityDetailConfigRequest
     */
    'detailDescription': string;
    /**
     * 
     * @type {string}
     * @memberof UpsertEntityDetailConfigRequest
     */
    'placeholder'?: string | null;
    /**
     * 
     * @type {EntityDetailType}
     * @memberof UpsertEntityDetailConfigRequest
     */
    'entityDetailType'?: EntityDetailType;
    /**
     * 
     * @type {Array<EntityDetailOption>}
     * @memberof UpsertEntityDetailConfigRequest
     */
    'options'?: Array<EntityDetailOption> | null;
    /**
     * 
     * @type {ValidationRequest}
     * @memberof UpsertEntityDetailConfigRequest
     */
    'validation'?: ValidationRequest;
    /**
     * 
     * @type {string}
     * @memberof UpsertEntityDetailConfigRequest
     */
    'defaultValue'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertEntityDetailConfigRequest
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpsertEntityDetailConfigRequest
     */
    'order'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertEntityDetailConfigRequest
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpsertEntityDetailConfigRequest
     */
    'custom'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertEntityDetailConfigRequest
     */
    'isVisible'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertEntityDetailConfigRequest
     */
    'isAutoCalculatedEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertEntityDetailConfigRequest
     */
    'isDatabaseSearchEnable'?: boolean;
}


/**
 * 
 * @export
 * @interface UpsertEntityDetailEnhancerRequest
 */
export interface UpsertEntityDetailEnhancerRequest {
    /**
     * 
     * @type {number}
     * @memberof UpsertEntityDetailEnhancerRequest
     */
    'entityDetailEnhancerId'?: number | null;
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof UpsertEntityDetailEnhancerRequest
     */
    'entityTypeCode'?: EntityTypeCode;
    /**
     * 
     * @type {string}
     * @memberof UpsertEntityDetailEnhancerRequest
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertEntityDetailEnhancerRequest
     */
    'description': string | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertEntityDetailEnhancerRequest
     */
    'configurationString': string | null;
}


/**
 * 
 * @export
 * @interface UpsertEntityDetailRequest
 */
export interface UpsertEntityDetailRequest {
    /**
     * 
     * @type {number}
     * @memberof UpsertEntityDetailRequest
     */
    'entityDetailId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertEntityDetailRequest
     */
    'entityId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertEntityDetailRequest
     */
    'entityDetailName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertEntityDetailRequest
     */
    'entityDetailDescription'?: string | null;
    /**
     * 
     * @type {EntityDetailType}
     * @memberof UpsertEntityDetailRequest
     */
    'entityDetailType'?: EntityDetailType;
}


/**
 * 
 * @export
 * @interface UpsertEntityDetailValue
 */
export interface UpsertEntityDetailValue {
    /**
     * 
     * @type {number}
     * @memberof UpsertEntityDetailValue
     */
    'entityDetailValueId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertEntityDetailValue
     */
    'entityDetailId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpsertEntityDetailValue
     */
    'value'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertEntityDetailValue
     */
    'isAppendNewRecord'?: boolean;
}
/**
 * 
 * @export
 * @interface UpsertEntityDetailValueFormData
 */
export interface UpsertEntityDetailValueFormData {
    /**
     * 
     * @type {number}
     * @memberof UpsertEntityDetailValueFormData
     */
    'entityDetailValueId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertEntityDetailValueFormData
     */
    'entityDetailId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpsertEntityDetailValueFormData
     */
    'entityId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpsertEntityDetailValueFormData
     */
    'value'?: string | null;
}
/**
 * 
 * @export
 * @interface UpsertEntityDetailValueFormRequest
 */
export interface UpsertEntityDetailValueFormRequest {
    /**
     * 
     * @type {number}
     * @memberof UpsertEntityDetailValueFormRequest
     */
    'entityDetailValueId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertEntityDetailValueFormRequest
     */
    'entityDetailId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpsertEntityDetailValueFormRequest
     */
    'entityDetailName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertEntityDetailValueFormRequest
     */
    'value'?: string | null;
}
/**
 * 
 * @export
 * @interface UpsertEntityDetailValueRequest
 */
export interface UpsertEntityDetailValueRequest {
    /**
     * 
     * @type {number}
     * @memberof UpsertEntityDetailValueRequest
     */
    'entityId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpsertEntityDetailValueRequest
     */
    'organisationId'?: number | null;
    /**
     * 
     * @type {Array<UpsertEntityDetailValue>}
     * @memberof UpsertEntityDetailValueRequest
     */
    'entityDetailValues'?: Array<UpsertEntityDetailValue> | null;
}
/**
 * 
 * @export
 * @interface UpsertEntityKeyRequest
 */
export interface UpsertEntityKeyRequest {
    /**
     * 
     * @type {string}
     * @memberof UpsertEntityKeyRequest
     */
    'entityKeyEntityId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertEntityKeyRequest
     */
    'entityId': string;
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof UpsertEntityKeyRequest
     */
    'entityType': EntityTypeCode;
    /**
     * 
     * @type {string}
     * @memberof UpsertEntityKeyRequest
     */
    'externalKey'?: string | null;
    /**
     * 
     * @type {ExternalSourceType}
     * @memberof UpsertEntityKeyRequest
     */
    'externalKeySource'?: ExternalSourceType;
}


/**
 * 
 * @export
 * @interface UpsertEntityRequest
 */
export interface UpsertEntityRequest {
    /**
     * 
     * @type {number}
     * @memberof UpsertEntityRequest
     */
    'entityId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertEntityRequest
     */
    'organisationId'?: number;
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof UpsertEntityRequest
     */
    'entityTypeCode'?: EntityTypeCode;
    /**
     * 
     * @type {Array<UpsertEntityDetailValueFormRequest>}
     * @memberof UpsertEntityRequest
     */
    'entityDetailValues'?: Array<UpsertEntityDetailValueFormRequest> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertEntityRequest
     */
    'isDraft'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertEntityRequest
     */
    'isConfirmed'?: boolean;
    /**
     * 
     * @type {Array<AcknowledgedWarningRequest>}
     * @memberof UpsertEntityRequest
     */
    'acknowledgedWarnings'?: Array<AcknowledgedWarningRequest> | null;
}


/**
 * 
 * @export
 * @interface UpsertEntityTransferRequest
 */
export interface UpsertEntityTransferRequest {
    /**
     * 
     * @type {number}
     * @memberof UpsertEntityTransferRequest
     */
    'entityTransferId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertEntityTransferRequest
     */
    'transferToEntityId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpsertEntityTransferRequest
     * @deprecated
     */
    'transferToEnterpriseId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpsertEntityTransferRequest
     */
    'transferFromDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertEntityTransferRequest
     */
    'transferToDate'?: string | null;
    /**
     * 
     * @type {TransferType}
     * @memberof UpsertEntityTransferRequest
     */
    'transferType'?: TransferType;
    /**
     * 
     * @type {number}
     * @memberof UpsertEntityTransferRequest
     */
    'entityId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertEntityTransferRequest
     */
    'isBillable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpsertEntityTransferRequest
     */
    'transferPercent'?: number;
}


/**
 * 
 * @export
 * @interface UpsertEntityTransfersRequest
 */
export interface UpsertEntityTransfersRequest {
    /**
     * 
     * @type {Array<UpsertEntityTransferRequest>}
     * @memberof UpsertEntityTransfersRequest
     */
    'transfers': Array<UpsertEntityTransferRequest> | null;
}
/**
 * 
 * @export
 * @interface UpsertEntityWithDetailRequest
 */
export interface UpsertEntityWithDetailRequest {
    /**
     * 
     * @type {number}
     * @memberof UpsertEntityWithDetailRequest
     */
    'entityId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertEntityWithDetailRequest
     */
    'organisationId'?: number;
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof UpsertEntityWithDetailRequest
     */
    'entityTypeCode'?: EntityTypeCode;
    /**
     * 
     * @type {Array<UpsertEntityDetailValueFormRequest>}
     * @memberof UpsertEntityWithDetailRequest
     */
    'entityDetailValues'?: Array<UpsertEntityDetailValueFormRequest> | null;
}


/**
 * 
 * @export
 * @interface UpsertFormActionAssociationRequest
 */
export interface UpsertFormActionAssociationRequest {
    /**
     * 
     * @type {number}
     * @memberof UpsertFormActionAssociationRequest
     */
    'formId': number;
    /**
     * 
     * @type {ActionType}
     * @memberof UpsertFormActionAssociationRequest
     */
    'actionType': ActionType;
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof UpsertFormActionAssociationRequest
     */
    'entityTypeCode': EntityTypeCode;
    /**
     * 
     * @type {number}
     * @memberof UpsertFormActionAssociationRequest
     */
    'organisationId': number;
}


/**
 * 
 * @export
 * @interface UpsertFormRequest
 */
export interface UpsertFormRequest {
    /**
     * 
     * @type {number}
     * @memberof UpsertFormRequest
     */
    'formId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertFormRequest
     */
    'value'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertFormRequest
     */
    'screenId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertFormRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertFormRequest
     */
    'formName'?: string | null;
}
/**
 * 
 * @export
 * @interface UpsertIdentGenerationRuleRequest
 */
export interface UpsertIdentGenerationRuleRequest {
    /**
     * 
     * @type {number}
     * @memberof UpsertIdentGenerationRuleRequest
     */
    'id'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertIdentGenerationRuleRequest
     */
    'organisationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpsertIdentGenerationRuleRequest
     */
    'format'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertIdentGenerationRuleRequest
     */
    'requiredFieldsJson'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertIdentGenerationRuleRequest
     */
    'gradeAbbreviationMapJson'?: string | null;
}
/**
 * 
 * @export
 * @interface UpsertImportBatchRequest
 */
export interface UpsertImportBatchRequest {
    /**
     * 
     * @type {string}
     * @memberof UpsertImportBatchRequest
     */
    'importBatchGuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertImportBatchRequest
     */
    'type'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertImportBatchRequest
     */
    'enterpriseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpsertImportBatchRequest
     */
    'numberOfRecords'?: number;
    /**
     * 
     * @type {ImportBatchStatus}
     * @memberof UpsertImportBatchRequest
     */
    'status'?: ImportBatchStatus;
    /**
     * 
     * @type {string}
     * @memberof UpsertImportBatchRequest
     */
    'documentId'?: string | null;
}


/**
 * 
 * @export
 * @interface UpsertItemCodeRequest
 */
export interface UpsertItemCodeRequest {
    /**
     * 
     * @type {number}
     * @memberof UpsertItemCodeRequest
     */
    'itemCodeId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertItemCodeRequest
     */
    'orgId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpsertItemCodeRequest
     */
    'itemCodeValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertItemCodeRequest
     */
    'externalId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertItemCodeRequest
     */
    'grossPrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpsertItemCodeRequest
     */
    'defaultDescription'?: string | null;
}
/**
 * 
 * @export
 * @interface UpsertNoteRequest
 */
export interface UpsertNoteRequest {
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof UpsertNoteRequest
     */
    'entityType'?: EntityTypeCode;
    /**
     * 
     * @type {string}
     * @memberof UpsertNoteRequest
     */
    'noteEntityId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertNoteRequest
     */
    'isImportant'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpsertNoteRequest
     */
    'entityId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertNoteRequest
     */
    'subject': string;
    /**
     * 
     * @type {string}
     * @memberof UpsertNoteRequest
     */
    'body'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertNoteRequest
     */
    'enterpriseId'?: number;
}


/**
 * 
 * @export
 * @interface UpsertOrganisationSettingsRequest
 */
export interface UpsertOrganisationSettingsRequest {
    /**
     * 
     * @type {number}
     * @memberof UpsertOrganisationSettingsRequest
     */
    'organisationSettingId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertOrganisationSettingsRequest
     */
    'organisationId': number;
    /**
     * 
     * @type {OrganisationSettingTypeCode}
     * @memberof UpsertOrganisationSettingsRequest
     */
    'settingTypeCode'?: OrganisationSettingTypeCode;
    /**
     * 
     * @type {OrganisationSettingDataType}
     * @memberof UpsertOrganisationSettingsRequest
     */
    'dataType'?: OrganisationSettingDataType;
    /**
     * 
     * @type {string}
     * @memberof UpsertOrganisationSettingsRequest
     */
    'value'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertOrganisationSettingsRequest
     */
    'order': number;
    /**
     * 
     * @type {number}
     * @memberof UpsertOrganisationSettingsRequest
     */
    'characterLimit'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertOrganisationSettingsRequest
     */
    'requiredByDefault': boolean;
}


/**
 * 
 * @export
 * @interface UpsertRolePermissionAssociationRequest
 */
export interface UpsertRolePermissionAssociationRequest {
    /**
     * 
     * @type {number}
     * @memberof UpsertRolePermissionAssociationRequest
     */
    'roleId'?: number;
    /**
     * 
     * @type {Array<Permissions>}
     * @memberof UpsertRolePermissionAssociationRequest
     */
    'rolePermissions': Array<Permissions> | null;
}
/**
 * 
 * @export
 * @interface UpsertRoleUserOrgAssociationRequest
 */
export interface UpsertRoleUserOrgAssociationRequest {
    /**
     * 
     * @type {number}
     * @memberof UpsertRoleUserOrgAssociationRequest
     */
    'userId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpsertRoleUserOrgAssociationRequest
     */
    'organisationId'?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpsertRoleUserOrgAssociationRequest
     */
    'roleIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface UpsertRuleConfigurationRequest
 */
export interface UpsertRuleConfigurationRequest {
    /**
     * 
     * @type {number}
     * @memberof UpsertRuleConfigurationRequest
     */
    'ruleConfigurationId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertRuleConfigurationRequest
     */
    'ruleId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpsertRuleConfigurationRequest
     */
    'roleId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpsertRuleConfigurationRequest
     */
    'organisationId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertRuleConfigurationRequest
     */
    'entityDetailId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpsertRuleConfigurationRequest
     */
    'entityDetailValue'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertRuleConfigurationRequest
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertRuleConfigurationRequest
     */
    'canOverride'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpsertRuleConfigurationRequest
     */
    'message'?: string | null;
}
/**
 * 
 * @export
 * @interface UpsertScreenRequest
 */
export interface UpsertScreenRequest {
    /**
     * 
     * @type {number}
     * @memberof UpsertScreenRequest
     */
    'screenId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertScreenRequest
     */
    'screenName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertScreenRequest
     */
    'screenDescription'?: string | null;
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof UpsertScreenRequest
     */
    'type'?: EntityTypeCode;
    /**
     * 
     * @type {number}
     * @memberof UpsertScreenRequest
     */
    'organisationId'?: number | null;
    /**
     * 
     * @type {Array<UpsertFormRequest>}
     * @memberof UpsertScreenRequest
     */
    'forms'?: Array<UpsertFormRequest> | null;
}


/**
 * 
 * @export
 * @interface UpsertUserConfigRequest
 */
export interface UpsertUserConfigRequest {
    /**
     * 
     * @type {number}
     * @memberof UpsertUserConfigRequest
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpsertUserConfigRequest
     */
    'config'?: string | null;
}
/**
 * 
 * @export
 * @interface UserConfigDto
 */
export interface UserConfigDto {
    /**
     * 
     * @type {number}
     * @memberof UserConfigDto
     */
    'userConfigId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserConfigDto
     */
    'userId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserConfigDto
     */
    'enterpriseId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UserConfigDto
     */
    'config'?: string | null;
}
/**
 * 
 * @export
 * @interface UserProfileDto
 */
export interface UserProfileDto {
    /**
     * 
     * @type {string}
     * @memberof UserProfileDto
     */
    'userProfileEntityId'?: string;
    /**
     * 
     * @type {number}
     * @memberof UserProfileDto
     */
    'userId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UserProfileDto
     */
    'isEulaAccepted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserProfileDto
     */
    'eulaAcceptedDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserProfileDto
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserProfileDto
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserProfileDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserProfileDto
     */
    'preferredName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserProfileDto
     */
    'communicationPreferences'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserProfileDto
     */
    'isReceiveNotifications'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserProfileDto
     */
    'dateOfBirth'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileDto
     */
    'displayName'?: string | null;
}
/**
 * 
 * @export
 * @interface UserProfileDtoPagedResult
 */
export interface UserProfileDtoPagedResult {
    /**
     * 
     * @type {number}
     * @memberof UserProfileDtoPagedResult
     */
    'currentPage': number;
    /**
     * 
     * @type {number}
     * @memberof UserProfileDtoPagedResult
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof UserProfileDtoPagedResult
     */
    'pageCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserProfileDtoPagedResult
     */
    'rowCount'?: number;
    /**
     * 
     * @type {Array<UserProfileDto>}
     * @memberof UserProfileDtoPagedResult
     */
    'results'?: Array<UserProfileDto> | null;
}
/**
 * 
 * @export
 * @interface UserRoleAssignment
 */
export interface UserRoleAssignment {
    /**
     * 
     * @type {number}
     * @memberof UserRoleAssignment
     */
    'userId'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof UserRoleAssignment
     */
    'roleIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface ValidateEntityDryRunFailure
 */
export interface ValidateEntityDryRunFailure {
    /**
     * 
     * @type {number}
     * @memberof ValidateEntityDryRunFailure
     */
    'detailId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ValidateEntityDryRunFailure
     */
    'detailName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ValidateEntityDryRunFailure
     */
    'message'?: string | null;
}
/**
 * 
 * @export
 * @interface ValidateEntityDryRunRequest
 */
export interface ValidateEntityDryRunRequest {
    /**
     * 
     * @type {number}
     * @memberof ValidateEntityDryRunRequest
     */
    'entityId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ValidateEntityDryRunRequest
     */
    'entityGuid'?: string | null;
    /**
     * 
     * @type {EntityTypeCode}
     * @memberof ValidateEntityDryRunRequest
     */
    'entityTypeCode'?: EntityTypeCode;
    /**
     * 
     * @type {ScreenActionType}
     * @memberof ValidateEntityDryRunRequest
     */
    'actionType'?: ScreenActionType;
    /**
     * 
     * @type {Array<UpsertEntityDetailValueFormRequest>}
     * @memberof ValidateEntityDryRunRequest
     */
    'entityDetailValues'?: Array<UpsertEntityDetailValueFormRequest> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ValidateEntityDryRunRequest
     */
    'ruleNames'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ValidateEntityDryRunRequest
     */
    'applySavedTestOverrides'?: boolean;
}


/**
 * 
 * @export
 * @interface ValidateEntityDryRunResponse
 */
export interface ValidateEntityDryRunResponse {
    /**
     * 
     * @type {number}
     * @memberof ValidateEntityDryRunResponse
     */
    'entityId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ValidateEntityDryRunResponse
     */
    'entityGuid'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ValidateEntityDryRunResponse
     */
    'organisationId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ValidateEntityDryRunResponse
     */
    'isValid'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ValidateEntityDryRunResponse
     */
    'failureCount'?: number;
    /**
     * 
     * @type {Array<ValidateEntityDryRunFailure>}
     * @memberof ValidateEntityDryRunResponse
     */
    'failures'?: Array<ValidateEntityDryRunFailure> | null;
    /**
     * 
     * @type {Array<RuleOutcomeDto>}
     * @memberof ValidateEntityDryRunResponse
     */
    'ruleOutcomes'?: Array<RuleOutcomeDto> | null;
    /**
     * 
     * @type {Array<ValidationFailureDto>}
     * @memberof ValidateEntityDryRunResponse
     */
    'structuredFailures'?: Array<ValidationFailureDto> | null;
}
/**
 * 
 * @export
 * @interface ValidationFailureDto
 */
export interface ValidationFailureDto {
    /**
     * 
     * @type {number}
     * @memberof ValidationFailureDto
     */
    'ruleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ValidationFailureDto
     */
    'ruleName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ValidationFailureDto
     */
    'entityDetailId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ValidationFailureDto
     */
    'entityDetailName'?: string | null;
    /**
     * 
     * @type {ValidationSeverity}
     * @memberof ValidationFailureDto
     */
    'severity'?: ValidationSeverity;
    /**
     * 
     * @type {string}
     * @memberof ValidationFailureDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ValidationFailureDto
     */
    'ruleKey'?: string | null;
}


/**
 * 
 * @export
 * @interface ValidationRequest
 */
export interface ValidationRequest {
    /**
     * 
     * @type {boolean}
     * @memberof ValidationRequest
     */
    'isRequired'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ValidationRequest
     */
    'min'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ValidationRequest
     */
    'max'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ValidationRequest
     */
    'regex'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ValidationRequest
     */
    'minDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ValidationRequest
     */
    'maxDate'?: string | null;
}
/**
 * 
 * @export
 * @interface ValidationRuleDto
 */
export interface ValidationRuleDto {
    /**
     * 
     * @type {boolean}
     * @memberof ValidationRuleDto
     */
    'required'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ValidationRuleDto
     */
    'min'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ValidationRuleDto
     */
    'max'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ValidationRuleDto
     */
    'regex'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ValidationRuleDto
     */
    'minDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ValidationRuleDto
     */
    'maxDate'?: string | null;
}
/**
 * 
 * @export
 * @enum {number}
 */

export const ValidationSeverity = {
    Error: 0,
    Warning: 1
} as const;

export type ValidationSeverity = typeof ValidationSeverity[keyof typeof ValidationSeverity];


/**
 * 
 * @export
 * @interface WorkOrderDto
 */
export interface WorkOrderDto {
    /**
     * 
     * @type {number}
     * @memberof WorkOrderDto
     */
    'workOrderId'?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkOrderDto
     */
    'organisationName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkOrderDto
     */
    'organisationEntityId'?: string;
    /**
     * 
     * @type {PaymentStatus}
     * @memberof WorkOrderDto
     */
    'status'?: PaymentStatus;
    /**
     * 
     * @type {string}
     * @memberof WorkOrderDto
     */
    'issueDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkOrderDto
     */
    'paymentDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WorkOrderDto
     */
    'total'?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkOrderDto
     */
    'invoiceNumber'?: string | null;
    /**
     * 
     * @type {Array<WorkOrderItemDto>}
     * @memberof WorkOrderDto
     */
    'items'?: Array<WorkOrderItemDto> | null;
}


/**
 * 
 * @export
 * @interface WorkOrderDtoPagedResult
 */
export interface WorkOrderDtoPagedResult {
    /**
     * 
     * @type {number}
     * @memberof WorkOrderDtoPagedResult
     */
    'currentPage': number;
    /**
     * 
     * @type {number}
     * @memberof WorkOrderDtoPagedResult
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof WorkOrderDtoPagedResult
     */
    'pageCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkOrderDtoPagedResult
     */
    'rowCount'?: number;
    /**
     * 
     * @type {Array<WorkOrderDto>}
     * @memberof WorkOrderDtoPagedResult
     */
    'results'?: Array<WorkOrderDto> | null;
}
/**
 * 
 * @export
 * @interface WorkOrderFilter
 */
export interface WorkOrderFilter {
    /**
     * 
     * @type {string}
     * @memberof WorkOrderFilter
     */
    'organisationName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkOrderFilter
     */
    'type'?: string | null;
    /**
     * 
     * @type {PaymentStatus}
     * @memberof WorkOrderFilter
     */
    'status'?: PaymentStatus;
    /**
     * 
     * @type {string}
     * @memberof WorkOrderFilter
     */
    'issueDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkOrderFilter
     */
    'paymentDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkOrderFilter
     */
    'invoiceNumber'?: string | null;
}


/**
 * 
 * @export
 * @interface WorkOrderItemDto
 */
export interface WorkOrderItemDto {
    /**
     * 
     * @type {number}
     * @memberof WorkOrderItemDto
     */
    'workOrderItemId'?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkOrderItemDto
     */
    'itemDescription': string;
    /**
     * 
     * @type {string}
     * @memberof WorkOrderItemDto
     */
    'itemEntityId': string;
    /**
     * 
     * @type {FeeSection}
     * @memberof WorkOrderItemDto
     */
    'itemType': FeeSection;
    /**
     * 
     * @type {string}
     * @memberof WorkOrderItemDto
     */
    'itemTypeEntityId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WorkOrderItemDto
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof WorkOrderItemDto
     */
    'feeId': number;
    /**
     * 
     * @type {FeeDto}
     * @memberof WorkOrderItemDto
     */
    'fee'?: FeeDto;
}


/**
 * 
 * @export
 * @interface WorkOrderSearchSortFilterRequest
 */
export interface WorkOrderSearchSortFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof WorkOrderSearchSortFilterRequest
     */
    'enterpriseId'?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkOrderSearchSortFilterRequest
     */
    'searchPhrase'?: string | null;
    /**
     * 
     * @type {SortByRequest}
     * @memberof WorkOrderSearchSortFilterRequest
     */
    'sortBySettings'?: SortByRequest;
    /**
     * 
     * @type {WorkOrderFilter}
     * @memberof WorkOrderSearchSortFilterRequest
     */
    'filter'?: WorkOrderFilter;
    /**
     * 
     * @type {PagedWorkOrderRequest}
     * @memberof WorkOrderSearchSortFilterRequest
     */
    'pageSettings'?: PagedWorkOrderRequest;
}

/**
 * AnimalSpeciesApi - axios parameter creator
 * @export
 */
export const AnimalSpeciesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnimalSpeciesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/AnimalSpecies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertAnimalSpeciesRequest} [upsertAnimalSpeciesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnimalSpeciesPost: async (upsertAnimalSpeciesRequest?: UpsertAnimalSpeciesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/AnimalSpecies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertAnimalSpeciesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnimalSpeciesApi - functional programming interface
 * @export
 */
export const AnimalSpeciesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnimalSpeciesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnimalSpeciesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AnimalSpeciesDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnimalSpeciesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnimalSpeciesApi.apiAnimalSpeciesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertAnimalSpeciesRequest} [upsertAnimalSpeciesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnimalSpeciesPost(upsertAnimalSpeciesRequest?: UpsertAnimalSpeciesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AnimalSpeciesDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnimalSpeciesPost(upsertAnimalSpeciesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnimalSpeciesApi.apiAnimalSpeciesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AnimalSpeciesApi - factory interface
 * @export
 */
export const AnimalSpeciesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnimalSpeciesApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnimalSpeciesGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<AnimalSpeciesDto>> {
            return localVarFp.apiAnimalSpeciesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertAnimalSpeciesRequest} [upsertAnimalSpeciesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnimalSpeciesPost(upsertAnimalSpeciesRequest?: UpsertAnimalSpeciesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AnimalSpeciesDto>> {
            return localVarFp.apiAnimalSpeciesPost(upsertAnimalSpeciesRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AnimalSpeciesApi - object-oriented interface
 * @export
 * @class AnimalSpeciesApi
 * @extends {BaseAPI}
 */
export class AnimalSpeciesApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnimalSpeciesApi
     */
    public apiAnimalSpeciesGet(options?: RawAxiosRequestConfig) {
        return AnimalSpeciesApiFp(this.configuration).apiAnimalSpeciesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpsertAnimalSpeciesRequest} [upsertAnimalSpeciesRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnimalSpeciesApi
     */
    public apiAnimalSpeciesPost(upsertAnimalSpeciesRequest?: UpsertAnimalSpeciesRequest, options?: RawAxiosRequestConfig) {
        return AnimalSpeciesApiFp(this.configuration).apiAnimalSpeciesPost(upsertAnimalSpeciesRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AnimalSpeciesBreedApi - axios parameter creator
 * @export
 */
export const AnimalSpeciesBreedApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnimalSpeciesBreedGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/AnimalSpeciesBreed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertAnimalSpeciesBreedRequest} [upsertAnimalSpeciesBreedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnimalSpeciesBreedPost: async (upsertAnimalSpeciesBreedRequest?: UpsertAnimalSpeciesBreedRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/AnimalSpeciesBreed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertAnimalSpeciesBreedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnimalSpeciesBreedApi - functional programming interface
 * @export
 */
export const AnimalSpeciesBreedApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnimalSpeciesBreedApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnimalSpeciesBreedGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AnimalSpeciesBreedDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnimalSpeciesBreedGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnimalSpeciesBreedApi.apiAnimalSpeciesBreedGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertAnimalSpeciesBreedRequest} [upsertAnimalSpeciesBreedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAnimalSpeciesBreedPost(upsertAnimalSpeciesBreedRequest?: UpsertAnimalSpeciesBreedRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AnimalSpeciesBreedDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAnimalSpeciesBreedPost(upsertAnimalSpeciesBreedRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnimalSpeciesBreedApi.apiAnimalSpeciesBreedPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AnimalSpeciesBreedApi - factory interface
 * @export
 */
export const AnimalSpeciesBreedApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnimalSpeciesBreedApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnimalSpeciesBreedGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<AnimalSpeciesBreedDto>> {
            return localVarFp.apiAnimalSpeciesBreedGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertAnimalSpeciesBreedRequest} [upsertAnimalSpeciesBreedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAnimalSpeciesBreedPost(upsertAnimalSpeciesBreedRequest?: UpsertAnimalSpeciesBreedRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AnimalSpeciesBreedDto>> {
            return localVarFp.apiAnimalSpeciesBreedPost(upsertAnimalSpeciesBreedRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AnimalSpeciesBreedApi - object-oriented interface
 * @export
 * @class AnimalSpeciesBreedApi
 * @extends {BaseAPI}
 */
export class AnimalSpeciesBreedApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnimalSpeciesBreedApi
     */
    public apiAnimalSpeciesBreedGet(options?: RawAxiosRequestConfig) {
        return AnimalSpeciesBreedApiFp(this.configuration).apiAnimalSpeciesBreedGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpsertAnimalSpeciesBreedRequest} [upsertAnimalSpeciesBreedRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnimalSpeciesBreedApi
     */
    public apiAnimalSpeciesBreedPost(upsertAnimalSpeciesBreedRequest?: UpsertAnimalSpeciesBreedRequest, options?: RawAxiosRequestConfig) {
        return AnimalSpeciesBreedApiFp(this.configuration).apiAnimalSpeciesBreedPost(upsertAnimalSpeciesBreedRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthCheckGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthHealthGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthPingGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/ping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthStatusGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Auth/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthCheckGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthCheckGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthCheckGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthHealthGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthHealthGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthHealthGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthPingGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthPingGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthPingGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthStatusGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthStatusGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiAuthStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthCheckGet(options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiAuthCheckGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthHealthGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiAuthHealthGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthPingGet(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiAuthPingGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthStatusGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiAuthStatusGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiAuthCheckGet(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthCheckGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiAuthHealthGet(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthHealthGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiAuthPingGet(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthPingGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiAuthStatusGet(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiAuthStatusGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthorisedRepresentativeApi - axios parameter creator
 * @export
 */
export const AuthorisedRepresentativeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthorisedRepresentativeBulkDelete: async (requestBody?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/AuthorisedRepresentative/Bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<UpsertAuthorisedRepresentativesRequest>} [upsertAuthorisedRepresentativesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthorisedRepresentativeBulkPost: async (upsertAuthorisedRepresentativesRequest?: Array<UpsertAuthorisedRepresentativesRequest>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/AuthorisedRepresentative/Bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertAuthorisedRepresentativesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [authorisedRepresentativeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthorisedRepresentativeDelete: async (authorisedRepresentativeId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/AuthorisedRepresentative`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorisedRepresentativeId !== undefined) {
                localVarQueryParameter['authorisedRepresentativeId'] = authorisedRepresentativeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [authorisedRepresentativeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthorisedRepresentativeGet: async (authorisedRepresentativeId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/AuthorisedRepresentative`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (authorisedRepresentativeId !== undefined) {
                localVarQueryParameter['authorisedRepresentativeId'] = authorisedRepresentativeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [enterpriseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthorisedRepresentativeGetAuthorisedRepresentativesByEnterpriseIdGet: async (enterpriseId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/AuthorisedRepresentative/GetAuthorisedRepresentativesByEnterpriseId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (enterpriseId !== undefined) {
                localVarQueryParameter['enterpriseId'] = enterpriseId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthorisedRepresentativeApi - functional programming interface
 * @export
 */
export const AuthorisedRepresentativeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthorisedRepresentativeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthorisedRepresentativeBulkDelete(requestBody?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthorisedRepresentativeBulkDelete(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthorisedRepresentativeApi.apiAuthorisedRepresentativeBulkDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<UpsertAuthorisedRepresentativesRequest>} [upsertAuthorisedRepresentativesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthorisedRepresentativeBulkPost(upsertAuthorisedRepresentativesRequest?: Array<UpsertAuthorisedRepresentativesRequest>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuthorisedRepresentativeDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthorisedRepresentativeBulkPost(upsertAuthorisedRepresentativesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthorisedRepresentativeApi.apiAuthorisedRepresentativeBulkPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [authorisedRepresentativeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthorisedRepresentativeDelete(authorisedRepresentativeId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthorisedRepresentativeDelete(authorisedRepresentativeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthorisedRepresentativeApi.apiAuthorisedRepresentativeDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [authorisedRepresentativeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthorisedRepresentativeGet(authorisedRepresentativeId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthorisedRepresentativeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthorisedRepresentativeGet(authorisedRepresentativeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthorisedRepresentativeApi.apiAuthorisedRepresentativeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [enterpriseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthorisedRepresentativeGetAuthorisedRepresentativesByEnterpriseIdGet(enterpriseId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuthorisedRepresentativeDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthorisedRepresentativeGetAuthorisedRepresentativesByEnterpriseIdGet(enterpriseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthorisedRepresentativeApi.apiAuthorisedRepresentativeGetAuthorisedRepresentativesByEnterpriseIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthorisedRepresentativeApi - factory interface
 * @export
 */
export const AuthorisedRepresentativeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthorisedRepresentativeApiFp(configuration)
    return {
        /**
         * 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthorisedRepresentativeBulkDelete(requestBody?: Array<number>, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiAuthorisedRepresentativeBulkDelete(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<UpsertAuthorisedRepresentativesRequest>} [upsertAuthorisedRepresentativesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthorisedRepresentativeBulkPost(upsertAuthorisedRepresentativesRequest?: Array<UpsertAuthorisedRepresentativesRequest>, options?: RawAxiosRequestConfig): AxiosPromise<Array<AuthorisedRepresentativeDto>> {
            return localVarFp.apiAuthorisedRepresentativeBulkPost(upsertAuthorisedRepresentativesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [authorisedRepresentativeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthorisedRepresentativeDelete(authorisedRepresentativeId?: number, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiAuthorisedRepresentativeDelete(authorisedRepresentativeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [authorisedRepresentativeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthorisedRepresentativeGet(authorisedRepresentativeId?: number, options?: RawAxiosRequestConfig): AxiosPromise<AuthorisedRepresentativeDto> {
            return localVarFp.apiAuthorisedRepresentativeGet(authorisedRepresentativeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [enterpriseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthorisedRepresentativeGetAuthorisedRepresentativesByEnterpriseIdGet(enterpriseId?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<AuthorisedRepresentativeDto>> {
            return localVarFp.apiAuthorisedRepresentativeGetAuthorisedRepresentativesByEnterpriseIdGet(enterpriseId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthorisedRepresentativeApi - object-oriented interface
 * @export
 * @class AuthorisedRepresentativeApi
 * @extends {BaseAPI}
 */
export class AuthorisedRepresentativeApi extends BaseAPI {
    /**
     * 
     * @param {Array<number>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorisedRepresentativeApi
     */
    public apiAuthorisedRepresentativeBulkDelete(requestBody?: Array<number>, options?: RawAxiosRequestConfig) {
        return AuthorisedRepresentativeApiFp(this.configuration).apiAuthorisedRepresentativeBulkDelete(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<UpsertAuthorisedRepresentativesRequest>} [upsertAuthorisedRepresentativesRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorisedRepresentativeApi
     */
    public apiAuthorisedRepresentativeBulkPost(upsertAuthorisedRepresentativesRequest?: Array<UpsertAuthorisedRepresentativesRequest>, options?: RawAxiosRequestConfig) {
        return AuthorisedRepresentativeApiFp(this.configuration).apiAuthorisedRepresentativeBulkPost(upsertAuthorisedRepresentativesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [authorisedRepresentativeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorisedRepresentativeApi
     */
    public apiAuthorisedRepresentativeDelete(authorisedRepresentativeId?: number, options?: RawAxiosRequestConfig) {
        return AuthorisedRepresentativeApiFp(this.configuration).apiAuthorisedRepresentativeDelete(authorisedRepresentativeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [authorisedRepresentativeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorisedRepresentativeApi
     */
    public apiAuthorisedRepresentativeGet(authorisedRepresentativeId?: number, options?: RawAxiosRequestConfig) {
        return AuthorisedRepresentativeApiFp(this.configuration).apiAuthorisedRepresentativeGet(authorisedRepresentativeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [enterpriseId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorisedRepresentativeApi
     */
    public apiAuthorisedRepresentativeGetAuthorisedRepresentativesByEnterpriseIdGet(enterpriseId?: number, options?: RawAxiosRequestConfig) {
        return AuthorisedRepresentativeApiFp(this.configuration).apiAuthorisedRepresentativeGetAuthorisedRepresentativesByEnterpriseIdGet(enterpriseId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BillableEventApi - axios parameter creator
 * @export
 */
export const BillableEventApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} entityId 
         * @param {number} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entityEntityIdGet: async (entityId: number, organisationId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('entityEntityIdGet', 'entityId', entityId)
            const localVarPath = `/entity/{entityId}`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (organisationId !== undefined) {
                localVarQueryParameter['organisationId'] = organisationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SearchBillableEventsByEntityRequest} [searchBillableEventsByEntityRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entitySearchPost: async (searchBillableEventsByEntityRequest?: SearchBillableEventsByEntityRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/entity/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchBillableEventsByEntityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BillableEventApi - functional programming interface
 * @export
 */
export const BillableEventApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BillableEventApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} entityId 
         * @param {number} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async entityEntityIdGet(entityId: number, organisationId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BillableEventDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.entityEntityIdGet(entityId, organisationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillableEventApi.entityEntityIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SearchBillableEventsByEntityRequest} [searchBillableEventsByEntityRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async entitySearchPost(searchBillableEventsByEntityRequest?: SearchBillableEventsByEntityRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillableEventDtoPagedResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.entitySearchPost(searchBillableEventsByEntityRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillableEventApi.entitySearchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BillableEventApi - factory interface
 * @export
 */
export const BillableEventApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BillableEventApiFp(configuration)
    return {
        /**
         * 
         * @param {number} entityId 
         * @param {number} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entityEntityIdGet(entityId: number, organisationId?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<BillableEventDto>> {
            return localVarFp.entityEntityIdGet(entityId, organisationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SearchBillableEventsByEntityRequest} [searchBillableEventsByEntityRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entitySearchPost(searchBillableEventsByEntityRequest?: SearchBillableEventsByEntityRequest, options?: RawAxiosRequestConfig): AxiosPromise<BillableEventDtoPagedResult> {
            return localVarFp.entitySearchPost(searchBillableEventsByEntityRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BillableEventApi - object-oriented interface
 * @export
 * @class BillableEventApi
 * @extends {BaseAPI}
 */
export class BillableEventApi extends BaseAPI {
    /**
     * 
     * @param {number} entityId 
     * @param {number} [organisationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillableEventApi
     */
    public entityEntityIdGet(entityId: number, organisationId?: number, options?: RawAxiosRequestConfig) {
        return BillableEventApiFp(this.configuration).entityEntityIdGet(entityId, organisationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SearchBillableEventsByEntityRequest} [searchBillableEventsByEntityRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillableEventApi
     */
    public entitySearchPost(searchBillableEventsByEntityRequest?: SearchBillableEventsByEntityRequest, options?: RawAxiosRequestConfig) {
        return BillableEventApiFp(this.configuration).entitySearchPost(searchBillableEventsByEntityRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DocumentApi - axios parameter creator
 * @export
 */
export const DocumentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {BulkUploadDocumentRequest} [bulkUploadDocumentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentBulkUploadPost: async (bulkUploadDocumentRequest?: BulkUploadDocumentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/bulk-upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkUploadDocumentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [documentId] 
         * @param {string} [entityId] 
         * @param {EntityTypeCode} [entityType] 
         * @param {DocumentTypeCode} [documentType] 
         * @param {number} [x] 
         * @param {number} [y] 
         * @param {number} [width] 
         * @param {number} [height] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCroppedPost: async (documentId?: number, entityId?: string, entityType?: EntityTypeCode, documentType?: DocumentTypeCode, x?: number, y?: number, width?: number, height?: number, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/cropped`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (documentId !== undefined) {
                localVarQueryParameter['DocumentId'] = documentId;
            }

            if (entityId !== undefined) {
                localVarQueryParameter['EntityId'] = entityId;
            }

            if (entityType !== undefined) {
                localVarQueryParameter['EntityType'] = entityType;
            }

            if (documentType !== undefined) {
                localVarQueryParameter['DocumentType'] = documentType;
            }

            if (x !== undefined) {
                localVarQueryParameter['X'] = x;
            }

            if (y !== undefined) {
                localVarQueryParameter['Y'] = y;
            }

            if (width !== undefined) {
                localVarQueryParameter['Width'] = width;
            }

            if (height !== undefined) {
                localVarQueryParameter['Height'] = height;
            }


            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [documentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentDelete: async (documentId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (documentId !== undefined) {
                localVarQueryParameter['documentId'] = documentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentDocumentIdSetPrimaryPut: async (documentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiDocumentDocumentIdSetPrimaryPut', 'documentId', documentId)
            const localVarPath = `/api/Document/{documentId}/set-primary`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [documentEntityId] 
         * @param {DocumentTypeCode} [documentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGet: async (documentEntityId?: string, documentType?: DocumentTypeCode, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (documentEntityId !== undefined) {
                localVarQueryParameter['documentEntityId'] = documentEntityId;
            }

            if (documentType !== undefined) {
                localVarQueryParameter['documentType'] = documentType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [entityId] 
         * @param {DocumentTypeCode} [documentType] 
         * @param {string} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetAllImagesForAnimalGet: async (entityId?: number, documentType?: DocumentTypeCode, size?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/GetAllImagesForAnimal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (documentType !== undefined) {
                localVarQueryParameter['documentType'] = documentType;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [entityIds] 
         * @param {DocumentTypeCode} [documentType] 
         * @param {string} [size] 
         * @param {boolean} [isPrimary] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetAnimalImageByEntityIdGet: async (entityIds?: Array<number>, documentType?: DocumentTypeCode, size?: string, isPrimary?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/GetAnimalImageByEntityId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (entityIds) {
                localVarQueryParameter['entityIds'] = entityIds;
            }

            if (documentType !== undefined) {
                localVarQueryParameter['documentType'] = documentType;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (isPrimary !== undefined) {
                localVarQueryParameter['isPrimary'] = isPrimary;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [entityId] 
         * @param {DocumentTypeCode} [documentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetDocumentsByEntityIdGet: async (entityId?: string, documentType?: DocumentTypeCode, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/GetDocumentsByEntityId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (documentType !== undefined) {
                localVarQueryParameter['documentType'] = documentType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [entityId] 
         * @param {DocumentTypeCode} [documentType] 
         * @param {string} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetImageByEntityIdGet: async (entityId?: string, documentType?: DocumentTypeCode, size?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/GetImageByEntityId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (documentType !== undefined) {
                localVarQueryParameter['documentType'] = documentType;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [documentEntityId] 
         * @param {string} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetImageGet: async (documentEntityId?: string, size?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/GetImage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (documentEntityId !== undefined) {
                localVarQueryParameter['documentEntityId'] = documentEntityId;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [entityId] 
         * @param {DocumentTypeCode} [documentType] 
         * @param {string} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetImagesByEntityIdGet: async (entityId?: string, documentType?: DocumentTypeCode, size?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/GetImagesByEntityId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (documentType !== undefined) {
                localVarQueryParameter['documentType'] = documentType;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DocumentTypeCode} [documentType] 
         * @param {string} [size] 
         * @param {boolean} [isPrimary] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetImagesByEntityIdsPost: async (documentType?: DocumentTypeCode, size?: string, isPrimary?: boolean, requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/GetImagesByEntityIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (documentType !== undefined) {
                localVarQueryParameter['documentType'] = documentType;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (isPrimary !== undefined) {
                localVarQueryParameter['isPrimary'] = isPrimary;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SingleUploadDocumentRequest} [singleUploadDocumentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentMainUploadPost: async (singleUploadDocumentRequest?: SingleUploadDocumentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/main-upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(singleUploadDocumentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [currentPage] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentPagedGet: async (currentPage?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/Paged`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (currentPage !== undefined) {
                localVarQueryParameter['CurrentPage'] = currentPage;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [documentId] 
         * @param {string} [entityId] 
         * @param {EntityTypeCode} [entityType] 
         * @param {DocumentTypeCode} [documentType] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentPost: async (documentId?: number, entityId?: string, entityType?: EntityTypeCode, documentType?: DocumentTypeCode, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (documentId !== undefined) {
                localVarQueryParameter['DocumentId'] = documentId;
            }

            if (entityId !== undefined) {
                localVarQueryParameter['EntityId'] = entityId;
            }

            if (entityType !== undefined) {
                localVarQueryParameter['EntityType'] = entityType;
            }

            if (documentType !== undefined) {
                localVarQueryParameter['DocumentType'] = documentType;
            }


            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DocumentTypeCode} [documentType] 
         * @param {DocumentSourceType} [sourceType] 
         * @param {string} [folderName] 
         * @param {boolean} [shouldCheckSameNameExist] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentTemporaryUploadPost: async (documentType?: DocumentTypeCode, sourceType?: DocumentSourceType, folderName?: string, shouldCheckSameNameExist?: boolean, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/temporary-upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (documentType !== undefined) {
                localVarQueryParameter['DocumentType'] = documentType;
            }

            if (sourceType !== undefined) {
                localVarQueryParameter['SourceType'] = sourceType;
            }

            if (folderName !== undefined) {
                localVarQueryParameter['FolderName'] = folderName;
            }

            if (shouldCheckSameNameExist !== undefined) {
                localVarQueryParameter['ShouldCheckSameNameExist'] = shouldCheckSameNameExist;
            }


            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentApi - functional programming interface
 * @export
 */
export const DocumentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {BulkUploadDocumentRequest} [bulkUploadDocumentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentBulkUploadPost(bulkUploadDocumentRequest?: BulkUploadDocumentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentBulkUploadPost(bulkUploadDocumentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.apiDocumentBulkUploadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [documentId] 
         * @param {string} [entityId] 
         * @param {EntityTypeCode} [entityType] 
         * @param {DocumentTypeCode} [documentType] 
         * @param {number} [x] 
         * @param {number} [y] 
         * @param {number} [width] 
         * @param {number} [height] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentCroppedPost(documentId?: number, entityId?: string, entityType?: EntityTypeCode, documentType?: DocumentTypeCode, x?: number, y?: number, width?: number, height?: number, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentCroppedPost(documentId, entityId, entityType, documentType, x, y, width, height, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.apiDocumentCroppedPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [documentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentDelete(documentId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentDelete(documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.apiDocumentDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentDocumentIdSetPrimaryPut(documentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentDocumentIdSetPrimaryPut(documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.apiDocumentDocumentIdSetPrimaryPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [documentEntityId] 
         * @param {DocumentTypeCode} [documentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentGet(documentEntityId?: string, documentType?: DocumentTypeCode, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentGet(documentEntityId, documentType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.apiDocumentGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [entityId] 
         * @param {DocumentTypeCode} [documentType] 
         * @param {string} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentGetAllImagesForAnimalGet(entityId?: number, documentType?: DocumentTypeCode, size?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentGetAllImagesForAnimalGet(entityId, documentType, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.apiDocumentGetAllImagesForAnimalGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<number>} [entityIds] 
         * @param {DocumentTypeCode} [documentType] 
         * @param {string} [size] 
         * @param {boolean} [isPrimary] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentGetAnimalImageByEntityIdGet(entityIds?: Array<number>, documentType?: DocumentTypeCode, size?: string, isPrimary?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentGetAnimalImageByEntityIdGet(entityIds, documentType, size, isPrimary, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.apiDocumentGetAnimalImageByEntityIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [entityId] 
         * @param {DocumentTypeCode} [documentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentGetDocumentsByEntityIdGet(entityId?: string, documentType?: DocumentTypeCode, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentGetDocumentsByEntityIdGet(entityId, documentType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.apiDocumentGetDocumentsByEntityIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [entityId] 
         * @param {DocumentTypeCode} [documentType] 
         * @param {string} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentGetImageByEntityIdGet(entityId?: string, documentType?: DocumentTypeCode, size?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentGetImageByEntityIdGet(entityId, documentType, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.apiDocumentGetImageByEntityIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [documentEntityId] 
         * @param {string} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentGetImageGet(documentEntityId?: string, size?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentGetImageGet(documentEntityId, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.apiDocumentGetImageGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [entityId] 
         * @param {DocumentTypeCode} [documentType] 
         * @param {string} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentGetImagesByEntityIdGet(entityId?: string, documentType?: DocumentTypeCode, size?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentGetImagesByEntityIdGet(entityId, documentType, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.apiDocumentGetImagesByEntityIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DocumentTypeCode} [documentType] 
         * @param {string} [size] 
         * @param {boolean} [isPrimary] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentGetImagesByEntityIdsPost(documentType?: DocumentTypeCode, size?: string, isPrimary?: boolean, requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentGetImagesByEntityIdsPost(documentType, size, isPrimary, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.apiDocumentGetImagesByEntityIdsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SingleUploadDocumentRequest} [singleUploadDocumentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentMainUploadPost(singleUploadDocumentRequest?: SingleUploadDocumentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentMainUploadPost(singleUploadDocumentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.apiDocumentMainUploadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [currentPage] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentPagedGet(currentPage?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentPagedResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentPagedGet(currentPage, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.apiDocumentPagedGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [documentId] 
         * @param {string} [entityId] 
         * @param {EntityTypeCode} [entityType] 
         * @param {DocumentTypeCode} [documentType] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentPost(documentId?: number, entityId?: string, entityType?: EntityTypeCode, documentType?: DocumentTypeCode, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentPost(documentId, entityId, entityType, documentType, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.apiDocumentPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DocumentTypeCode} [documentType] 
         * @param {DocumentSourceType} [sourceType] 
         * @param {string} [folderName] 
         * @param {boolean} [shouldCheckSameNameExist] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentTemporaryUploadPost(documentType?: DocumentTypeCode, sourceType?: DocumentSourceType, folderName?: string, shouldCheckSameNameExist?: boolean, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentTemporaryUploadPost(documentType, sourceType, folderName, shouldCheckSameNameExist, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.apiDocumentTemporaryUploadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DocumentApi - factory interface
 * @export
 */
export const DocumentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentApiFp(configuration)
    return {
        /**
         * 
         * @param {BulkUploadDocumentRequest} [bulkUploadDocumentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentBulkUploadPost(bulkUploadDocumentRequest?: BulkUploadDocumentRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<DocumentDto>> {
            return localVarFp.apiDocumentBulkUploadPost(bulkUploadDocumentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [documentId] 
         * @param {string} [entityId] 
         * @param {EntityTypeCode} [entityType] 
         * @param {DocumentTypeCode} [documentType] 
         * @param {number} [x] 
         * @param {number} [y] 
         * @param {number} [width] 
         * @param {number} [height] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCroppedPost(documentId?: number, entityId?: string, entityType?: EntityTypeCode, documentType?: DocumentTypeCode, x?: number, y?: number, width?: number, height?: number, file?: File, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDto> {
            return localVarFp.apiDocumentCroppedPost(documentId, entityId, entityType, documentType, x, y, width, height, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [documentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentDelete(documentId?: number, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDto> {
            return localVarFp.apiDocumentDelete(documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentDocumentIdSetPrimaryPut(documentId: number, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiDocumentDocumentIdSetPrimaryPut(documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [documentEntityId] 
         * @param {DocumentTypeCode} [documentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGet(documentEntityId?: string, documentType?: DocumentTypeCode, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiDocumentGet(documentEntityId, documentType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [entityId] 
         * @param {DocumentTypeCode} [documentType] 
         * @param {string} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetAllImagesForAnimalGet(entityId?: number, documentType?: DocumentTypeCode, size?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DocumentDto>> {
            return localVarFp.apiDocumentGetAllImagesForAnimalGet(entityId, documentType, size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [entityIds] 
         * @param {DocumentTypeCode} [documentType] 
         * @param {string} [size] 
         * @param {boolean} [isPrimary] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetAnimalImageByEntityIdGet(entityIds?: Array<number>, documentType?: DocumentTypeCode, size?: string, isPrimary?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<DocumentDto>> {
            return localVarFp.apiDocumentGetAnimalImageByEntityIdGet(entityIds, documentType, size, isPrimary, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [entityId] 
         * @param {DocumentTypeCode} [documentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetDocumentsByEntityIdGet(entityId?: string, documentType?: DocumentTypeCode, options?: RawAxiosRequestConfig): AxiosPromise<Array<DocumentDto>> {
            return localVarFp.apiDocumentGetDocumentsByEntityIdGet(entityId, documentType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [entityId] 
         * @param {DocumentTypeCode} [documentType] 
         * @param {string} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetImageByEntityIdGet(entityId?: string, documentType?: DocumentTypeCode, size?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiDocumentGetImageByEntityIdGet(entityId, documentType, size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [documentEntityId] 
         * @param {string} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetImageGet(documentEntityId?: string, size?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiDocumentGetImageGet(documentEntityId, size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [entityId] 
         * @param {DocumentTypeCode} [documentType] 
         * @param {string} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetImagesByEntityIdGet(entityId?: string, documentType?: DocumentTypeCode, size?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DocumentDto>> {
            return localVarFp.apiDocumentGetImagesByEntityIdGet(entityId, documentType, size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentTypeCode} [documentType] 
         * @param {string} [size] 
         * @param {boolean} [isPrimary] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentGetImagesByEntityIdsPost(documentType?: DocumentTypeCode, size?: string, isPrimary?: boolean, requestBody?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<Array<DocumentDto>> {
            return localVarFp.apiDocumentGetImagesByEntityIdsPost(documentType, size, isPrimary, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SingleUploadDocumentRequest} [singleUploadDocumentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentMainUploadPost(singleUploadDocumentRequest?: SingleUploadDocumentRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDto> {
            return localVarFp.apiDocumentMainUploadPost(singleUploadDocumentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [currentPage] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentPagedGet(currentPage?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<DocumentPagedResult> {
            return localVarFp.apiDocumentPagedGet(currentPage, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [documentId] 
         * @param {string} [entityId] 
         * @param {EntityTypeCode} [entityType] 
         * @param {DocumentTypeCode} [documentType] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentPost(documentId?: number, entityId?: string, entityType?: EntityTypeCode, documentType?: DocumentTypeCode, file?: File, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDto> {
            return localVarFp.apiDocumentPost(documentId, entityId, entityType, documentType, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentTypeCode} [documentType] 
         * @param {DocumentSourceType} [sourceType] 
         * @param {string} [folderName] 
         * @param {boolean} [shouldCheckSameNameExist] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentTemporaryUploadPost(documentType?: DocumentTypeCode, sourceType?: DocumentSourceType, folderName?: string, shouldCheckSameNameExist?: boolean, file?: File, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDto> {
            return localVarFp.apiDocumentTemporaryUploadPost(documentType, sourceType, folderName, shouldCheckSameNameExist, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentApi - object-oriented interface
 * @export
 * @class DocumentApi
 * @extends {BaseAPI}
 */
export class DocumentApi extends BaseAPI {
    /**
     * 
     * @param {BulkUploadDocumentRequest} [bulkUploadDocumentRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentBulkUploadPost(bulkUploadDocumentRequest?: BulkUploadDocumentRequest, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentBulkUploadPost(bulkUploadDocumentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [documentId] 
     * @param {string} [entityId] 
     * @param {EntityTypeCode} [entityType] 
     * @param {DocumentTypeCode} [documentType] 
     * @param {number} [x] 
     * @param {number} [y] 
     * @param {number} [width] 
     * @param {number} [height] 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentCroppedPost(documentId?: number, entityId?: string, entityType?: EntityTypeCode, documentType?: DocumentTypeCode, x?: number, y?: number, width?: number, height?: number, file?: File, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentCroppedPost(documentId, entityId, entityType, documentType, x, y, width, height, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [documentId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentDelete(documentId?: number, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentDelete(documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentDocumentIdSetPrimaryPut(documentId: number, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentDocumentIdSetPrimaryPut(documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [documentEntityId] 
     * @param {DocumentTypeCode} [documentType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentGet(documentEntityId?: string, documentType?: DocumentTypeCode, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentGet(documentEntityId, documentType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [entityId] 
     * @param {DocumentTypeCode} [documentType] 
     * @param {string} [size] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentGetAllImagesForAnimalGet(entityId?: number, documentType?: DocumentTypeCode, size?: string, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentGetAllImagesForAnimalGet(entityId, documentType, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [entityIds] 
     * @param {DocumentTypeCode} [documentType] 
     * @param {string} [size] 
     * @param {boolean} [isPrimary] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentGetAnimalImageByEntityIdGet(entityIds?: Array<number>, documentType?: DocumentTypeCode, size?: string, isPrimary?: boolean, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentGetAnimalImageByEntityIdGet(entityIds, documentType, size, isPrimary, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [entityId] 
     * @param {DocumentTypeCode} [documentType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentGetDocumentsByEntityIdGet(entityId?: string, documentType?: DocumentTypeCode, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentGetDocumentsByEntityIdGet(entityId, documentType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [entityId] 
     * @param {DocumentTypeCode} [documentType] 
     * @param {string} [size] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentGetImageByEntityIdGet(entityId?: string, documentType?: DocumentTypeCode, size?: string, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentGetImageByEntityIdGet(entityId, documentType, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [documentEntityId] 
     * @param {string} [size] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentGetImageGet(documentEntityId?: string, size?: string, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentGetImageGet(documentEntityId, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [entityId] 
     * @param {DocumentTypeCode} [documentType] 
     * @param {string} [size] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentGetImagesByEntityIdGet(entityId?: string, documentType?: DocumentTypeCode, size?: string, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentGetImagesByEntityIdGet(entityId, documentType, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentTypeCode} [documentType] 
     * @param {string} [size] 
     * @param {boolean} [isPrimary] 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentGetImagesByEntityIdsPost(documentType?: DocumentTypeCode, size?: string, isPrimary?: boolean, requestBody?: Array<string>, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentGetImagesByEntityIdsPost(documentType, size, isPrimary, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SingleUploadDocumentRequest} [singleUploadDocumentRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentMainUploadPost(singleUploadDocumentRequest?: SingleUploadDocumentRequest, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentMainUploadPost(singleUploadDocumentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [currentPage] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentPagedGet(currentPage?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentPagedGet(currentPage, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [documentId] 
     * @param {string} [entityId] 
     * @param {EntityTypeCode} [entityType] 
     * @param {DocumentTypeCode} [documentType] 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentPost(documentId?: number, entityId?: string, entityType?: EntityTypeCode, documentType?: DocumentTypeCode, file?: File, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentPost(documentId, entityId, entityType, documentType, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentTypeCode} [documentType] 
     * @param {DocumentSourceType} [sourceType] 
     * @param {string} [folderName] 
     * @param {boolean} [shouldCheckSameNameExist] 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiDocumentTemporaryUploadPost(documentType?: DocumentTypeCode, sourceType?: DocumentSourceType, folderName?: string, shouldCheckSameNameExist?: boolean, file?: File, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentTemporaryUploadPost(documentType, sourceType, folderName, shouldCheckSameNameExist, file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EntityApi - axios parameter creator
 * @export
 */
export const EntityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityApprovePost: async (entityId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Entity/Approve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkDisposeRequest} [bulkDisposeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityBulkDisposeAnimalsPost: async (bulkDisposeRequest?: BulkDisposeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Entity/BulkDisposeAnimals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkDisposeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckValidIdentForOrganisationRequest} [checkValidIdentForOrganisationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityCheckValidIdentForOrganisationPost: async (checkValidIdentForOrganisationRequest?: CheckValidIdentForOrganisationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Entity/CheckValidIdentForOrganisation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkValidIdentForOrganisationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckValidPrefixForOrganisationRequest} [checkValidPrefixForOrganisationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityCheckValidPrefixForOrganisationPost: async (checkValidPrefixForOrganisationRequest?: CheckValidPrefixForOrganisationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Entity/CheckValidPrefixForOrganisation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkValidPrefixForOrganisationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [organisationId] 
         * @param {EntityTypeCode} [entityTypeCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityCleanEntityDetailValuesPost: async (organisationId?: number, entityTypeCode?: EntityTypeCode, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Entity/clean-entity-detail-values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (organisationId !== undefined) {
                localVarQueryParameter['organisationId'] = organisationId;
            }

            if (entityTypeCode !== undefined) {
                localVarQueryParameter['entityTypeCode'] = entityTypeCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityDelete: async (entityId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Entity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [orgId] 
         * @param {string} [keyType] 
         * @param {string} [uniqueKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityEntityResolverGet: async (orgId?: string, keyType?: string, uniqueKey?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Entity/EntityResolver`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (orgId !== undefined) {
                localVarQueryParameter['orgId'] = orgId;
            }

            if (keyType !== undefined) {
                localVarQueryParameter['keyType'] = keyType;
            }

            if (uniqueKey !== undefined) {
                localVarQueryParameter['uniqueKey'] = uniqueKey;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [entityId] 
         * @param {number} [orgId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityGenerateAnimalIdentGet: async (entityId?: number, orgId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Entity/GenerateAnimalIdent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (orgId !== undefined) {
                localVarQueryParameter['orgId'] = orgId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GenerateCertificateRequest} [generateCertificateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityGenerateCertificatePost: async (generateCertificateRequest?: GenerateCertificateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Entity/generate-certificate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateCertificateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} currentPage 
         * @param {number} pageSize 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityGetAllEntitiesWithPaginationGet: async (currentPage: number, pageSize: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'currentPage' is not null or undefined
            assertParamExists('apiEntityGetAllEntitiesWithPaginationGet', 'currentPage', currentPage)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('apiEntityGetAllEntitiesWithPaginationGet', 'pageSize', pageSize)
            const localVarPath = `/api/Entity/GetAllEntitiesWithPagination`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (currentPage !== undefined) {
                localVarQueryParameter['CurrentPage'] = currentPage;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetAnimalProgenyRequest} [getAnimalProgenyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityGetAnimalProgenyPost: async (getAnimalProgenyRequest?: GetAnimalProgenyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Entity/GetAnimalProgeny`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getAnimalProgenyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityGetDetailsByEntityIdGet: async (entityId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Entity/get-details-by-entity-id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityGetEntityByEntityGuidsPost: async (requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Entity/GetEntityByEntityGuids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityGetEntityByEntityIdGet: async (entityId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Entity/GetEntityByEntityId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityGetEntityByGuidGet: async (id?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Entity/GetEntityByGuid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} currentPage 
         * @param {number} pageSize 
         * @param {number} [organisationId] 
         * @param {EntityTypeCode} [entityTypeCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityGetEntityByOrgIdGet: async (currentPage: number, pageSize: number, organisationId?: number, entityTypeCode?: EntityTypeCode, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'currentPage' is not null or undefined
            assertParamExists('apiEntityGetEntityByOrgIdGet', 'currentPage', currentPage)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('apiEntityGetEntityByOrgIdGet', 'pageSize', pageSize)
            const localVarPath = `/api/Entity/GetEntityByOrgId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (currentPage !== undefined) {
                localVarQueryParameter['CurrentPage'] = currentPage;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (organisationId !== undefined) {
                localVarQueryParameter['organisationId'] = organisationId;
            }

            if (entityTypeCode !== undefined) {
                localVarQueryParameter['entityTypeCode'] = entityTypeCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EntityFilterByDetailRequest} [entityFilterByDetailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityGetEntityFilterByDetailPost: async (entityFilterByDetailRequest?: EntityFilterByDetailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Entity/GetEntityFilterByDetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityFilterByDetailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [entityGuidId] 
         * @param {number} [maxGeneration] 
         * @param {boolean} [includeEnhancers] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityGetPedigreeGet: async (entityGuidId?: string, maxGeneration?: number, includeEnhancers?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Entity/GetPedigree`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (entityGuidId !== undefined) {
                localVarQueryParameter['entityGuidId'] = entityGuidId;
            }

            if (maxGeneration !== undefined) {
                localVarQueryParameter['maxGeneration'] = maxGeneration;
            }

            if (includeEnhancers !== undefined) {
                localVarQueryParameter['includeEnhancers'] = includeEnhancers;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LinkOptionsByEntityDetailsRequest} [linkOptionsByEntityDetailsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityLinkOptionsByEntityDetailPost: async (linkOptionsByEntityDetailsRequest?: LinkOptionsByEntityDetailsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Entity/link-options-by-entity-detail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(linkOptionsByEntityDetailsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateMemberMembershipRequest} [updateMemberMembershipRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityMemberMembershipsPut: async (updateMemberMembershipRequest?: UpdateMemberMembershipRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Entity/member/memberships`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMemberMembershipRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertEntityRequest} [upsertEntityRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityPost: async (upsertEntityRequest?: UpsertEntityRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Entity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertEntityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {QuickSearchRequest} [quickSearchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityQuickSearchPost: async (quickSearchRequest?: QuickSearchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Entity/quick-search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(quickSearchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SearchByOrgIdRequest} [searchByOrgIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntitySearchByOrgIdPost: async (searchByOrgIdRequest?: SearchByOrgIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Entity/SearchByOrgId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchByOrgIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SearchEntityByDetailRequest} [searchEntityByDetailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntitySearchEntityByDetailPost: async (searchEntityByDetailRequest?: SearchEntityByDetailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Entity/SearchEntityByDetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchEntityByDetailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkSuspendMemberRequest} [bulkSuspendMemberRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntitySuspendEnterprisesPatch: async (bulkSuspendMemberRequest?: BulkSuspendMemberRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Entity/SuspendEnterprises`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkSuspendMemberRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} orgId 
         * @param {BreedlogicSyncEntityType} [entityType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntitySyncSocietyOrgIdPost: async (orgId: number, entityType?: BreedlogicSyncEntityType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('apiEntitySyncSocietyOrgIdPost', 'orgId', orgId)
            const localVarPath = `/api/Entity/sync/society/{orgId}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (entityType !== undefined) {
                localVarQueryParameter['entityType'] = entityType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertDetailValuesRequest} [upsertDetailValuesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityUpsertDetailValuesPost: async (upsertDetailValuesRequest?: UpsertDetailValuesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Entity/UpsertDetailValues`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertDetailValuesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertEntityWithDetailRequest} [upsertEntityWithDetailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityUpsertEntityWithDetailPost: async (upsertEntityWithDetailRequest?: UpsertEntityWithDetailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Entity/UpsertEntityWithDetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertEntityWithDetailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EntityApi - functional programming interface
 * @export
 */
export const EntityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EntityApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityApprovePost(entityId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityApprovePost(entityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityApi.apiEntityApprovePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BulkDisposeRequest} [bulkDisposeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityBulkDisposeAnimalsPost(bulkDisposeRequest?: BulkDisposeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkDisposeResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityBulkDisposeAnimalsPost(bulkDisposeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityApi.apiEntityBulkDisposeAnimalsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CheckValidIdentForOrganisationRequest} [checkValidIdentForOrganisationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityCheckValidIdentForOrganisationPost(checkValidIdentForOrganisationRequest?: CheckValidIdentForOrganisationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityCheckValidIdentForOrganisationPost(checkValidIdentForOrganisationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityApi.apiEntityCheckValidIdentForOrganisationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CheckValidPrefixForOrganisationRequest} [checkValidPrefixForOrganisationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityCheckValidPrefixForOrganisationPost(checkValidPrefixForOrganisationRequest?: CheckValidPrefixForOrganisationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityCheckValidPrefixForOrganisationPost(checkValidPrefixForOrganisationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityApi.apiEntityCheckValidPrefixForOrganisationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [organisationId] 
         * @param {EntityTypeCode} [entityTypeCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityCleanEntityDetailValuesPost(organisationId?: number, entityTypeCode?: EntityTypeCode, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityCleanEntityDetailValuesPost(organisationId, entityTypeCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityApi.apiEntityCleanEntityDetailValuesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityDelete(entityId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityDelete(entityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityApi.apiEntityDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [orgId] 
         * @param {string} [keyType] 
         * @param {string} [uniqueKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityEntityResolverGet(orgId?: string, keyType?: string, uniqueKey?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityEntityResolverGet(orgId, keyType, uniqueKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityApi.apiEntityEntityResolverGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [entityId] 
         * @param {number} [orgId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityGenerateAnimalIdentGet(entityId?: number, orgId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityGenerateAnimalIdentGet(entityId, orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityApi.apiEntityGenerateAnimalIdentGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GenerateCertificateRequest} [generateCertificateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityGenerateCertificatePost(generateCertificateRequest?: GenerateCertificateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityGenerateCertificatePost(generateCertificateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityApi.apiEntityGenerateCertificatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} currentPage 
         * @param {number} pageSize 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityGetAllEntitiesWithPaginationGet(currentPage: number, pageSize: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityDtoPagedResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityGetAllEntitiesWithPaginationGet(currentPage, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityApi.apiEntityGetAllEntitiesWithPaginationGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetAnimalProgenyRequest} [getAnimalProgenyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityGetAnimalProgenyPost(getAnimalProgenyRequest?: GetAnimalProgenyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityDtoPagedResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityGetAnimalProgenyPost(getAnimalProgenyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityApi.apiEntityGetAnimalProgenyPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityGetDetailsByEntityIdGet(entityId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityGetDetailsByEntityIdGet(entityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityApi.apiEntityGetDetailsByEntityIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityGetEntityByEntityGuidsPost(requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityGetEntityByEntityGuidsPost(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityApi.apiEntityGetEntityByEntityGuidsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityGetEntityByEntityIdGet(entityId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityGetEntityByEntityIdGet(entityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityApi.apiEntityGetEntityByEntityIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityGetEntityByGuidGet(id?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityGetEntityByGuidGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityApi.apiEntityGetEntityByGuidGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} currentPage 
         * @param {number} pageSize 
         * @param {number} [organisationId] 
         * @param {EntityTypeCode} [entityTypeCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityGetEntityByOrgIdGet(currentPage: number, pageSize: number, organisationId?: number, entityTypeCode?: EntityTypeCode, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityDtoPagedResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityGetEntityByOrgIdGet(currentPage, pageSize, organisationId, entityTypeCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityApi.apiEntityGetEntityByOrgIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EntityFilterByDetailRequest} [entityFilterByDetailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityGetEntityFilterByDetailPost(entityFilterByDetailRequest?: EntityFilterByDetailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityDtoPagedResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityGetEntityFilterByDetailPost(entityFilterByDetailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityApi.apiEntityGetEntityFilterByDetailPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [entityGuidId] 
         * @param {number} [maxGeneration] 
         * @param {boolean} [includeEnhancers] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityGetPedigreeGet(entityGuidId?: string, maxGeneration?: number, includeEnhancers?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PedigreeNodeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityGetPedigreeGet(entityGuidId, maxGeneration, includeEnhancers, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityApi.apiEntityGetPedigreeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {LinkOptionsByEntityDetailsRequest} [linkOptionsByEntityDetailsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityLinkOptionsByEntityDetailPost(linkOptionsByEntityDetailsRequest?: LinkOptionsByEntityDetailsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LinkOptionsByEntityDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityLinkOptionsByEntityDetailPost(linkOptionsByEntityDetailsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityApi.apiEntityLinkOptionsByEntityDetailPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateMemberMembershipRequest} [updateMemberMembershipRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityMemberMembershipsPut(updateMemberMembershipRequest?: UpdateMemberMembershipRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityMemberMembershipsPut(updateMemberMembershipRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityApi.apiEntityMemberMembershipsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertEntityRequest} [upsertEntityRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityPost(upsertEntityRequest?: UpsertEntityRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityPost(upsertEntityRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityApi.apiEntityPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {QuickSearchRequest} [quickSearchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityQuickSearchPost(quickSearchRequest?: QuickSearchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityDtoPagedResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityQuickSearchPost(quickSearchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityApi.apiEntityQuickSearchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SearchByOrgIdRequest} [searchByOrgIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntitySearchByOrgIdPost(searchByOrgIdRequest?: SearchByOrgIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityDtoPagedResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntitySearchByOrgIdPost(searchByOrgIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityApi.apiEntitySearchByOrgIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SearchEntityByDetailRequest} [searchEntityByDetailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntitySearchEntityByDetailPost(searchEntityByDetailRequest?: SearchEntityByDetailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityDtoPagedResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntitySearchEntityByDetailPost(searchEntityByDetailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityApi.apiEntitySearchEntityByDetailPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BulkSuspendMemberRequest} [bulkSuspendMemberRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntitySuspendEnterprisesPatch(bulkSuspendMemberRequest?: BulkSuspendMemberRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntitySuspendEnterprisesPatch(bulkSuspendMemberRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityApi.apiEntitySuspendEnterprisesPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} orgId 
         * @param {BreedlogicSyncEntityType} [entityType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntitySyncSocietyOrgIdPost(orgId: number, entityType?: BreedlogicSyncEntityType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntitySyncSocietyOrgIdPost(orgId, entityType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityApi.apiEntitySyncSocietyOrgIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertDetailValuesRequest} [upsertDetailValuesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityUpsertDetailValuesPost(upsertDetailValuesRequest?: UpsertDetailValuesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityUpsertDetailValuesPost(upsertDetailValuesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityApi.apiEntityUpsertDetailValuesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertEntityWithDetailRequest} [upsertEntityWithDetailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityUpsertEntityWithDetailPost(upsertEntityWithDetailRequest?: UpsertEntityWithDetailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityUpsertEntityWithDetailPost(upsertEntityWithDetailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityApi.apiEntityUpsertEntityWithDetailPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EntityApi - factory interface
 * @export
 */
export const EntityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EntityApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityApprovePost(entityId?: number, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiEntityApprovePost(entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BulkDisposeRequest} [bulkDisposeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityBulkDisposeAnimalsPost(bulkDisposeRequest?: BulkDisposeRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkDisposeResultDto> {
            return localVarFp.apiEntityBulkDisposeAnimalsPost(bulkDisposeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckValidIdentForOrganisationRequest} [checkValidIdentForOrganisationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityCheckValidIdentForOrganisationPost(checkValidIdentForOrganisationRequest?: CheckValidIdentForOrganisationRequest, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiEntityCheckValidIdentForOrganisationPost(checkValidIdentForOrganisationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckValidPrefixForOrganisationRequest} [checkValidPrefixForOrganisationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityCheckValidPrefixForOrganisationPost(checkValidPrefixForOrganisationRequest?: CheckValidPrefixForOrganisationRequest, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiEntityCheckValidPrefixForOrganisationPost(checkValidPrefixForOrganisationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [organisationId] 
         * @param {EntityTypeCode} [entityTypeCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityCleanEntityDetailValuesPost(organisationId?: number, entityTypeCode?: EntityTypeCode, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiEntityCleanEntityDetailValuesPost(organisationId, entityTypeCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityDelete(entityId?: number, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiEntityDelete(entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [orgId] 
         * @param {string} [keyType] 
         * @param {string} [uniqueKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityEntityResolverGet(orgId?: string, keyType?: string, uniqueKey?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiEntityEntityResolverGet(orgId, keyType, uniqueKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [entityId] 
         * @param {number} [orgId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityGenerateAnimalIdentGet(entityId?: number, orgId?: number, options?: RawAxiosRequestConfig): AxiosPromise<EntityDto> {
            return localVarFp.apiEntityGenerateAnimalIdentGet(entityId, orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GenerateCertificateRequest} [generateCertificateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityGenerateCertificatePost(generateCertificateRequest?: GenerateCertificateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiEntityGenerateCertificatePost(generateCertificateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} currentPage 
         * @param {number} pageSize 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityGetAllEntitiesWithPaginationGet(currentPage: number, pageSize: number, options?: RawAxiosRequestConfig): AxiosPromise<EntityDtoPagedResult> {
            return localVarFp.apiEntityGetAllEntitiesWithPaginationGet(currentPage, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetAnimalProgenyRequest} [getAnimalProgenyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityGetAnimalProgenyPost(getAnimalProgenyRequest?: GetAnimalProgenyRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityDtoPagedResult> {
            return localVarFp.apiEntityGetAnimalProgenyPost(getAnimalProgenyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityGetDetailsByEntityIdGet(entityId?: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiEntityGetDetailsByEntityIdGet(entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityGetEntityByEntityGuidsPost(requestBody?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<Array<EntityDto>> {
            return localVarFp.apiEntityGetEntityByEntityGuidsPost(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityGetEntityByEntityIdGet(entityId?: number, options?: RawAxiosRequestConfig): AxiosPromise<EntityDto> {
            return localVarFp.apiEntityGetEntityByEntityIdGet(entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityGetEntityByGuidGet(id?: string, options?: RawAxiosRequestConfig): AxiosPromise<EntityDto> {
            return localVarFp.apiEntityGetEntityByGuidGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} currentPage 
         * @param {number} pageSize 
         * @param {number} [organisationId] 
         * @param {EntityTypeCode} [entityTypeCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityGetEntityByOrgIdGet(currentPage: number, pageSize: number, organisationId?: number, entityTypeCode?: EntityTypeCode, options?: RawAxiosRequestConfig): AxiosPromise<EntityDtoPagedResult> {
            return localVarFp.apiEntityGetEntityByOrgIdGet(currentPage, pageSize, organisationId, entityTypeCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EntityFilterByDetailRequest} [entityFilterByDetailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityGetEntityFilterByDetailPost(entityFilterByDetailRequest?: EntityFilterByDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityDtoPagedResult> {
            return localVarFp.apiEntityGetEntityFilterByDetailPost(entityFilterByDetailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [entityGuidId] 
         * @param {number} [maxGeneration] 
         * @param {boolean} [includeEnhancers] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityGetPedigreeGet(entityGuidId?: string, maxGeneration?: number, includeEnhancers?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PedigreeNodeDto> {
            return localVarFp.apiEntityGetPedigreeGet(entityGuidId, maxGeneration, includeEnhancers, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LinkOptionsByEntityDetailsRequest} [linkOptionsByEntityDetailsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityLinkOptionsByEntityDetailPost(linkOptionsByEntityDetailsRequest?: LinkOptionsByEntityDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<LinkOptionsByEntityDetailsResponse> {
            return localVarFp.apiEntityLinkOptionsByEntityDetailPost(linkOptionsByEntityDetailsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateMemberMembershipRequest} [updateMemberMembershipRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityMemberMembershipsPut(updateMemberMembershipRequest?: UpdateMemberMembershipRequest, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiEntityMemberMembershipsPut(updateMemberMembershipRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertEntityRequest} [upsertEntityRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityPost(upsertEntityRequest?: UpsertEntityRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityDto> {
            return localVarFp.apiEntityPost(upsertEntityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuickSearchRequest} [quickSearchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityQuickSearchPost(quickSearchRequest?: QuickSearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityDtoPagedResult> {
            return localVarFp.apiEntityQuickSearchPost(quickSearchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SearchByOrgIdRequest} [searchByOrgIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntitySearchByOrgIdPost(searchByOrgIdRequest?: SearchByOrgIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityDtoPagedResult> {
            return localVarFp.apiEntitySearchByOrgIdPost(searchByOrgIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SearchEntityByDetailRequest} [searchEntityByDetailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntitySearchEntityByDetailPost(searchEntityByDetailRequest?: SearchEntityByDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityDtoPagedResult> {
            return localVarFp.apiEntitySearchEntityByDetailPost(searchEntityByDetailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BulkSuspendMemberRequest} [bulkSuspendMemberRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntitySuspendEnterprisesPatch(bulkSuspendMemberRequest?: BulkSuspendMemberRequest, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiEntitySuspendEnterprisesPatch(bulkSuspendMemberRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} orgId 
         * @param {BreedlogicSyncEntityType} [entityType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntitySyncSocietyOrgIdPost(orgId: number, entityType?: BreedlogicSyncEntityType, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiEntitySyncSocietyOrgIdPost(orgId, entityType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertDetailValuesRequest} [upsertDetailValuesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityUpsertDetailValuesPost(upsertDetailValuesRequest?: UpsertDetailValuesRequest, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiEntityUpsertDetailValuesPost(upsertDetailValuesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertEntityWithDetailRequest} [upsertEntityWithDetailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityUpsertEntityWithDetailPost(upsertEntityWithDetailRequest?: UpsertEntityWithDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityDto> {
            return localVarFp.apiEntityUpsertEntityWithDetailPost(upsertEntityWithDetailRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EntityApi - object-oriented interface
 * @export
 * @class EntityApi
 * @extends {BaseAPI}
 */
export class EntityApi extends BaseAPI {
    /**
     * 
     * @param {number} [entityId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiEntityApprovePost(entityId?: number, options?: RawAxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiEntityApprovePost(entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BulkDisposeRequest} [bulkDisposeRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiEntityBulkDisposeAnimalsPost(bulkDisposeRequest?: BulkDisposeRequest, options?: RawAxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiEntityBulkDisposeAnimalsPost(bulkDisposeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckValidIdentForOrganisationRequest} [checkValidIdentForOrganisationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiEntityCheckValidIdentForOrganisationPost(checkValidIdentForOrganisationRequest?: CheckValidIdentForOrganisationRequest, options?: RawAxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiEntityCheckValidIdentForOrganisationPost(checkValidIdentForOrganisationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckValidPrefixForOrganisationRequest} [checkValidPrefixForOrganisationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiEntityCheckValidPrefixForOrganisationPost(checkValidPrefixForOrganisationRequest?: CheckValidPrefixForOrganisationRequest, options?: RawAxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiEntityCheckValidPrefixForOrganisationPost(checkValidPrefixForOrganisationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [organisationId] 
     * @param {EntityTypeCode} [entityTypeCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiEntityCleanEntityDetailValuesPost(organisationId?: number, entityTypeCode?: EntityTypeCode, options?: RawAxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiEntityCleanEntityDetailValuesPost(organisationId, entityTypeCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [entityId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiEntityDelete(entityId?: number, options?: RawAxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiEntityDelete(entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [orgId] 
     * @param {string} [keyType] 
     * @param {string} [uniqueKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiEntityEntityResolverGet(orgId?: string, keyType?: string, uniqueKey?: string, options?: RawAxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiEntityEntityResolverGet(orgId, keyType, uniqueKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [entityId] 
     * @param {number} [orgId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiEntityGenerateAnimalIdentGet(entityId?: number, orgId?: number, options?: RawAxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiEntityGenerateAnimalIdentGet(entityId, orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GenerateCertificateRequest} [generateCertificateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiEntityGenerateCertificatePost(generateCertificateRequest?: GenerateCertificateRequest, options?: RawAxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiEntityGenerateCertificatePost(generateCertificateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} currentPage 
     * @param {number} pageSize 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiEntityGetAllEntitiesWithPaginationGet(currentPage: number, pageSize: number, options?: RawAxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiEntityGetAllEntitiesWithPaginationGet(currentPage, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetAnimalProgenyRequest} [getAnimalProgenyRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiEntityGetAnimalProgenyPost(getAnimalProgenyRequest?: GetAnimalProgenyRequest, options?: RawAxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiEntityGetAnimalProgenyPost(getAnimalProgenyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [entityId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiEntityGetDetailsByEntityIdGet(entityId?: number, options?: RawAxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiEntityGetDetailsByEntityIdGet(entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiEntityGetEntityByEntityGuidsPost(requestBody?: Array<string>, options?: RawAxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiEntityGetEntityByEntityGuidsPost(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [entityId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiEntityGetEntityByEntityIdGet(entityId?: number, options?: RawAxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiEntityGetEntityByEntityIdGet(entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiEntityGetEntityByGuidGet(id?: string, options?: RawAxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiEntityGetEntityByGuidGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} currentPage 
     * @param {number} pageSize 
     * @param {number} [organisationId] 
     * @param {EntityTypeCode} [entityTypeCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiEntityGetEntityByOrgIdGet(currentPage: number, pageSize: number, organisationId?: number, entityTypeCode?: EntityTypeCode, options?: RawAxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiEntityGetEntityByOrgIdGet(currentPage, pageSize, organisationId, entityTypeCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EntityFilterByDetailRequest} [entityFilterByDetailRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiEntityGetEntityFilterByDetailPost(entityFilterByDetailRequest?: EntityFilterByDetailRequest, options?: RawAxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiEntityGetEntityFilterByDetailPost(entityFilterByDetailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [entityGuidId] 
     * @param {number} [maxGeneration] 
     * @param {boolean} [includeEnhancers] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiEntityGetPedigreeGet(entityGuidId?: string, maxGeneration?: number, includeEnhancers?: boolean, options?: RawAxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiEntityGetPedigreeGet(entityGuidId, maxGeneration, includeEnhancers, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LinkOptionsByEntityDetailsRequest} [linkOptionsByEntityDetailsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiEntityLinkOptionsByEntityDetailPost(linkOptionsByEntityDetailsRequest?: LinkOptionsByEntityDetailsRequest, options?: RawAxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiEntityLinkOptionsByEntityDetailPost(linkOptionsByEntityDetailsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateMemberMembershipRequest} [updateMemberMembershipRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiEntityMemberMembershipsPut(updateMemberMembershipRequest?: UpdateMemberMembershipRequest, options?: RawAxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiEntityMemberMembershipsPut(updateMemberMembershipRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpsertEntityRequest} [upsertEntityRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiEntityPost(upsertEntityRequest?: UpsertEntityRequest, options?: RawAxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiEntityPost(upsertEntityRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuickSearchRequest} [quickSearchRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiEntityQuickSearchPost(quickSearchRequest?: QuickSearchRequest, options?: RawAxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiEntityQuickSearchPost(quickSearchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SearchByOrgIdRequest} [searchByOrgIdRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiEntitySearchByOrgIdPost(searchByOrgIdRequest?: SearchByOrgIdRequest, options?: RawAxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiEntitySearchByOrgIdPost(searchByOrgIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SearchEntityByDetailRequest} [searchEntityByDetailRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiEntitySearchEntityByDetailPost(searchEntityByDetailRequest?: SearchEntityByDetailRequest, options?: RawAxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiEntitySearchEntityByDetailPost(searchEntityByDetailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BulkSuspendMemberRequest} [bulkSuspendMemberRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiEntitySuspendEnterprisesPatch(bulkSuspendMemberRequest?: BulkSuspendMemberRequest, options?: RawAxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiEntitySuspendEnterprisesPatch(bulkSuspendMemberRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} orgId 
     * @param {BreedlogicSyncEntityType} [entityType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiEntitySyncSocietyOrgIdPost(orgId: number, entityType?: BreedlogicSyncEntityType, options?: RawAxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiEntitySyncSocietyOrgIdPost(orgId, entityType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpsertDetailValuesRequest} [upsertDetailValuesRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiEntityUpsertDetailValuesPost(upsertDetailValuesRequest?: UpsertDetailValuesRequest, options?: RawAxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiEntityUpsertDetailValuesPost(upsertDetailValuesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpsertEntityWithDetailRequest} [upsertEntityWithDetailRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityApi
     */
    public apiEntityUpsertEntityWithDetailPost(upsertEntityWithDetailRequest?: UpsertEntityWithDetailRequest, options?: RawAxiosRequestConfig) {
        return EntityApiFp(this.configuration).apiEntityUpsertEntityWithDetailPost(upsertEntityWithDetailRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EntityDetailApi - axios parameter creator
 * @export
 */
export const EntityDetailApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityDetailAllDefinitionsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/EntityDetail/all-definitions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [organisationId] 
         * @param {number} [entityId] 
         * @param {number} [categoryId] 
         * @param {EntityDetailType} [entityDetailType] 
         * @param {EntityTypeCode} [entityTypeCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityDetailGet: async (organisationId?: number, entityId?: number, categoryId?: number, entityDetailType?: EntityDetailType, entityTypeCode?: EntityTypeCode, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/EntityDetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (organisationId !== undefined) {
                localVarQueryParameter['organisationId'] = organisationId;
            }

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }

            if (entityDetailType !== undefined) {
                localVarQueryParameter['entityDetailType'] = entityDetailType;
            }

            if (entityTypeCode !== undefined) {
                localVarQueryParameter['entityTypeCode'] = entityTypeCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} currentPage 
         * @param {number} pageSize 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityDetailGetEntityDetailPaginationGet: async (currentPage: number, pageSize: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'currentPage' is not null or undefined
            assertParamExists('apiEntityDetailGetEntityDetailPaginationGet', 'currentPage', currentPage)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('apiEntityDetailGetEntityDetailPaginationGet', 'pageSize', pageSize)
            const localVarPath = `/api/EntityDetail/GetEntityDetailPagination`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (currentPage !== undefined) {
                localVarQueryParameter['CurrentPage'] = currentPage;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [categoryId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityDetailGetEntityDetailssByCategoryIdGet: async (categoryId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/EntityDetail/GetEntityDetailssByCategoryId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PagedEntityDetailsRequest} [pagedEntityDetailsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityDetailPagedEntityDetailssByOrganisationIdPost: async (pagedEntityDetailsRequest?: PagedEntityDetailsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/EntityDetail/PagedEntityDetailssByOrganisationId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pagedEntityDetailsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertEntityDetailRequest} [upsertEntityDetailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityDetailPost: async (upsertEntityDetailRequest?: UpsertEntityDetailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/EntityDetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertEntityDetailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EntityDetailsSearchSortFilterRequest} [entityDetailsSearchSortFilterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityDetailSearchSortFilterPost: async (entityDetailsSearchSortFilterRequest?: EntityDetailsSearchSortFilterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/EntityDetail/SearchSortFilter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityDetailsSearchSortFilterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EntityDetailApi - functional programming interface
 * @export
 */
export const EntityDetailApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EntityDetailApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityDetailAllDefinitionsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityDetailDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityDetailAllDefinitionsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityDetailApi.apiEntityDetailAllDefinitionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [organisationId] 
         * @param {number} [entityId] 
         * @param {number} [categoryId] 
         * @param {EntityDetailType} [entityDetailType] 
         * @param {EntityTypeCode} [entityTypeCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityDetailGet(organisationId?: number, entityId?: number, categoryId?: number, entityDetailType?: EntityDetailType, entityTypeCode?: EntityTypeCode, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityDetailDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityDetailGet(organisationId, entityId, categoryId, entityDetailType, entityTypeCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityDetailApi.apiEntityDetailGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} currentPage 
         * @param {number} pageSize 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityDetailGetEntityDetailPaginationGet(currentPage: number, pageSize: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityDetailDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityDetailGetEntityDetailPaginationGet(currentPage, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityDetailApi.apiEntityDetailGetEntityDetailPaginationGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [categoryId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityDetailGetEntityDetailssByCategoryIdGet(categoryId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityDetailDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityDetailGetEntityDetailssByCategoryIdGet(categoryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityDetailApi.apiEntityDetailGetEntityDetailssByCategoryIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PagedEntityDetailsRequest} [pagedEntityDetailsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityDetailPagedEntityDetailssByOrganisationIdPost(pagedEntityDetailsRequest?: PagedEntityDetailsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityDetailDtoPagedResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityDetailPagedEntityDetailssByOrganisationIdPost(pagedEntityDetailsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityDetailApi.apiEntityDetailPagedEntityDetailssByOrganisationIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertEntityDetailRequest} [upsertEntityDetailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityDetailPost(upsertEntityDetailRequest?: UpsertEntityDetailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityDetailDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityDetailPost(upsertEntityDetailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityDetailApi.apiEntityDetailPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EntityDetailsSearchSortFilterRequest} [entityDetailsSearchSortFilterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityDetailSearchSortFilterPost(entityDetailsSearchSortFilterRequest?: EntityDetailsSearchSortFilterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityDetailDtoPagedResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityDetailSearchSortFilterPost(entityDetailsSearchSortFilterRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityDetailApi.apiEntityDetailSearchSortFilterPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EntityDetailApi - factory interface
 * @export
 */
export const EntityDetailApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EntityDetailApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityDetailAllDefinitionsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<EntityDetailDto>> {
            return localVarFp.apiEntityDetailAllDefinitionsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [organisationId] 
         * @param {number} [entityId] 
         * @param {number} [categoryId] 
         * @param {EntityDetailType} [entityDetailType] 
         * @param {EntityTypeCode} [entityTypeCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityDetailGet(organisationId?: number, entityId?: number, categoryId?: number, entityDetailType?: EntityDetailType, entityTypeCode?: EntityTypeCode, options?: RawAxiosRequestConfig): AxiosPromise<Array<EntityDetailDto>> {
            return localVarFp.apiEntityDetailGet(organisationId, entityId, categoryId, entityDetailType, entityTypeCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} currentPage 
         * @param {number} pageSize 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityDetailGetEntityDetailPaginationGet(currentPage: number, pageSize: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<EntityDetailDto>> {
            return localVarFp.apiEntityDetailGetEntityDetailPaginationGet(currentPage, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [categoryId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityDetailGetEntityDetailssByCategoryIdGet(categoryId?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<EntityDetailDto>> {
            return localVarFp.apiEntityDetailGetEntityDetailssByCategoryIdGet(categoryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PagedEntityDetailsRequest} [pagedEntityDetailsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityDetailPagedEntityDetailssByOrganisationIdPost(pagedEntityDetailsRequest?: PagedEntityDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityDetailDtoPagedResult> {
            return localVarFp.apiEntityDetailPagedEntityDetailssByOrganisationIdPost(pagedEntityDetailsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertEntityDetailRequest} [upsertEntityDetailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityDetailPost(upsertEntityDetailRequest?: UpsertEntityDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<EntityDetailDto>> {
            return localVarFp.apiEntityDetailPost(upsertEntityDetailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EntityDetailsSearchSortFilterRequest} [entityDetailsSearchSortFilterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityDetailSearchSortFilterPost(entityDetailsSearchSortFilterRequest?: EntityDetailsSearchSortFilterRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityDetailDtoPagedResult> {
            return localVarFp.apiEntityDetailSearchSortFilterPost(entityDetailsSearchSortFilterRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EntityDetailApi - object-oriented interface
 * @export
 * @class EntityDetailApi
 * @extends {BaseAPI}
 */
export class EntityDetailApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityDetailApi
     */
    public apiEntityDetailAllDefinitionsGet(options?: RawAxiosRequestConfig) {
        return EntityDetailApiFp(this.configuration).apiEntityDetailAllDefinitionsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [organisationId] 
     * @param {number} [entityId] 
     * @param {number} [categoryId] 
     * @param {EntityDetailType} [entityDetailType] 
     * @param {EntityTypeCode} [entityTypeCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityDetailApi
     */
    public apiEntityDetailGet(organisationId?: number, entityId?: number, categoryId?: number, entityDetailType?: EntityDetailType, entityTypeCode?: EntityTypeCode, options?: RawAxiosRequestConfig) {
        return EntityDetailApiFp(this.configuration).apiEntityDetailGet(organisationId, entityId, categoryId, entityDetailType, entityTypeCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} currentPage 
     * @param {number} pageSize 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityDetailApi
     */
    public apiEntityDetailGetEntityDetailPaginationGet(currentPage: number, pageSize: number, options?: RawAxiosRequestConfig) {
        return EntityDetailApiFp(this.configuration).apiEntityDetailGetEntityDetailPaginationGet(currentPage, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [categoryId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityDetailApi
     */
    public apiEntityDetailGetEntityDetailssByCategoryIdGet(categoryId?: number, options?: RawAxiosRequestConfig) {
        return EntityDetailApiFp(this.configuration).apiEntityDetailGetEntityDetailssByCategoryIdGet(categoryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PagedEntityDetailsRequest} [pagedEntityDetailsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityDetailApi
     */
    public apiEntityDetailPagedEntityDetailssByOrganisationIdPost(pagedEntityDetailsRequest?: PagedEntityDetailsRequest, options?: RawAxiosRequestConfig) {
        return EntityDetailApiFp(this.configuration).apiEntityDetailPagedEntityDetailssByOrganisationIdPost(pagedEntityDetailsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpsertEntityDetailRequest} [upsertEntityDetailRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityDetailApi
     */
    public apiEntityDetailPost(upsertEntityDetailRequest?: UpsertEntityDetailRequest, options?: RawAxiosRequestConfig) {
        return EntityDetailApiFp(this.configuration).apiEntityDetailPost(upsertEntityDetailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EntityDetailsSearchSortFilterRequest} [entityDetailsSearchSortFilterRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityDetailApi
     */
    public apiEntityDetailSearchSortFilterPost(entityDetailsSearchSortFilterRequest?: EntityDetailsSearchSortFilterRequest, options?: RawAxiosRequestConfig) {
        return EntityDetailApiFp(this.configuration).apiEntityDetailSearchSortFilterPost(entityDetailsSearchSortFilterRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EntityDetailCategoryApi - axios parameter creator
 * @export
 */
export const EntityDetailCategoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityDetailCategoryGet: async (organisationId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/EntityDetailCategory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (organisationId !== undefined) {
                localVarQueryParameter['organisationId'] = organisationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertEntityDetailCategoryRequest} [upsertEntityDetailCategoryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityDetailCategoryPost: async (upsertEntityDetailCategoryRequest?: UpsertEntityDetailCategoryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/EntityDetailCategory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertEntityDetailCategoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EntityDetailCategoryApi - functional programming interface
 * @export
 */
export const EntityDetailCategoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EntityDetailCategoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityDetailCategoryGet(organisationId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityDetailCategoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityDetailCategoryGet(organisationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityDetailCategoryApi.apiEntityDetailCategoryGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertEntityDetailCategoryRequest} [upsertEntityDetailCategoryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityDetailCategoryPost(upsertEntityDetailCategoryRequest?: UpsertEntityDetailCategoryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityDetailCategoryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityDetailCategoryPost(upsertEntityDetailCategoryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityDetailCategoryApi.apiEntityDetailCategoryPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EntityDetailCategoryApi - factory interface
 * @export
 */
export const EntityDetailCategoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EntityDetailCategoryApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityDetailCategoryGet(organisationId?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<EntityDetailCategoryDto>> {
            return localVarFp.apiEntityDetailCategoryGet(organisationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertEntityDetailCategoryRequest} [upsertEntityDetailCategoryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityDetailCategoryPost(upsertEntityDetailCategoryRequest?: UpsertEntityDetailCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityDetailCategoryDto> {
            return localVarFp.apiEntityDetailCategoryPost(upsertEntityDetailCategoryRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EntityDetailCategoryApi - object-oriented interface
 * @export
 * @class EntityDetailCategoryApi
 * @extends {BaseAPI}
 */
export class EntityDetailCategoryApi extends BaseAPI {
    /**
     * 
     * @param {number} [organisationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityDetailCategoryApi
     */
    public apiEntityDetailCategoryGet(organisationId?: number, options?: RawAxiosRequestConfig) {
        return EntityDetailCategoryApiFp(this.configuration).apiEntityDetailCategoryGet(organisationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpsertEntityDetailCategoryRequest} [upsertEntityDetailCategoryRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityDetailCategoryApi
     */
    public apiEntityDetailCategoryPost(upsertEntityDetailCategoryRequest?: UpsertEntityDetailCategoryRequest, options?: RawAxiosRequestConfig) {
        return EntityDetailCategoryApiFp(this.configuration).apiEntityDetailCategoryPost(upsertEntityDetailCategoryRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EntityDetailCategoryAssociationApi - axios parameter creator
 * @export
 */
export const EntityDetailCategoryAssociationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {MergeEntityDetailCategoryAssociationRequest} [mergeEntityDetailCategoryAssociationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityDetailCategoryAssociationPost: async (mergeEntityDetailCategoryAssociationRequest?: MergeEntityDetailCategoryAssociationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/EntityDetailCategoryAssociation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mergeEntityDetailCategoryAssociationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EntityDetailCategoryAssociationApi - functional programming interface
 * @export
 */
export const EntityDetailCategoryAssociationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EntityDetailCategoryAssociationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {MergeEntityDetailCategoryAssociationRequest} [mergeEntityDetailCategoryAssociationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityDetailCategoryAssociationPost(mergeEntityDetailCategoryAssociationRequest?: MergeEntityDetailCategoryAssociationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityDetailCategoryAssociationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityDetailCategoryAssociationPost(mergeEntityDetailCategoryAssociationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityDetailCategoryAssociationApi.apiEntityDetailCategoryAssociationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EntityDetailCategoryAssociationApi - factory interface
 * @export
 */
export const EntityDetailCategoryAssociationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EntityDetailCategoryAssociationApiFp(configuration)
    return {
        /**
         * 
         * @param {MergeEntityDetailCategoryAssociationRequest} [mergeEntityDetailCategoryAssociationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityDetailCategoryAssociationPost(mergeEntityDetailCategoryAssociationRequest?: MergeEntityDetailCategoryAssociationRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityDetailCategoryAssociationDto> {
            return localVarFp.apiEntityDetailCategoryAssociationPost(mergeEntityDetailCategoryAssociationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EntityDetailCategoryAssociationApi - object-oriented interface
 * @export
 * @class EntityDetailCategoryAssociationApi
 * @extends {BaseAPI}
 */
export class EntityDetailCategoryAssociationApi extends BaseAPI {
    /**
     * 
     * @param {MergeEntityDetailCategoryAssociationRequest} [mergeEntityDetailCategoryAssociationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityDetailCategoryAssociationApi
     */
    public apiEntityDetailCategoryAssociationPost(mergeEntityDetailCategoryAssociationRequest?: MergeEntityDetailCategoryAssociationRequest, options?: RawAxiosRequestConfig) {
        return EntityDetailCategoryAssociationApiFp(this.configuration).apiEntityDetailCategoryAssociationPost(mergeEntityDetailCategoryAssociationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EntityDetailConfigApi - axios parameter creator
 * @export
 */
export const EntityDetailConfigApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {EntityTypeCode} [entityTypeCode] 
         * @param {number} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityDetailConfigDefaultEntityDetailsGet: async (entityTypeCode?: EntityTypeCode, organisationId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/EntityDetailConfig/default-entity-details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (entityTypeCode !== undefined) {
                localVarQueryParameter['entityTypeCode'] = entityTypeCode;
            }

            if (organisationId !== undefined) {
                localVarQueryParameter['organisationId'] = organisationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} entityDetailConfigId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityDetailConfigEntityDetailConfigIdResetDefaultValuePost: async (entityDetailConfigId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityDetailConfigId' is not null or undefined
            assertParamExists('apiEntityDetailConfigEntityDetailConfigIdResetDefaultValuePost', 'entityDetailConfigId', entityDetailConfigId)
            const localVarPath = `/api/EntityDetailConfig/{entityDetailConfigId}/ResetDefaultValue`
                .replace(`{${"entityDetailConfigId"}}`, encodeURIComponent(String(entityDetailConfigId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertEntityDetailConfigRequest} [upsertEntityDetailConfigRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityDetailConfigPost: async (upsertEntityDetailConfigRequest?: UpsertEntityDetailConfigRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/EntityDetailConfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertEntityDetailConfigRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SetVisibleConfigRequest} [setVisibleConfigRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityDetailConfigSetVisibleConfigPost: async (setVisibleConfigRequest?: SetVisibleConfigRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/EntityDetailConfig/SetVisibleConfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setVisibleConfigRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EntityDetailConfigApi - functional programming interface
 * @export
 */
export const EntityDetailConfigApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EntityDetailConfigApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {EntityTypeCode} [entityTypeCode] 
         * @param {number} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityDetailConfigDefaultEntityDetailsGet(entityTypeCode?: EntityTypeCode, organisationId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityDetailData>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityDetailConfigDefaultEntityDetailsGet(entityTypeCode, organisationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityDetailConfigApi.apiEntityDetailConfigDefaultEntityDetailsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} entityDetailConfigId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityDetailConfigEntityDetailConfigIdResetDefaultValuePost(entityDetailConfigId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityDetailConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityDetailConfigEntityDetailConfigIdResetDefaultValuePost(entityDetailConfigId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityDetailConfigApi.apiEntityDetailConfigEntityDetailConfigIdResetDefaultValuePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertEntityDetailConfigRequest} [upsertEntityDetailConfigRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityDetailConfigPost(upsertEntityDetailConfigRequest?: UpsertEntityDetailConfigRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityDetailConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityDetailConfigPost(upsertEntityDetailConfigRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityDetailConfigApi.apiEntityDetailConfigPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SetVisibleConfigRequest} [setVisibleConfigRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityDetailConfigSetVisibleConfigPost(setVisibleConfigRequest?: SetVisibleConfigRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityDetailConfigSetVisibleConfigPost(setVisibleConfigRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityDetailConfigApi.apiEntityDetailConfigSetVisibleConfigPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EntityDetailConfigApi - factory interface
 * @export
 */
export const EntityDetailConfigApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EntityDetailConfigApiFp(configuration)
    return {
        /**
         * 
         * @param {EntityTypeCode} [entityTypeCode] 
         * @param {number} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityDetailConfigDefaultEntityDetailsGet(entityTypeCode?: EntityTypeCode, organisationId?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<EntityDetailData>> {
            return localVarFp.apiEntityDetailConfigDefaultEntityDetailsGet(entityTypeCode, organisationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} entityDetailConfigId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityDetailConfigEntityDetailConfigIdResetDefaultValuePost(entityDetailConfigId: number, options?: RawAxiosRequestConfig): AxiosPromise<EntityDetailConfigDto> {
            return localVarFp.apiEntityDetailConfigEntityDetailConfigIdResetDefaultValuePost(entityDetailConfigId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertEntityDetailConfigRequest} [upsertEntityDetailConfigRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityDetailConfigPost(upsertEntityDetailConfigRequest?: UpsertEntityDetailConfigRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityDetailConfigDto> {
            return localVarFp.apiEntityDetailConfigPost(upsertEntityDetailConfigRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SetVisibleConfigRequest} [setVisibleConfigRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityDetailConfigSetVisibleConfigPost(setVisibleConfigRequest?: SetVisibleConfigRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiEntityDetailConfigSetVisibleConfigPost(setVisibleConfigRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EntityDetailConfigApi - object-oriented interface
 * @export
 * @class EntityDetailConfigApi
 * @extends {BaseAPI}
 */
export class EntityDetailConfigApi extends BaseAPI {
    /**
     * 
     * @param {EntityTypeCode} [entityTypeCode] 
     * @param {number} [organisationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityDetailConfigApi
     */
    public apiEntityDetailConfigDefaultEntityDetailsGet(entityTypeCode?: EntityTypeCode, organisationId?: number, options?: RawAxiosRequestConfig) {
        return EntityDetailConfigApiFp(this.configuration).apiEntityDetailConfigDefaultEntityDetailsGet(entityTypeCode, organisationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} entityDetailConfigId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityDetailConfigApi
     */
    public apiEntityDetailConfigEntityDetailConfigIdResetDefaultValuePost(entityDetailConfigId: number, options?: RawAxiosRequestConfig) {
        return EntityDetailConfigApiFp(this.configuration).apiEntityDetailConfigEntityDetailConfigIdResetDefaultValuePost(entityDetailConfigId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpsertEntityDetailConfigRequest} [upsertEntityDetailConfigRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityDetailConfigApi
     */
    public apiEntityDetailConfigPost(upsertEntityDetailConfigRequest?: UpsertEntityDetailConfigRequest, options?: RawAxiosRequestConfig) {
        return EntityDetailConfigApiFp(this.configuration).apiEntityDetailConfigPost(upsertEntityDetailConfigRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SetVisibleConfigRequest} [setVisibleConfigRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityDetailConfigApi
     */
    public apiEntityDetailConfigSetVisibleConfigPost(setVisibleConfigRequest?: SetVisibleConfigRequest, options?: RawAxiosRequestConfig) {
        return EntityDetailConfigApiFp(this.configuration).apiEntityDetailConfigSetVisibleConfigPost(setVisibleConfigRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EntityDetailEnhancerApi - axios parameter creator
 * @export
 */
export const EntityDetailEnhancerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [entityDetailEnhancerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityDetailEnhancerGetEntityDetailValueByEntityIdGet: async (entityDetailEnhancerId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/EntityDetailEnhancer/GetEntityDetailValueByEntityId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (entityDetailEnhancerId !== undefined) {
                localVarQueryParameter['entityDetailEnhancerId'] = entityDetailEnhancerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertEntityDetailEnhancerRequest} [upsertEntityDetailEnhancerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityDetailEnhancerPost: async (upsertEntityDetailEnhancerRequest?: UpsertEntityDetailEnhancerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/EntityDetailEnhancer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertEntityDetailEnhancerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PreviewValueEntityDetailEnhancerRequest} [previewValueEntityDetailEnhancerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityDetailEnhancerPreviewValuePost: async (previewValueEntityDetailEnhancerRequest?: PreviewValueEntityDetailEnhancerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/EntityDetailEnhancer/PreviewValue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(previewValueEntityDetailEnhancerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EntityDetailEnhancerApi - functional programming interface
 * @export
 */
export const EntityDetailEnhancerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EntityDetailEnhancerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [entityDetailEnhancerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityDetailEnhancerGetEntityDetailValueByEntityIdGet(entityDetailEnhancerId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityEnhancerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityDetailEnhancerGetEntityDetailValueByEntityIdGet(entityDetailEnhancerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityDetailEnhancerApi.apiEntityDetailEnhancerGetEntityDetailValueByEntityIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertEntityDetailEnhancerRequest} [upsertEntityDetailEnhancerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityDetailEnhancerPost(upsertEntityDetailEnhancerRequest?: UpsertEntityDetailEnhancerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityEnhancerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityDetailEnhancerPost(upsertEntityDetailEnhancerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityDetailEnhancerApi.apiEntityDetailEnhancerPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PreviewValueEntityDetailEnhancerRequest} [previewValueEntityDetailEnhancerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityDetailEnhancerPreviewValuePost(previewValueEntityDetailEnhancerRequest?: PreviewValueEntityDetailEnhancerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityDetailEnhancerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityDetailEnhancerPreviewValuePost(previewValueEntityDetailEnhancerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityDetailEnhancerApi.apiEntityDetailEnhancerPreviewValuePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EntityDetailEnhancerApi - factory interface
 * @export
 */
export const EntityDetailEnhancerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EntityDetailEnhancerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [entityDetailEnhancerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityDetailEnhancerGetEntityDetailValueByEntityIdGet(entityDetailEnhancerId?: number, options?: RawAxiosRequestConfig): AxiosPromise<EntityEnhancerDto> {
            return localVarFp.apiEntityDetailEnhancerGetEntityDetailValueByEntityIdGet(entityDetailEnhancerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertEntityDetailEnhancerRequest} [upsertEntityDetailEnhancerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityDetailEnhancerPost(upsertEntityDetailEnhancerRequest?: UpsertEntityDetailEnhancerRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityEnhancerDto> {
            return localVarFp.apiEntityDetailEnhancerPost(upsertEntityDetailEnhancerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PreviewValueEntityDetailEnhancerRequest} [previewValueEntityDetailEnhancerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityDetailEnhancerPreviewValuePost(previewValueEntityDetailEnhancerRequest?: PreviewValueEntityDetailEnhancerRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityDetailEnhancerDto> {
            return localVarFp.apiEntityDetailEnhancerPreviewValuePost(previewValueEntityDetailEnhancerRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EntityDetailEnhancerApi - object-oriented interface
 * @export
 * @class EntityDetailEnhancerApi
 * @extends {BaseAPI}
 */
export class EntityDetailEnhancerApi extends BaseAPI {
    /**
     * 
     * @param {number} [entityDetailEnhancerId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityDetailEnhancerApi
     */
    public apiEntityDetailEnhancerGetEntityDetailValueByEntityIdGet(entityDetailEnhancerId?: number, options?: RawAxiosRequestConfig) {
        return EntityDetailEnhancerApiFp(this.configuration).apiEntityDetailEnhancerGetEntityDetailValueByEntityIdGet(entityDetailEnhancerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpsertEntityDetailEnhancerRequest} [upsertEntityDetailEnhancerRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityDetailEnhancerApi
     */
    public apiEntityDetailEnhancerPost(upsertEntityDetailEnhancerRequest?: UpsertEntityDetailEnhancerRequest, options?: RawAxiosRequestConfig) {
        return EntityDetailEnhancerApiFp(this.configuration).apiEntityDetailEnhancerPost(upsertEntityDetailEnhancerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PreviewValueEntityDetailEnhancerRequest} [previewValueEntityDetailEnhancerRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityDetailEnhancerApi
     */
    public apiEntityDetailEnhancerPreviewValuePost(previewValueEntityDetailEnhancerRequest?: PreviewValueEntityDetailEnhancerRequest, options?: RawAxiosRequestConfig) {
        return EntityDetailEnhancerApiFp(this.configuration).apiEntityDetailEnhancerPreviewValuePost(previewValueEntityDetailEnhancerRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EntityDetailValueApi - axios parameter creator
 * @export
 */
export const EntityDetailValueApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityDetailValueGetEntityDetailValueByEntityIdGet: async (entityId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/EntityDetailValue/GetEntityDetailValueByEntityId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (entityId !== undefined) {
                localVarQueryParameter['EntityId'] = entityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertEntityDetailValueRequest} [upsertEntityDetailValueRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityDetailValuePost: async (upsertEntityDetailValueRequest?: UpsertEntityDetailValueRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/EntityDetailValue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertEntityDetailValueRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EntityDetailValueApi - functional programming interface
 * @export
 */
export const EntityDetailValueApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EntityDetailValueApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityDetailValueGetEntityDetailValueByEntityIdGet(entityId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityDetailValueDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityDetailValueGetEntityDetailValueByEntityIdGet(entityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityDetailValueApi.apiEntityDetailValueGetEntityDetailValueByEntityIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertEntityDetailValueRequest} [upsertEntityDetailValueRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityDetailValuePost(upsertEntityDetailValueRequest?: UpsertEntityDetailValueRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityDetailValueDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityDetailValuePost(upsertEntityDetailValueRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityDetailValueApi.apiEntityDetailValuePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EntityDetailValueApi - factory interface
 * @export
 */
export const EntityDetailValueApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EntityDetailValueApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityDetailValueGetEntityDetailValueByEntityIdGet(entityId?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<EntityDetailValueDto>> {
            return localVarFp.apiEntityDetailValueGetEntityDetailValueByEntityIdGet(entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertEntityDetailValueRequest} [upsertEntityDetailValueRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityDetailValuePost(upsertEntityDetailValueRequest?: UpsertEntityDetailValueRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<EntityDetailValueDto>> {
            return localVarFp.apiEntityDetailValuePost(upsertEntityDetailValueRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EntityDetailValueApi - object-oriented interface
 * @export
 * @class EntityDetailValueApi
 * @extends {BaseAPI}
 */
export class EntityDetailValueApi extends BaseAPI {
    /**
     * 
     * @param {number} [entityId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityDetailValueApi
     */
    public apiEntityDetailValueGetEntityDetailValueByEntityIdGet(entityId?: number, options?: RawAxiosRequestConfig) {
        return EntityDetailValueApiFp(this.configuration).apiEntityDetailValueGetEntityDetailValueByEntityIdGet(entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpsertEntityDetailValueRequest} [upsertEntityDetailValueRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityDetailValueApi
     */
    public apiEntityDetailValuePost(upsertEntityDetailValueRequest?: UpsertEntityDetailValueRequest, options?: RawAxiosRequestConfig) {
        return EntityDetailValueApiFp(this.configuration).apiEntityDetailValuePost(upsertEntityDetailValueRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EntityKeyApi - axios parameter creator
 * @export
 */
export const EntityKeyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityKeyDeleteEntityKeyDelete: async (body?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/EntityKey/DeleteEntityKey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertEntityKeyRequest} [upsertEntityKeyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityKeyUpsertEntityKeyPost: async (upsertEntityKeyRequest?: UpsertEntityKeyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/EntityKey/UpsertEntityKey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertEntityKeyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EntityKeyApi - functional programming interface
 * @export
 */
export const EntityKeyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EntityKeyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityKeyDeleteEntityKeyDelete(body?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityKeyDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityKeyDeleteEntityKeyDelete(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityKeyApi.apiEntityKeyDeleteEntityKeyDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertEntityKeyRequest} [upsertEntityKeyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityKeyUpsertEntityKeyPost(upsertEntityKeyRequest?: UpsertEntityKeyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityKeyDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityKeyUpsertEntityKeyPost(upsertEntityKeyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityKeyApi.apiEntityKeyUpsertEntityKeyPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EntityKeyApi - factory interface
 * @export
 */
export const EntityKeyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EntityKeyApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityKeyDeleteEntityKeyDelete(body?: number, options?: RawAxiosRequestConfig): AxiosPromise<EntityKeyDto> {
            return localVarFp.apiEntityKeyDeleteEntityKeyDelete(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertEntityKeyRequest} [upsertEntityKeyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityKeyUpsertEntityKeyPost(upsertEntityKeyRequest?: UpsertEntityKeyRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityKeyDto> {
            return localVarFp.apiEntityKeyUpsertEntityKeyPost(upsertEntityKeyRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EntityKeyApi - object-oriented interface
 * @export
 * @class EntityKeyApi
 * @extends {BaseAPI}
 */
export class EntityKeyApi extends BaseAPI {
    /**
     * 
     * @param {number} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityKeyApi
     */
    public apiEntityKeyDeleteEntityKeyDelete(body?: number, options?: RawAxiosRequestConfig) {
        return EntityKeyApiFp(this.configuration).apiEntityKeyDeleteEntityKeyDelete(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpsertEntityKeyRequest} [upsertEntityKeyRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityKeyApi
     */
    public apiEntityKeyUpsertEntityKeyPost(upsertEntityKeyRequest?: UpsertEntityKeyRequest, options?: RawAxiosRequestConfig) {
        return EntityKeyApiFp(this.configuration).apiEntityKeyUpsertEntityKeyPost(upsertEntityKeyRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EntityTransferApi - axios parameter creator
 * @export
 */
export const EntityTransferApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [entityTransferId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityTransferDelete: async (entityTransferId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/EntityTransfer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (entityTransferId !== undefined) {
                localVarQueryParameter['entityTransferId'] = entityTransferId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [entityTransferId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityTransferGet: async (entityTransferId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/EntityTransfer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (entityTransferId !== undefined) {
                localVarQueryParameter['entityTransferId'] = entityTransferId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [transferFromEnterpriseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityTransferGetEntityTransferByFromEntityIdGet: async (transferFromEnterpriseId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/EntityTransfer/GetEntityTransferByFromEntityId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (transferFromEnterpriseId !== undefined) {
                localVarQueryParameter['transferFromEnterpriseId'] = transferFromEnterpriseId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [transferToEnterpriseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityTransferGetEntityTransferByToEntityIdGet: async (transferToEnterpriseId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/EntityTransfer/GetEntityTransferByToEntityId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (transferToEnterpriseId !== undefined) {
                localVarQueryParameter['transferToEnterpriseId'] = transferToEnterpriseId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertEntityTransfersRequest} [upsertEntityTransfersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityTransferPost: async (upsertEntityTransfersRequest?: UpsertEntityTransfersRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/EntityTransfer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertEntityTransfersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EntityTransferSearchRequest} [entityTransferSearchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityTransferSearchPost: async (entityTransferSearchRequest?: EntityTransferSearchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/EntityTransfer/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityTransferSearchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EntityTransferApi - functional programming interface
 * @export
 */
export const EntityTransferApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EntityTransferApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [entityTransferId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityTransferDelete(entityTransferId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityTransferDelete(entityTransferId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityTransferApi.apiEntityTransferDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [entityTransferId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityTransferGet(entityTransferId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityTransferDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityTransferGet(entityTransferId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityTransferApi.apiEntityTransferGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [transferFromEnterpriseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityTransferGetEntityTransferByFromEntityIdGet(transferFromEnterpriseId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityTransferDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityTransferGetEntityTransferByFromEntityIdGet(transferFromEnterpriseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityTransferApi.apiEntityTransferGetEntityTransferByFromEntityIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [transferToEnterpriseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityTransferGetEntityTransferByToEntityIdGet(transferToEnterpriseId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityTransferDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityTransferGetEntityTransferByToEntityIdGet(transferToEnterpriseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityTransferApi.apiEntityTransferGetEntityTransferByToEntityIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertEntityTransfersRequest} [upsertEntityTransfersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityTransferPost(upsertEntityTransfersRequest?: UpsertEntityTransfersRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityTransferDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityTransferPost(upsertEntityTransfersRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityTransferApi.apiEntityTransferPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EntityTransferSearchRequest} [entityTransferSearchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityTransferSearchPost(entityTransferSearchRequest?: EntityTransferSearchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityTransferDtoPagedResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityTransferSearchPost(entityTransferSearchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityTransferApi.apiEntityTransferSearchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EntityTransferApi - factory interface
 * @export
 */
export const EntityTransferApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EntityTransferApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [entityTransferId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityTransferDelete(entityTransferId?: number, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiEntityTransferDelete(entityTransferId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [entityTransferId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityTransferGet(entityTransferId?: number, options?: RawAxiosRequestConfig): AxiosPromise<EntityTransferDto> {
            return localVarFp.apiEntityTransferGet(entityTransferId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [transferFromEnterpriseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityTransferGetEntityTransferByFromEntityIdGet(transferFromEnterpriseId?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<EntityTransferDto>> {
            return localVarFp.apiEntityTransferGetEntityTransferByFromEntityIdGet(transferFromEnterpriseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [transferToEnterpriseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityTransferGetEntityTransferByToEntityIdGet(transferToEnterpriseId?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<EntityTransferDto>> {
            return localVarFp.apiEntityTransferGetEntityTransferByToEntityIdGet(transferToEnterpriseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertEntityTransfersRequest} [upsertEntityTransfersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityTransferPost(upsertEntityTransfersRequest?: UpsertEntityTransfersRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityTransferDto> {
            return localVarFp.apiEntityTransferPost(upsertEntityTransfersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EntityTransferSearchRequest} [entityTransferSearchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityTransferSearchPost(entityTransferSearchRequest?: EntityTransferSearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityTransferDtoPagedResult> {
            return localVarFp.apiEntityTransferSearchPost(entityTransferSearchRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EntityTransferApi - object-oriented interface
 * @export
 * @class EntityTransferApi
 * @extends {BaseAPI}
 */
export class EntityTransferApi extends BaseAPI {
    /**
     * 
     * @param {number} [entityTransferId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityTransferApi
     */
    public apiEntityTransferDelete(entityTransferId?: number, options?: RawAxiosRequestConfig) {
        return EntityTransferApiFp(this.configuration).apiEntityTransferDelete(entityTransferId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [entityTransferId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityTransferApi
     */
    public apiEntityTransferGet(entityTransferId?: number, options?: RawAxiosRequestConfig) {
        return EntityTransferApiFp(this.configuration).apiEntityTransferGet(entityTransferId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [transferFromEnterpriseId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityTransferApi
     */
    public apiEntityTransferGetEntityTransferByFromEntityIdGet(transferFromEnterpriseId?: number, options?: RawAxiosRequestConfig) {
        return EntityTransferApiFp(this.configuration).apiEntityTransferGetEntityTransferByFromEntityIdGet(transferFromEnterpriseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [transferToEnterpriseId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityTransferApi
     */
    public apiEntityTransferGetEntityTransferByToEntityIdGet(transferToEnterpriseId?: number, options?: RawAxiosRequestConfig) {
        return EntityTransferApiFp(this.configuration).apiEntityTransferGetEntityTransferByToEntityIdGet(transferToEnterpriseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpsertEntityTransfersRequest} [upsertEntityTransfersRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityTransferApi
     */
    public apiEntityTransferPost(upsertEntityTransfersRequest?: UpsertEntityTransfersRequest, options?: RawAxiosRequestConfig) {
        return EntityTransferApiFp(this.configuration).apiEntityTransferPost(upsertEntityTransfersRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EntityTransferSearchRequest} [entityTransferSearchRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityTransferApi
     */
    public apiEntityTransferSearchPost(entityTransferSearchRequest?: EntityTransferSearchRequest, options?: RawAxiosRequestConfig) {
        return EntityTransferApiFp(this.configuration).apiEntityTransferSearchPost(entityTransferSearchRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EntityValidationDryRunApi - axios parameter creator
 * @export
 */
export const EntityValidationDryRunApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ValidateEntityDryRunRequest} [validateEntityDryRunRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityValidationDryRunValidatePost: async (validateEntityDryRunRequest?: ValidateEntityDryRunRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/EntityValidationDryRun/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validateEntityDryRunRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EntityValidationDryRunApi - functional programming interface
 * @export
 */
export const EntityValidationDryRunApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EntityValidationDryRunApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ValidateEntityDryRunRequest} [validateEntityDryRunRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEntityValidationDryRunValidatePost(validateEntityDryRunRequest?: ValidateEntityDryRunRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateEntityDryRunResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityValidationDryRunValidatePost(validateEntityDryRunRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntityValidationDryRunApi.apiEntityValidationDryRunValidatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EntityValidationDryRunApi - factory interface
 * @export
 */
export const EntityValidationDryRunApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EntityValidationDryRunApiFp(configuration)
    return {
        /**
         * 
         * @param {ValidateEntityDryRunRequest} [validateEntityDryRunRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEntityValidationDryRunValidatePost(validateEntityDryRunRequest?: ValidateEntityDryRunRequest, options?: RawAxiosRequestConfig): AxiosPromise<ValidateEntityDryRunResponse> {
            return localVarFp.apiEntityValidationDryRunValidatePost(validateEntityDryRunRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EntityValidationDryRunApi - object-oriented interface
 * @export
 * @class EntityValidationDryRunApi
 * @extends {BaseAPI}
 */
export class EntityValidationDryRunApi extends BaseAPI {
    /**
     * 
     * @param {ValidateEntityDryRunRequest} [validateEntityDryRunRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityValidationDryRunApi
     */
    public apiEntityValidationDryRunValidatePost(validateEntityDryRunRequest?: ValidateEntityDryRunRequest, options?: RawAxiosRequestConfig) {
        return EntityValidationDryRunApiFp(this.configuration).apiEntityValidationDryRunValidatePost(validateEntityDryRunRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FeatureFlagTestApi - axios parameter creator
 * @export
 */
export const FeatureFlagTestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} userKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFeatureFlagTestUserKeyGet: async (userKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userKey' is not null or undefined
            assertParamExists('apiFeatureFlagTestUserKeyGet', 'userKey', userKey)
            const localVarPath = `/api/FeatureFlagTest/{userKey}`
                .replace(`{${"userKey"}}`, encodeURIComponent(String(userKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeatureFlagTestApi - functional programming interface
 * @export
 */
export const FeatureFlagTestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FeatureFlagTestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} userKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFeatureFlagTestUserKeyGet(userKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFeatureFlagTestUserKeyGet(userKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureFlagTestApi.apiFeatureFlagTestUserKeyGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FeatureFlagTestApi - factory interface
 * @export
 */
export const FeatureFlagTestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FeatureFlagTestApiFp(configuration)
    return {
        /**
         * 
         * @param {string} userKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFeatureFlagTestUserKeyGet(userKey: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiFeatureFlagTestUserKeyGet(userKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FeatureFlagTestApi - object-oriented interface
 * @export
 * @class FeatureFlagTestApi
 * @extends {BaseAPI}
 */
export class FeatureFlagTestApi extends BaseAPI {
    /**
     * 
     * @param {string} userKey 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureFlagTestApi
     */
    public apiFeatureFlagTestUserKeyGet(userKey: string, options?: RawAxiosRequestConfig) {
        return FeatureFlagTestApiFp(this.configuration).apiFeatureFlagTestUserKeyGet(userKey, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FeeApi - axios parameter creator
 * @export
 */
export const FeeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AddFeesRequest} [addFeesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFeeAddFeesPost: async (addFeesRequest?: AddFeesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Fee/AddFees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addFeesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteFeesRequest} [deleteFeesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFeeDeleteFeesPost: async (deleteFeesRequest?: DeleteFeesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Fee/DeleteFees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteFeesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFeeGetFeeByOrganisationIdGet: async (organisationId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Fee/GetFeeByOrganisationId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (organisationId !== undefined) {
                localVarQueryParameter['organisationId'] = organisationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeeApi - functional programming interface
 * @export
 */
export const FeeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FeeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AddFeesRequest} [addFeesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFeeAddFeesPost(addFeesRequest?: AddFeesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FeeDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFeeAddFeesPost(addFeesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeeApi.apiFeeAddFeesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeleteFeesRequest} [deleteFeesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFeeDeleteFeesPost(deleteFeesRequest?: DeleteFeesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FeeDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFeeDeleteFeesPost(deleteFeesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeeApi.apiFeeDeleteFeesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFeeGetFeeByOrganisationIdGet(organisationId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FeeDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFeeGetFeeByOrganisationIdGet(organisationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeeApi.apiFeeGetFeeByOrganisationIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FeeApi - factory interface
 * @export
 */
export const FeeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FeeApiFp(configuration)
    return {
        /**
         * 
         * @param {AddFeesRequest} [addFeesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFeeAddFeesPost(addFeesRequest?: AddFeesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<FeeDto>> {
            return localVarFp.apiFeeAddFeesPost(addFeesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteFeesRequest} [deleteFeesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFeeDeleteFeesPost(deleteFeesRequest?: DeleteFeesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<FeeDto>> {
            return localVarFp.apiFeeDeleteFeesPost(deleteFeesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFeeGetFeeByOrganisationIdGet(organisationId?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<FeeDto>> {
            return localVarFp.apiFeeGetFeeByOrganisationIdGet(organisationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FeeApi - object-oriented interface
 * @export
 * @class FeeApi
 * @extends {BaseAPI}
 */
export class FeeApi extends BaseAPI {
    /**
     * 
     * @param {AddFeesRequest} [addFeesRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeeApi
     */
    public apiFeeAddFeesPost(addFeesRequest?: AddFeesRequest, options?: RawAxiosRequestConfig) {
        return FeeApiFp(this.configuration).apiFeeAddFeesPost(addFeesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteFeesRequest} [deleteFeesRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeeApi
     */
    public apiFeeDeleteFeesPost(deleteFeesRequest?: DeleteFeesRequest, options?: RawAxiosRequestConfig) {
        return FeeApiFp(this.configuration).apiFeeDeleteFeesPost(deleteFeesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [organisationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeeApi
     */
    public apiFeeGetFeeByOrganisationIdGet(organisationId?: number, options?: RawAxiosRequestConfig) {
        return FeeApiFp(this.configuration).apiFeeGetFeeByOrganisationIdGet(organisationId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FormApi - axios parameter creator
 * @export
 */
export const FormApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [formId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormDelete: async (formId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Form`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (formId !== undefined) {
                localVarQueryParameter['formId'] = formId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DuplicateFormRequest} [duplicateFormRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormDuplicatePost: async (duplicateFormRequest?: DuplicateFormRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Form/duplicate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(duplicateFormRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormGetFormsByIdFormIdGet: async (formId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formId' is not null or undefined
            assertParamExists('apiFormGetFormsByIdFormIdGet', 'formId', formId)
            const localVarPath = `/api/Form/GetFormsById/{formId}`
                .replace(`{${"formId"}}`, encodeURIComponent(String(formId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormGetFormsByOrgGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Form/GetFormsByOrg`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} orgId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        apiFormGetFormsByOrgOrgIdGet: async (orgId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('apiFormGetFormsByOrgOrgIdGet', 'orgId', orgId)
            const localVarPath = `/api/Form/GetFormsByOrg/{orgId}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertFormRequest} [upsertFormRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormPost: async (upsertFormRequest?: UpsertFormRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Form`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertFormRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} screenId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormScreenIdGet: async (screenId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'screenId' is not null or undefined
            assertParamExists('apiFormScreenIdGet', 'screenId', screenId)
            const localVarPath = `/api/Form/{screenId}`
                .replace(`{${"screenId"}}`, encodeURIComponent(String(screenId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FormApi - functional programming interface
 * @export
 */
export const FormApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FormApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [formId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormDelete(formId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormDelete(formId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormApi.apiFormDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DuplicateFormRequest} [duplicateFormRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormDuplicatePost(duplicateFormRequest?: DuplicateFormRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormDuplicatePost(duplicateFormRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormApi.apiFormDuplicatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormGetFormsByIdFormIdGet(formId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FormDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormGetFormsByIdFormIdGet(formId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormApi.apiFormGetFormsByIdFormIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormGetFormsByOrgGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FormDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormGetFormsByOrgGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormApi.apiFormGetFormsByOrgGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} orgId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async apiFormGetFormsByOrgOrgIdGet(orgId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FormDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormGetFormsByOrgOrgIdGet(orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormApi.apiFormGetFormsByOrgOrgIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertFormRequest} [upsertFormRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormPost(upsertFormRequest?: UpsertFormRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormPost(upsertFormRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormApi.apiFormPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} screenId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormScreenIdGet(screenId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FormDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormScreenIdGet(screenId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormApi.apiFormScreenIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FormApi - factory interface
 * @export
 */
export const FormApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FormApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [formId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormDelete(formId?: number, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiFormDelete(formId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DuplicateFormRequest} [duplicateFormRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormDuplicatePost(duplicateFormRequest?: DuplicateFormRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormDto> {
            return localVarFp.apiFormDuplicatePost(duplicateFormRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormGetFormsByIdFormIdGet(formId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<FormDto>> {
            return localVarFp.apiFormGetFormsByIdFormIdGet(formId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormGetFormsByOrgGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<FormDto>> {
            return localVarFp.apiFormGetFormsByOrgGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} orgId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        apiFormGetFormsByOrgOrgIdGet(orgId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<FormDto>> {
            return localVarFp.apiFormGetFormsByOrgOrgIdGet(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertFormRequest} [upsertFormRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormPost(upsertFormRequest?: UpsertFormRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormDto> {
            return localVarFp.apiFormPost(upsertFormRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} screenId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormScreenIdGet(screenId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<FormDto>> {
            return localVarFp.apiFormScreenIdGet(screenId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FormApi - object-oriented interface
 * @export
 * @class FormApi
 * @extends {BaseAPI}
 */
export class FormApi extends BaseAPI {
    /**
     * 
     * @param {number} [formId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormApi
     */
    public apiFormDelete(formId?: number, options?: RawAxiosRequestConfig) {
        return FormApiFp(this.configuration).apiFormDelete(formId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DuplicateFormRequest} [duplicateFormRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormApi
     */
    public apiFormDuplicatePost(duplicateFormRequest?: DuplicateFormRequest, options?: RawAxiosRequestConfig) {
        return FormApiFp(this.configuration).apiFormDuplicatePost(duplicateFormRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} formId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormApi
     */
    public apiFormGetFormsByIdFormIdGet(formId: number, options?: RawAxiosRequestConfig) {
        return FormApiFp(this.configuration).apiFormGetFormsByIdFormIdGet(formId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormApi
     */
    public apiFormGetFormsByOrgGet(options?: RawAxiosRequestConfig) {
        return FormApiFp(this.configuration).apiFormGetFormsByOrgGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} orgId 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof FormApi
     */
    public apiFormGetFormsByOrgOrgIdGet(orgId: number, options?: RawAxiosRequestConfig) {
        return FormApiFp(this.configuration).apiFormGetFormsByOrgOrgIdGet(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpsertFormRequest} [upsertFormRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormApi
     */
    public apiFormPost(upsertFormRequest?: UpsertFormRequest, options?: RawAxiosRequestConfig) {
        return FormApiFp(this.configuration).apiFormPost(upsertFormRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} screenId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormApi
     */
    public apiFormScreenIdGet(screenId: number, options?: RawAxiosRequestConfig) {
        return FormApiFp(this.configuration).apiFormScreenIdGet(screenId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FormActionAssociationApi - axios parameter creator
 * @export
 */
export const FormActionAssociationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormActionAssociationByOrgGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/FormActionAssociation/ByOrg`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [orgId] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        apiFormActionAssociationByOrgIdGet: async (orgId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/FormActionAssociation/ByOrgId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (orgId !== undefined) {
                localVarQueryParameter['orgId'] = orgId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [formId] 
         * @param {ActionType} [actionType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormActionAssociationGet: async (formId?: number, actionType?: ActionType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/FormActionAssociation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (formId !== undefined) {
                localVarQueryParameter['formId'] = formId;
            }

            if (actionType !== undefined) {
                localVarQueryParameter['actionType'] = actionType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertFormActionAssociationRequest} [upsertFormActionAssociationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormActionAssociationUpsertFormActionAssociationPost: async (upsertFormActionAssociationRequest?: UpsertFormActionAssociationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/FormActionAssociation/UpsertFormActionAssociation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertFormActionAssociationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FormActionAssociationApi - functional programming interface
 * @export
 */
export const FormActionAssociationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FormActionAssociationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormActionAssociationByOrgGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FormActionAssociationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormActionAssociationByOrgGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormActionAssociationApi.apiFormActionAssociationByOrgGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [orgId] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async apiFormActionAssociationByOrgIdGet(orgId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FormActionAssociationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormActionAssociationByOrgIdGet(orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormActionAssociationApi.apiFormActionAssociationByOrgIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [formId] 
         * @param {ActionType} [actionType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormActionAssociationGet(formId?: number, actionType?: ActionType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormActionAssociationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormActionAssociationGet(formId, actionType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormActionAssociationApi.apiFormActionAssociationGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertFormActionAssociationRequest} [upsertFormActionAssociationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormActionAssociationUpsertFormActionAssociationPost(upsertFormActionAssociationRequest?: UpsertFormActionAssociationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormActionAssociationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormActionAssociationUpsertFormActionAssociationPost(upsertFormActionAssociationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormActionAssociationApi.apiFormActionAssociationUpsertFormActionAssociationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FormActionAssociationApi - factory interface
 * @export
 */
export const FormActionAssociationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FormActionAssociationApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormActionAssociationByOrgGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<FormActionAssociationDto>> {
            return localVarFp.apiFormActionAssociationByOrgGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [orgId] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        apiFormActionAssociationByOrgIdGet(orgId?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<FormActionAssociationDto>> {
            return localVarFp.apiFormActionAssociationByOrgIdGet(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [formId] 
         * @param {ActionType} [actionType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormActionAssociationGet(formId?: number, actionType?: ActionType, options?: RawAxiosRequestConfig): AxiosPromise<FormActionAssociationDto> {
            return localVarFp.apiFormActionAssociationGet(formId, actionType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertFormActionAssociationRequest} [upsertFormActionAssociationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormActionAssociationUpsertFormActionAssociationPost(upsertFormActionAssociationRequest?: UpsertFormActionAssociationRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormActionAssociationDto> {
            return localVarFp.apiFormActionAssociationUpsertFormActionAssociationPost(upsertFormActionAssociationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FormActionAssociationApi - object-oriented interface
 * @export
 * @class FormActionAssociationApi
 * @extends {BaseAPI}
 */
export class FormActionAssociationApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormActionAssociationApi
     */
    public apiFormActionAssociationByOrgGet(options?: RawAxiosRequestConfig) {
        return FormActionAssociationApiFp(this.configuration).apiFormActionAssociationByOrgGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [orgId] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof FormActionAssociationApi
     */
    public apiFormActionAssociationByOrgIdGet(orgId?: number, options?: RawAxiosRequestConfig) {
        return FormActionAssociationApiFp(this.configuration).apiFormActionAssociationByOrgIdGet(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [formId] 
     * @param {ActionType} [actionType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormActionAssociationApi
     */
    public apiFormActionAssociationGet(formId?: number, actionType?: ActionType, options?: RawAxiosRequestConfig) {
        return FormActionAssociationApiFp(this.configuration).apiFormActionAssociationGet(formId, actionType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpsertFormActionAssociationRequest} [upsertFormActionAssociationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormActionAssociationApi
     */
    public apiFormActionAssociationUpsertFormActionAssociationPost(upsertFormActionAssociationRequest?: UpsertFormActionAssociationRequest, options?: RawAxiosRequestConfig) {
        return FormActionAssociationApiFp(this.configuration).apiFormActionAssociationUpsertFormActionAssociationPost(upsertFormActionAssociationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * IdentGenerationRuleApi - axios parameter creator
 * @export
 */
export const IdentGenerationRuleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentGenerationRuleByOrganisationGet: async (organisationId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/IdentGenerationRule/by-organisation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (organisationId !== undefined) {
                localVarQueryParameter['organisationId'] = organisationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentGenerationRuleDelete: async (id?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/IdentGenerationRule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertIdentGenerationRuleRequest} [upsertIdentGenerationRuleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentGenerationRuleUpsertPost: async (upsertIdentGenerationRuleRequest?: UpsertIdentGenerationRuleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/IdentGenerationRule/upsert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertIdentGenerationRuleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IdentGenerationRuleApi - functional programming interface
 * @export
 */
export const IdentGenerationRuleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IdentGenerationRuleApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentGenerationRuleByOrganisationGet(organisationId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentGenerationRuleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentGenerationRuleByOrganisationGet(organisationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IdentGenerationRuleApi.apiIdentGenerationRuleByOrganisationGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentGenerationRuleDelete(id?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentGenerationRuleDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IdentGenerationRuleApi.apiIdentGenerationRuleDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertIdentGenerationRuleRequest} [upsertIdentGenerationRuleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentGenerationRuleUpsertPost(upsertIdentGenerationRuleRequest?: UpsertIdentGenerationRuleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentGenerationRuleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentGenerationRuleUpsertPost(upsertIdentGenerationRuleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IdentGenerationRuleApi.apiIdentGenerationRuleUpsertPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * IdentGenerationRuleApi - factory interface
 * @export
 */
export const IdentGenerationRuleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IdentGenerationRuleApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentGenerationRuleByOrganisationGet(organisationId?: number, options?: RawAxiosRequestConfig): AxiosPromise<IdentGenerationRuleDto> {
            return localVarFp.apiIdentGenerationRuleByOrganisationGet(organisationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentGenerationRuleDelete(id?: number, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiIdentGenerationRuleDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertIdentGenerationRuleRequest} [upsertIdentGenerationRuleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentGenerationRuleUpsertPost(upsertIdentGenerationRuleRequest?: UpsertIdentGenerationRuleRequest, options?: RawAxiosRequestConfig): AxiosPromise<IdentGenerationRuleDto> {
            return localVarFp.apiIdentGenerationRuleUpsertPost(upsertIdentGenerationRuleRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IdentGenerationRuleApi - object-oriented interface
 * @export
 * @class IdentGenerationRuleApi
 * @extends {BaseAPI}
 */
export class IdentGenerationRuleApi extends BaseAPI {
    /**
     * 
     * @param {number} [organisationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentGenerationRuleApi
     */
    public apiIdentGenerationRuleByOrganisationGet(organisationId?: number, options?: RawAxiosRequestConfig) {
        return IdentGenerationRuleApiFp(this.configuration).apiIdentGenerationRuleByOrganisationGet(organisationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentGenerationRuleApi
     */
    public apiIdentGenerationRuleDelete(id?: number, options?: RawAxiosRequestConfig) {
        return IdentGenerationRuleApiFp(this.configuration).apiIdentGenerationRuleDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpsertIdentGenerationRuleRequest} [upsertIdentGenerationRuleRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentGenerationRuleApi
     */
    public apiIdentGenerationRuleUpsertPost(upsertIdentGenerationRuleRequest?: UpsertIdentGenerationRuleRequest, options?: RawAxiosRequestConfig) {
        return IdentGenerationRuleApiFp(this.configuration).apiIdentGenerationRuleUpsertPost(upsertIdentGenerationRuleRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ImportBatchApi - axios parameter creator
 * @export
 */
export const ImportBatchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [enterpriseId] 
         * @param {File} [file] 
         * @param {DocumentTypeCode} [documentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportBatchCreateWithDocumentPost: async (enterpriseId?: number, file?: File, documentType?: DocumentTypeCode, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ImportBatch/create-with-document`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (enterpriseId !== undefined) { 
                localVarFormParams.append('EnterpriseId', enterpriseId as any);
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }
    
            if (documentType !== undefined) { 
                localVarFormParams.append('DocumentType', documentType as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} paginationCurrentPage 
         * @param {number} paginationPageSize 
         * @param {string} [search] 
         * @param {boolean} [includeCompleted] 
         * @param {string} [sortBy] 
         * @param {SortDirectionOrder} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportBatchGet: async (paginationCurrentPage: number, paginationPageSize: number, search?: string, includeCompleted?: boolean, sortBy?: string, sortDirection?: SortDirectionOrder, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paginationCurrentPage' is not null or undefined
            assertParamExists('apiImportBatchGet', 'paginationCurrentPage', paginationCurrentPage)
            // verify required parameter 'paginationPageSize' is not null or undefined
            assertParamExists('apiImportBatchGet', 'paginationPageSize', paginationPageSize)
            const localVarPath = `/api/ImportBatch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (search !== undefined) {
                localVarQueryParameter['Search'] = search;
            }

            if (includeCompleted !== undefined) {
                localVarQueryParameter['IncludeCompleted'] = includeCompleted;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (paginationCurrentPage !== undefined) {
                localVarQueryParameter['Pagination.CurrentPage'] = paginationCurrentPage;
            }

            if (paginationPageSize !== undefined) {
                localVarQueryParameter['Pagination.PageSize'] = paginationPageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} importBatchGuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportBatchImportBatchGuidDelete: async (importBatchGuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'importBatchGuid' is not null or undefined
            assertParamExists('apiImportBatchImportBatchGuidDelete', 'importBatchGuid', importBatchGuid)
            const localVarPath = `/api/ImportBatch/{importBatchGuid}`
                .replace(`{${"importBatchGuid"}}`, encodeURIComponent(String(importBatchGuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} importBatchGuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportBatchImportBatchGuidGet: async (importBatchGuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'importBatchGuid' is not null or undefined
            assertParamExists('apiImportBatchImportBatchGuidGet', 'importBatchGuid', importBatchGuid)
            const localVarPath = `/api/ImportBatch/{importBatchGuid}`
                .replace(`{${"importBatchGuid"}}`, encodeURIComponent(String(importBatchGuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} importBatchId 
         * @param {FinaliseImportBatchRequest} [finaliseImportBatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportBatchImportBatchIdFinalisePost: async (importBatchId: number, finaliseImportBatchRequest?: FinaliseImportBatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'importBatchId' is not null or undefined
            assertParamExists('apiImportBatchImportBatchIdFinalisePost', 'importBatchId', importBatchId)
            const localVarPath = `/api/ImportBatch/{importBatchId}/finalise`
                .replace(`{${"importBatchId"}}`, encodeURIComponent(String(importBatchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(finaliseImportBatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertImportBatchRequest} [upsertImportBatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportBatchUpsertPost: async (upsertImportBatchRequest?: UpsertImportBatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ImportBatch/upsert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertImportBatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ImportBatchApi - functional programming interface
 * @export
 */
export const ImportBatchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ImportBatchApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [enterpriseId] 
         * @param {File} [file] 
         * @param {DocumentTypeCode} [documentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiImportBatchCreateWithDocumentPost(enterpriseId?: number, file?: File, documentType?: DocumentTypeCode, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiImportBatchCreateWithDocumentPost(enterpriseId, file, documentType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImportBatchApi.apiImportBatchCreateWithDocumentPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} paginationCurrentPage 
         * @param {number} paginationPageSize 
         * @param {string} [search] 
         * @param {boolean} [includeCompleted] 
         * @param {string} [sortBy] 
         * @param {SortDirectionOrder} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiImportBatchGet(paginationCurrentPage: number, paginationPageSize: number, search?: string, includeCompleted?: boolean, sortBy?: string, sortDirection?: SortDirectionOrder, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportBatchDtoPagedResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiImportBatchGet(paginationCurrentPage, paginationPageSize, search, includeCompleted, sortBy, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImportBatchApi.apiImportBatchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} importBatchGuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiImportBatchImportBatchGuidDelete(importBatchGuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiImportBatchImportBatchGuidDelete(importBatchGuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImportBatchApi.apiImportBatchImportBatchGuidDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} importBatchGuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiImportBatchImportBatchGuidGet(importBatchGuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiImportBatchImportBatchGuidGet(importBatchGuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImportBatchApi.apiImportBatchImportBatchGuidGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} importBatchId 
         * @param {FinaliseImportBatchRequest} [finaliseImportBatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiImportBatchImportBatchIdFinalisePost(importBatchId: number, finaliseImportBatchRequest?: FinaliseImportBatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportBatchDtoResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiImportBatchImportBatchIdFinalisePost(importBatchId, finaliseImportBatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImportBatchApi.apiImportBatchImportBatchIdFinalisePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertImportBatchRequest} [upsertImportBatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiImportBatchUpsertPost(upsertImportBatchRequest?: UpsertImportBatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportBatchDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiImportBatchUpsertPost(upsertImportBatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImportBatchApi.apiImportBatchUpsertPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ImportBatchApi - factory interface
 * @export
 */
export const ImportBatchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ImportBatchApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [enterpriseId] 
         * @param {File} [file] 
         * @param {DocumentTypeCode} [documentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportBatchCreateWithDocumentPost(enterpriseId?: number, file?: File, documentType?: DocumentTypeCode, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiImportBatchCreateWithDocumentPost(enterpriseId, file, documentType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} paginationCurrentPage 
         * @param {number} paginationPageSize 
         * @param {string} [search] 
         * @param {boolean} [includeCompleted] 
         * @param {string} [sortBy] 
         * @param {SortDirectionOrder} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportBatchGet(paginationCurrentPage: number, paginationPageSize: number, search?: string, includeCompleted?: boolean, sortBy?: string, sortDirection?: SortDirectionOrder, options?: RawAxiosRequestConfig): AxiosPromise<ImportBatchDtoPagedResult> {
            return localVarFp.apiImportBatchGet(paginationCurrentPage, paginationPageSize, search, includeCompleted, sortBy, sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} importBatchGuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportBatchImportBatchGuidDelete(importBatchGuid: string, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiImportBatchImportBatchGuidDelete(importBatchGuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} importBatchGuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportBatchImportBatchGuidGet(importBatchGuid: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiImportBatchImportBatchGuidGet(importBatchGuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} importBatchId 
         * @param {FinaliseImportBatchRequest} [finaliseImportBatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportBatchImportBatchIdFinalisePost(importBatchId: number, finaliseImportBatchRequest?: FinaliseImportBatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImportBatchDtoResult> {
            return localVarFp.apiImportBatchImportBatchIdFinalisePost(importBatchId, finaliseImportBatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertImportBatchRequest} [upsertImportBatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportBatchUpsertPost(upsertImportBatchRequest?: UpsertImportBatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImportBatchDto> {
            return localVarFp.apiImportBatchUpsertPost(upsertImportBatchRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ImportBatchApi - object-oriented interface
 * @export
 * @class ImportBatchApi
 * @extends {BaseAPI}
 */
export class ImportBatchApi extends BaseAPI {
    /**
     * 
     * @param {number} [enterpriseId] 
     * @param {File} [file] 
     * @param {DocumentTypeCode} [documentType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportBatchApi
     */
    public apiImportBatchCreateWithDocumentPost(enterpriseId?: number, file?: File, documentType?: DocumentTypeCode, options?: RawAxiosRequestConfig) {
        return ImportBatchApiFp(this.configuration).apiImportBatchCreateWithDocumentPost(enterpriseId, file, documentType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} paginationCurrentPage 
     * @param {number} paginationPageSize 
     * @param {string} [search] 
     * @param {boolean} [includeCompleted] 
     * @param {string} [sortBy] 
     * @param {SortDirectionOrder} [sortDirection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportBatchApi
     */
    public apiImportBatchGet(paginationCurrentPage: number, paginationPageSize: number, search?: string, includeCompleted?: boolean, sortBy?: string, sortDirection?: SortDirectionOrder, options?: RawAxiosRequestConfig) {
        return ImportBatchApiFp(this.configuration).apiImportBatchGet(paginationCurrentPage, paginationPageSize, search, includeCompleted, sortBy, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} importBatchGuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportBatchApi
     */
    public apiImportBatchImportBatchGuidDelete(importBatchGuid: string, options?: RawAxiosRequestConfig) {
        return ImportBatchApiFp(this.configuration).apiImportBatchImportBatchGuidDelete(importBatchGuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} importBatchGuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportBatchApi
     */
    public apiImportBatchImportBatchGuidGet(importBatchGuid: string, options?: RawAxiosRequestConfig) {
        return ImportBatchApiFp(this.configuration).apiImportBatchImportBatchGuidGet(importBatchGuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} importBatchId 
     * @param {FinaliseImportBatchRequest} [finaliseImportBatchRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportBatchApi
     */
    public apiImportBatchImportBatchIdFinalisePost(importBatchId: number, finaliseImportBatchRequest?: FinaliseImportBatchRequest, options?: RawAxiosRequestConfig) {
        return ImportBatchApiFp(this.configuration).apiImportBatchImportBatchIdFinalisePost(importBatchId, finaliseImportBatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpsertImportBatchRequest} [upsertImportBatchRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportBatchApi
     */
    public apiImportBatchUpsertPost(upsertImportBatchRequest?: UpsertImportBatchRequest, options?: RawAxiosRequestConfig) {
        return ImportBatchApiFp(this.configuration).apiImportBatchUpsertPost(upsertImportBatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InvitationApi - axios parameter creator
 * @export
 */
export const InvitationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ProcessInvitationRequest} [processInvitationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvitationProcessInvitationPost: async (processInvitationRequest?: ProcessInvitationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Invitation/ProcessInvitation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processInvitationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SendSocietyInvitationEmailRequest} [sendSocietyInvitationEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvitationSendSocietyInvitationEmailPost: async (sendSocietyInvitationEmailRequest?: SendSocietyInvitationEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Invitation/SendSocietyInvitationEmail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendSocietyInvitationEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvitationApi - functional programming interface
 * @export
 */
export const InvitationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InvitationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ProcessInvitationRequest} [processInvitationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInvitationProcessInvitationPost(processInvitationRequest?: ProcessInvitationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInvitationProcessInvitationPost(processInvitationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvitationApi.apiInvitationProcessInvitationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SendSocietyInvitationEmailRequest} [sendSocietyInvitationEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInvitationSendSocietyInvitationEmailPost(sendSocietyInvitationEmailRequest?: SendSocietyInvitationEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInvitationSendSocietyInvitationEmailPost(sendSocietyInvitationEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvitationApi.apiInvitationSendSocietyInvitationEmailPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InvitationApi - factory interface
 * @export
 */
export const InvitationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InvitationApiFp(configuration)
    return {
        /**
         * 
         * @param {ProcessInvitationRequest} [processInvitationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvitationProcessInvitationPost(processInvitationRequest?: ProcessInvitationRequest, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiInvitationProcessInvitationPost(processInvitationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SendSocietyInvitationEmailRequest} [sendSocietyInvitationEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvitationSendSocietyInvitationEmailPost(sendSocietyInvitationEmailRequest?: SendSocietyInvitationEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiInvitationSendSocietyInvitationEmailPost(sendSocietyInvitationEmailRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InvitationApi - object-oriented interface
 * @export
 * @class InvitationApi
 * @extends {BaseAPI}
 */
export class InvitationApi extends BaseAPI {
    /**
     * 
     * @param {ProcessInvitationRequest} [processInvitationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationApi
     */
    public apiInvitationProcessInvitationPost(processInvitationRequest?: ProcessInvitationRequest, options?: RawAxiosRequestConfig) {
        return InvitationApiFp(this.configuration).apiInvitationProcessInvitationPost(processInvitationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SendSocietyInvitationEmailRequest} [sendSocietyInvitationEmailRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationApi
     */
    public apiInvitationSendSocietyInvitationEmailPost(sendSocietyInvitationEmailRequest?: SendSocietyInvitationEmailRequest, options?: RawAxiosRequestConfig) {
        return InvitationApiFp(this.configuration).apiInvitationSendSocietyInvitationEmailPost(sendSocietyInvitationEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ItemCodeApi - axios parameter creator
 * @export
 */
export const ItemCodeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} itemCodeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiItemCodeItemCodeIdDelete: async (itemCodeId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'itemCodeId' is not null or undefined
            assertParamExists('apiItemCodeItemCodeIdDelete', 'itemCodeId', itemCodeId)
            const localVarPath = `/api/ItemCode/{itemCodeId}`
                .replace(`{${"itemCodeId"}}`, encodeURIComponent(String(itemCodeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} itemCodeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiItemCodeItemCodeIdGet: async (itemCodeId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'itemCodeId' is not null or undefined
            assertParamExists('apiItemCodeItemCodeIdGet', 'itemCodeId', itemCodeId)
            const localVarPath = `/api/ItemCode/{itemCodeId}`
                .replace(`{${"itemCodeId"}}`, encodeURIComponent(String(itemCodeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiItemCodeOrgOrgIdGet: async (orgId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('apiItemCodeOrgOrgIdGet', 'orgId', orgId)
            const localVarPath = `/api/ItemCode/Org/{orgId}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertItemCodeRequest} [upsertItemCodeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiItemCodePost: async (upsertItemCodeRequest?: UpsertItemCodeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ItemCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertItemCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ItemCodeApi - functional programming interface
 * @export
 */
export const ItemCodeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ItemCodeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} itemCodeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiItemCodeItemCodeIdDelete(itemCodeId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiItemCodeItemCodeIdDelete(itemCodeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ItemCodeApi.apiItemCodeItemCodeIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} itemCodeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiItemCodeItemCodeIdGet(itemCodeId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ItemCodeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiItemCodeItemCodeIdGet(itemCodeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ItemCodeApi.apiItemCodeItemCodeIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiItemCodeOrgOrgIdGet(orgId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ItemCodeDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiItemCodeOrgOrgIdGet(orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ItemCodeApi.apiItemCodeOrgOrgIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertItemCodeRequest} [upsertItemCodeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiItemCodePost(upsertItemCodeRequest?: UpsertItemCodeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ItemCodeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiItemCodePost(upsertItemCodeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ItemCodeApi.apiItemCodePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ItemCodeApi - factory interface
 * @export
 */
export const ItemCodeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ItemCodeApiFp(configuration)
    return {
        /**
         * 
         * @param {number} itemCodeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiItemCodeItemCodeIdDelete(itemCodeId: number, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiItemCodeItemCodeIdDelete(itemCodeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} itemCodeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiItemCodeItemCodeIdGet(itemCodeId: number, options?: RawAxiosRequestConfig): AxiosPromise<ItemCodeDto> {
            return localVarFp.apiItemCodeItemCodeIdGet(itemCodeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiItemCodeOrgOrgIdGet(orgId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ItemCodeDto>> {
            return localVarFp.apiItemCodeOrgOrgIdGet(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertItemCodeRequest} [upsertItemCodeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiItemCodePost(upsertItemCodeRequest?: UpsertItemCodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<ItemCodeDto> {
            return localVarFp.apiItemCodePost(upsertItemCodeRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ItemCodeApi - object-oriented interface
 * @export
 * @class ItemCodeApi
 * @extends {BaseAPI}
 */
export class ItemCodeApi extends BaseAPI {
    /**
     * 
     * @param {number} itemCodeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemCodeApi
     */
    public apiItemCodeItemCodeIdDelete(itemCodeId: number, options?: RawAxiosRequestConfig) {
        return ItemCodeApiFp(this.configuration).apiItemCodeItemCodeIdDelete(itemCodeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} itemCodeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemCodeApi
     */
    public apiItemCodeItemCodeIdGet(itemCodeId: number, options?: RawAxiosRequestConfig) {
        return ItemCodeApiFp(this.configuration).apiItemCodeItemCodeIdGet(itemCodeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} orgId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemCodeApi
     */
    public apiItemCodeOrgOrgIdGet(orgId: number, options?: RawAxiosRequestConfig) {
        return ItemCodeApiFp(this.configuration).apiItemCodeOrgOrgIdGet(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpsertItemCodeRequest} [upsertItemCodeRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemCodeApi
     */
    public apiItemCodePost(upsertItemCodeRequest?: UpsertItemCodeRequest, options?: RawAxiosRequestConfig) {
        return ItemCodeApiFp(this.configuration).apiItemCodePost(upsertItemCodeRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NoteApi - axios parameter creator
 * @export
 */
export const NoteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [noteId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNoteDelete: async (noteId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Note`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (noteId !== undefined) {
                localVarQueryParameter['noteId'] = noteId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [noteEntityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNoteGetNoteByEntityIdGet: async (noteEntityId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Note/GetNoteByEntityId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (noteEntityId !== undefined) {
                localVarQueryParameter['noteEntityId'] = noteEntityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [noteId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNoteGetNoteByIdGet: async (noteId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Note/GetNoteById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (noteId !== undefined) {
                localVarQueryParameter['noteId'] = noteId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertNoteRequest} [upsertNoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotePost: async (upsertNoteRequest?: UpsertNoteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Note`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertNoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {NoteSearchSortRequest} [noteSearchSortRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNoteSearchSortFilterNotePost: async (noteSearchSortRequest?: NoteSearchSortRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Note/SearchSortFilterNote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(noteSearchSortRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NoteApi - functional programming interface
 * @export
 */
export const NoteApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NoteApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [noteId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNoteDelete(noteId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNoteDelete(noteId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NoteApi.apiNoteDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [noteEntityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNoteGetNoteByEntityIdGet(noteEntityId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NoteDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNoteGetNoteByEntityIdGet(noteEntityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NoteApi.apiNoteGetNoteByEntityIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [noteId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNoteGetNoteByIdGet(noteId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NoteDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNoteGetNoteByIdGet(noteId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NoteApi.apiNoteGetNoteByIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertNoteRequest} [upsertNoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotePost(upsertNoteRequest?: UpsertNoteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NoteDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotePost(upsertNoteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NoteApi.apiNotePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {NoteSearchSortRequest} [noteSearchSortRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNoteSearchSortFilterNotePost(noteSearchSortRequest?: NoteSearchSortRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NoteDtoPagedResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNoteSearchSortFilterNotePost(noteSearchSortRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NoteApi.apiNoteSearchSortFilterNotePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NoteApi - factory interface
 * @export
 */
export const NoteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NoteApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [noteId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNoteDelete(noteId?: number, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiNoteDelete(noteId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [noteEntityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNoteGetNoteByEntityIdGet(noteEntityId?: string, options?: RawAxiosRequestConfig): AxiosPromise<NoteDto> {
            return localVarFp.apiNoteGetNoteByEntityIdGet(noteEntityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [noteId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNoteGetNoteByIdGet(noteId?: number, options?: RawAxiosRequestConfig): AxiosPromise<NoteDto> {
            return localVarFp.apiNoteGetNoteByIdGet(noteId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertNoteRequest} [upsertNoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotePost(upsertNoteRequest?: UpsertNoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<NoteDto> {
            return localVarFp.apiNotePost(upsertNoteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NoteSearchSortRequest} [noteSearchSortRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNoteSearchSortFilterNotePost(noteSearchSortRequest?: NoteSearchSortRequest, options?: RawAxiosRequestConfig): AxiosPromise<NoteDtoPagedResult> {
            return localVarFp.apiNoteSearchSortFilterNotePost(noteSearchSortRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NoteApi - object-oriented interface
 * @export
 * @class NoteApi
 * @extends {BaseAPI}
 */
export class NoteApi extends BaseAPI {
    /**
     * 
     * @param {number} [noteId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoteApi
     */
    public apiNoteDelete(noteId?: number, options?: RawAxiosRequestConfig) {
        return NoteApiFp(this.configuration).apiNoteDelete(noteId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [noteEntityId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoteApi
     */
    public apiNoteGetNoteByEntityIdGet(noteEntityId?: string, options?: RawAxiosRequestConfig) {
        return NoteApiFp(this.configuration).apiNoteGetNoteByEntityIdGet(noteEntityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [noteId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoteApi
     */
    public apiNoteGetNoteByIdGet(noteId?: number, options?: RawAxiosRequestConfig) {
        return NoteApiFp(this.configuration).apiNoteGetNoteByIdGet(noteId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpsertNoteRequest} [upsertNoteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoteApi
     */
    public apiNotePost(upsertNoteRequest?: UpsertNoteRequest, options?: RawAxiosRequestConfig) {
        return NoteApiFp(this.configuration).apiNotePost(upsertNoteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NoteSearchSortRequest} [noteSearchSortRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoteApi
     */
    public apiNoteSearchSortFilterNotePost(noteSearchSortRequest?: NoteSearchSortRequest, options?: RawAxiosRequestConfig) {
        return NoteApiFp(this.configuration).apiNoteSearchSortFilterNotePost(noteSearchSortRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrganisationApi - axios parameter creator
 * @export
 */
export const OrganisationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganisationByEntityIdGet: async (entityId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Organisation/ByEntityId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganisationGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Organisation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganisationGetOrganisationByIdGet: async (entityId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Organisation/GetOrganisationById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateOrganisationRequest} [updateOrganisationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganisationPatch: async (updateOrganisationRequest?: UpdateOrganisationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Organisation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrganisationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddOrganisationRequest} [addOrganisationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganisationPost: async (addOrganisationRequest?: AddOrganisationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Organisation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addOrganisationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganisationApi - functional programming interface
 * @export
 */
export const OrganisationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganisationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganisationByEntityIdGet(entityId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganisationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganisationByEntityIdGet(entityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationApi.apiOrganisationByEntityIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganisationGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganisationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganisationGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationApi.apiOrganisationGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganisationGetOrganisationByIdGet(entityId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganisationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganisationGetOrganisationByIdGet(entityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationApi.apiOrganisationGetOrganisationByIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateOrganisationRequest} [updateOrganisationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganisationPatch(updateOrganisationRequest?: UpdateOrganisationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganisationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganisationPatch(updateOrganisationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationApi.apiOrganisationPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AddOrganisationRequest} [addOrganisationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganisationPost(addOrganisationRequest?: AddOrganisationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganisationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganisationPost(addOrganisationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationApi.apiOrganisationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrganisationApi - factory interface
 * @export
 */
export const OrganisationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganisationApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganisationByEntityIdGet(entityId?: string, options?: RawAxiosRequestConfig): AxiosPromise<OrganisationDto> {
            return localVarFp.apiOrganisationByEntityIdGet(entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganisationGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<OrganisationDto>> {
            return localVarFp.apiOrganisationGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganisationGetOrganisationByIdGet(entityId?: number, options?: RawAxiosRequestConfig): AxiosPromise<OrganisationDto> {
            return localVarFp.apiOrganisationGetOrganisationByIdGet(entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateOrganisationRequest} [updateOrganisationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganisationPatch(updateOrganisationRequest?: UpdateOrganisationRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrganisationDto> {
            return localVarFp.apiOrganisationPatch(updateOrganisationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AddOrganisationRequest} [addOrganisationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganisationPost(addOrganisationRequest?: AddOrganisationRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrganisationDto> {
            return localVarFp.apiOrganisationPost(addOrganisationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganisationApi - object-oriented interface
 * @export
 * @class OrganisationApi
 * @extends {BaseAPI}
 */
export class OrganisationApi extends BaseAPI {
    /**
     * 
     * @param {string} [entityId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationApi
     */
    public apiOrganisationByEntityIdGet(entityId?: string, options?: RawAxiosRequestConfig) {
        return OrganisationApiFp(this.configuration).apiOrganisationByEntityIdGet(entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationApi
     */
    public apiOrganisationGet(options?: RawAxiosRequestConfig) {
        return OrganisationApiFp(this.configuration).apiOrganisationGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [entityId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationApi
     */
    public apiOrganisationGetOrganisationByIdGet(entityId?: number, options?: RawAxiosRequestConfig) {
        return OrganisationApiFp(this.configuration).apiOrganisationGetOrganisationByIdGet(entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateOrganisationRequest} [updateOrganisationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationApi
     */
    public apiOrganisationPatch(updateOrganisationRequest?: UpdateOrganisationRequest, options?: RawAxiosRequestConfig) {
        return OrganisationApiFp(this.configuration).apiOrganisationPatch(updateOrganisationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AddOrganisationRequest} [addOrganisationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationApi
     */
    public apiOrganisationPost(addOrganisationRequest?: AddOrganisationRequest, options?: RawAxiosRequestConfig) {
        return OrganisationApiFp(this.configuration).apiOrganisationPost(addOrganisationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrganisationSettingApi - axios parameter creator
 * @export
 */
export const OrganisationSettingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<UpsertOrganisationSettingsRequest>} [upsertOrganisationSettingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganisationSettingBulkPost: async (upsertOrganisationSettingsRequest?: Array<UpsertOrganisationSettingsRequest>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/OrganisationSetting/Bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertOrganisationSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganisationSettingGet: async (organisationId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/OrganisationSetting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (organisationId !== undefined) {
                localVarQueryParameter['organisationId'] = organisationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [organisationId] 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganisationSettingGetByOrganisationIdAndSettingIdsPost: async (organisationId?: number, requestBody?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/OrganisationSetting/GetByOrganisationIdAndSettingIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (organisationId !== undefined) {
                localVarQueryParameter['organisationId'] = organisationId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetSettingsByOrganisationAndSettingTypesRequest} [getSettingsByOrganisationAndSettingTypesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganisationSettingGetByOrganisationIdAndSettingTypesPost: async (getSettingsByOrganisationAndSettingTypesRequest?: GetSettingsByOrganisationAndSettingTypesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/OrganisationSetting/GetByOrganisationIdAndSettingTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getSettingsByOrganisationAndSettingTypesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganisationSettingApi - functional programming interface
 * @export
 */
export const OrganisationSettingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganisationSettingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {Array<UpsertOrganisationSettingsRequest>} [upsertOrganisationSettingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganisationSettingBulkPost(upsertOrganisationSettingsRequest?: Array<UpsertOrganisationSettingsRequest>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganisationSettingDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganisationSettingBulkPost(upsertOrganisationSettingsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationSettingApi.apiOrganisationSettingBulkPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganisationSettingGet(organisationId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganisationSettingDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganisationSettingGet(organisationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationSettingApi.apiOrganisationSettingGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [organisationId] 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganisationSettingGetByOrganisationIdAndSettingIdsPost(organisationId?: number, requestBody?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganisationSettingDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganisationSettingGetByOrganisationIdAndSettingIdsPost(organisationId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationSettingApi.apiOrganisationSettingGetByOrganisationIdAndSettingIdsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetSettingsByOrganisationAndSettingTypesRequest} [getSettingsByOrganisationAndSettingTypesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganisationSettingGetByOrganisationIdAndSettingTypesPost(getSettingsByOrganisationAndSettingTypesRequest?: GetSettingsByOrganisationAndSettingTypesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganisationSettingDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganisationSettingGetByOrganisationIdAndSettingTypesPost(getSettingsByOrganisationAndSettingTypesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationSettingApi.apiOrganisationSettingGetByOrganisationIdAndSettingTypesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrganisationSettingApi - factory interface
 * @export
 */
export const OrganisationSettingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganisationSettingApiFp(configuration)
    return {
        /**
         * 
         * @param {Array<UpsertOrganisationSettingsRequest>} [upsertOrganisationSettingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganisationSettingBulkPost(upsertOrganisationSettingsRequest?: Array<UpsertOrganisationSettingsRequest>, options?: RawAxiosRequestConfig): AxiosPromise<Array<OrganisationSettingDto>> {
            return localVarFp.apiOrganisationSettingBulkPost(upsertOrganisationSettingsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganisationSettingGet(organisationId?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<OrganisationSettingDto>> {
            return localVarFp.apiOrganisationSettingGet(organisationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [organisationId] 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganisationSettingGetByOrganisationIdAndSettingIdsPost(organisationId?: number, requestBody?: Array<number>, options?: RawAxiosRequestConfig): AxiosPromise<Array<OrganisationSettingDto>> {
            return localVarFp.apiOrganisationSettingGetByOrganisationIdAndSettingIdsPost(organisationId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetSettingsByOrganisationAndSettingTypesRequest} [getSettingsByOrganisationAndSettingTypesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganisationSettingGetByOrganisationIdAndSettingTypesPost(getSettingsByOrganisationAndSettingTypesRequest?: GetSettingsByOrganisationAndSettingTypesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<OrganisationSettingDto>> {
            return localVarFp.apiOrganisationSettingGetByOrganisationIdAndSettingTypesPost(getSettingsByOrganisationAndSettingTypesRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganisationSettingApi - object-oriented interface
 * @export
 * @class OrganisationSettingApi
 * @extends {BaseAPI}
 */
export class OrganisationSettingApi extends BaseAPI {
    /**
     * 
     * @param {Array<UpsertOrganisationSettingsRequest>} [upsertOrganisationSettingsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationSettingApi
     */
    public apiOrganisationSettingBulkPost(upsertOrganisationSettingsRequest?: Array<UpsertOrganisationSettingsRequest>, options?: RawAxiosRequestConfig) {
        return OrganisationSettingApiFp(this.configuration).apiOrganisationSettingBulkPost(upsertOrganisationSettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [organisationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationSettingApi
     */
    public apiOrganisationSettingGet(organisationId?: number, options?: RawAxiosRequestConfig) {
        return OrganisationSettingApiFp(this.configuration).apiOrganisationSettingGet(organisationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [organisationId] 
     * @param {Array<number>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationSettingApi
     */
    public apiOrganisationSettingGetByOrganisationIdAndSettingIdsPost(organisationId?: number, requestBody?: Array<number>, options?: RawAxiosRequestConfig) {
        return OrganisationSettingApiFp(this.configuration).apiOrganisationSettingGetByOrganisationIdAndSettingIdsPost(organisationId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetSettingsByOrganisationAndSettingTypesRequest} [getSettingsByOrganisationAndSettingTypesRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationSettingApi
     */
    public apiOrganisationSettingGetByOrganisationIdAndSettingTypesPost(getSettingsByOrganisationAndSettingTypesRequest?: GetSettingsByOrganisationAndSettingTypesRequest, options?: RawAxiosRequestConfig) {
        return OrganisationSettingApiFp(this.configuration).apiOrganisationSettingGetByOrganisationIdAndSettingTypesPost(getSettingsByOrganisationAndSettingTypesRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RoleApi - axios parameter creator
 * @export
 */
export const RoleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [roleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoleDelete: async (roleId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (roleId !== undefined) {
                localVarQueryParameter['roleId'] = roleId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoleGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [roleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoleGetByIdGet: async (roleId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Role/GetById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (roleId !== undefined) {
                localVarQueryParameter['roleId'] = roleId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateRoleRequest} [updateRoleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRolePatch: async (updateRoleRequest?: UpdateRoleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRoleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddRoleRequest} [addRoleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRolePost: async (addRoleRequest?: AddRoleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addRoleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RoleApi - functional programming interface
 * @export
 */
export const RoleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RoleApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [roleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRoleDelete(roleId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRoleDelete(roleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoleApi.apiRoleDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRoleGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoleDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRoleGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoleApi.apiRoleGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [roleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRoleGetByIdGet(roleId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRoleGetByIdGet(roleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoleApi.apiRoleGetByIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateRoleRequest} [updateRoleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRolePatch(updateRoleRequest?: UpdateRoleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRolePatch(updateRoleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoleApi.apiRolePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AddRoleRequest} [addRoleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRolePost(addRoleRequest?: AddRoleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRolePost(addRoleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoleApi.apiRolePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RoleApi - factory interface
 * @export
 */
export const RoleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RoleApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [roleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoleDelete(roleId?: number, options?: RawAxiosRequestConfig): AxiosPromise<RoleDto> {
            return localVarFp.apiRoleDelete(roleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoleGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<RoleDto>> {
            return localVarFp.apiRoleGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [roleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoleGetByIdGet(roleId?: number, options?: RawAxiosRequestConfig): AxiosPromise<RoleDto> {
            return localVarFp.apiRoleGetByIdGet(roleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateRoleRequest} [updateRoleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRolePatch(updateRoleRequest?: UpdateRoleRequest, options?: RawAxiosRequestConfig): AxiosPromise<RoleDto> {
            return localVarFp.apiRolePatch(updateRoleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AddRoleRequest} [addRoleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRolePost(addRoleRequest?: AddRoleRequest, options?: RawAxiosRequestConfig): AxiosPromise<RoleDto> {
            return localVarFp.apiRolePost(addRoleRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RoleApi - object-oriented interface
 * @export
 * @class RoleApi
 * @extends {BaseAPI}
 */
export class RoleApi extends BaseAPI {
    /**
     * 
     * @param {number} [roleId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiRoleDelete(roleId?: number, options?: RawAxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiRoleDelete(roleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiRoleGet(options?: RawAxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiRoleGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [roleId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiRoleGetByIdGet(roleId?: number, options?: RawAxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiRoleGetByIdGet(roleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateRoleRequest} [updateRoleRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiRolePatch(updateRoleRequest?: UpdateRoleRequest, options?: RawAxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiRolePatch(updateRoleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AddRoleRequest} [addRoleRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiRolePost(addRoleRequest?: AddRoleRequest, options?: RawAxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiRolePost(addRoleRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RolePermissionAssociationApi - axios parameter creator
 * @export
 */
export const RolePermissionAssociationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {UpsertRolePermissionAssociationRequest} [upsertRolePermissionAssociationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRolePermissionAssociationPost: async (upsertRolePermissionAssociationRequest?: UpsertRolePermissionAssociationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/RolePermissionAssociation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertRolePermissionAssociationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRolePermissionAssociationRoleIdGet: async (roleId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('apiRolePermissionAssociationRoleIdGet', 'roleId', roleId)
            const localVarPath = `/api/RolePermissionAssociation/{roleId}`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RolePermissionAssociationApi - functional programming interface
 * @export
 */
export const RolePermissionAssociationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RolePermissionAssociationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {UpsertRolePermissionAssociationRequest} [upsertRolePermissionAssociationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRolePermissionAssociationPost(upsertRolePermissionAssociationRequest?: UpsertRolePermissionAssociationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RolePermissionAssociationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRolePermissionAssociationPost(upsertRolePermissionAssociationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolePermissionAssociationApi.apiRolePermissionAssociationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRolePermissionAssociationRoleIdGet(roleId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RolePermissionAssociationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRolePermissionAssociationRoleIdGet(roleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolePermissionAssociationApi.apiRolePermissionAssociationRoleIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RolePermissionAssociationApi - factory interface
 * @export
 */
export const RolePermissionAssociationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RolePermissionAssociationApiFp(configuration)
    return {
        /**
         * 
         * @param {UpsertRolePermissionAssociationRequest} [upsertRolePermissionAssociationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRolePermissionAssociationPost(upsertRolePermissionAssociationRequest?: UpsertRolePermissionAssociationRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<RolePermissionAssociationDto>> {
            return localVarFp.apiRolePermissionAssociationPost(upsertRolePermissionAssociationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRolePermissionAssociationRoleIdGet(roleId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<RolePermissionAssociationDto>> {
            return localVarFp.apiRolePermissionAssociationRoleIdGet(roleId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RolePermissionAssociationApi - object-oriented interface
 * @export
 * @class RolePermissionAssociationApi
 * @extends {BaseAPI}
 */
export class RolePermissionAssociationApi extends BaseAPI {
    /**
     * 
     * @param {UpsertRolePermissionAssociationRequest} [upsertRolePermissionAssociationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolePermissionAssociationApi
     */
    public apiRolePermissionAssociationPost(upsertRolePermissionAssociationRequest?: UpsertRolePermissionAssociationRequest, options?: RawAxiosRequestConfig) {
        return RolePermissionAssociationApiFp(this.configuration).apiRolePermissionAssociationPost(upsertRolePermissionAssociationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} roleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolePermissionAssociationApi
     */
    public apiRolePermissionAssociationRoleIdGet(roleId: number, options?: RawAxiosRequestConfig) {
        return RolePermissionAssociationApiFp(this.configuration).apiRolePermissionAssociationRoleIdGet(roleId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RoleUserOrgAssociationApi - axios parameter creator
 * @export
 */
export const RoleUserOrgAssociationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {BulkAssignUsersToOrganisationRequest} [bulkAssignUsersToOrganisationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoleUserOrgAssociationBulkAssignToOrganisationPost: async (bulkAssignUsersToOrganisationRequest?: BulkAssignUsersToOrganisationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/RoleUserOrgAssociation/BulkAssignToOrganisation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkAssignUsersToOrganisationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertRoleUserOrgAssociationRequest} [upsertRoleUserOrgAssociationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoleUserOrgAssociationBulkPost: async (upsertRoleUserOrgAssociationRequest?: UpsertRoleUserOrgAssociationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/RoleUserOrgAssociation/Bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertRoleUserOrgAssociationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoleUserOrgAssociationGetByOrganisationIdGet: async (organisationId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/RoleUserOrgAssociation/GetByOrganisationId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (organisationId !== undefined) {
                localVarQueryParameter['organisationId'] = organisationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [userId] 
         * @param {number} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoleUserOrgAssociationGetByUserOrgIdGet: async (userId?: number, organisationId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/RoleUserOrgAssociation/GetByUserOrgId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (organisationId !== undefined) {
                localVarQueryParameter['organisationId'] = organisationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RoleUserOrgAssociationApi - functional programming interface
 * @export
 */
export const RoleUserOrgAssociationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RoleUserOrgAssociationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {BulkAssignUsersToOrganisationRequest} [bulkAssignUsersToOrganisationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRoleUserOrgAssociationBulkAssignToOrganisationPost(bulkAssignUsersToOrganisationRequest?: BulkAssignUsersToOrganisationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoleUserOrgAssociationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRoleUserOrgAssociationBulkAssignToOrganisationPost(bulkAssignUsersToOrganisationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoleUserOrgAssociationApi.apiRoleUserOrgAssociationBulkAssignToOrganisationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertRoleUserOrgAssociationRequest} [upsertRoleUserOrgAssociationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRoleUserOrgAssociationBulkPost(upsertRoleUserOrgAssociationRequest?: UpsertRoleUserOrgAssociationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoleUserOrgAssociationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRoleUserOrgAssociationBulkPost(upsertRoleUserOrgAssociationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoleUserOrgAssociationApi.apiRoleUserOrgAssociationBulkPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRoleUserOrgAssociationGetByOrganisationIdGet(organisationId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoleUserOrgAssociationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRoleUserOrgAssociationGetByOrganisationIdGet(organisationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoleUserOrgAssociationApi.apiRoleUserOrgAssociationGetByOrganisationIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [userId] 
         * @param {number} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRoleUserOrgAssociationGetByUserOrgIdGet(userId?: number, organisationId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoleUserOrgAssociationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRoleUserOrgAssociationGetByUserOrgIdGet(userId, organisationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoleUserOrgAssociationApi.apiRoleUserOrgAssociationGetByUserOrgIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RoleUserOrgAssociationApi - factory interface
 * @export
 */
export const RoleUserOrgAssociationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RoleUserOrgAssociationApiFp(configuration)
    return {
        /**
         * 
         * @param {BulkAssignUsersToOrganisationRequest} [bulkAssignUsersToOrganisationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoleUserOrgAssociationBulkAssignToOrganisationPost(bulkAssignUsersToOrganisationRequest?: BulkAssignUsersToOrganisationRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<RoleUserOrgAssociationDto>> {
            return localVarFp.apiRoleUserOrgAssociationBulkAssignToOrganisationPost(bulkAssignUsersToOrganisationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertRoleUserOrgAssociationRequest} [upsertRoleUserOrgAssociationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoleUserOrgAssociationBulkPost(upsertRoleUserOrgAssociationRequest?: UpsertRoleUserOrgAssociationRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<RoleUserOrgAssociationDto>> {
            return localVarFp.apiRoleUserOrgAssociationBulkPost(upsertRoleUserOrgAssociationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoleUserOrgAssociationGetByOrganisationIdGet(organisationId?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<RoleUserOrgAssociationDto>> {
            return localVarFp.apiRoleUserOrgAssociationGetByOrganisationIdGet(organisationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [userId] 
         * @param {number} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoleUserOrgAssociationGetByUserOrgIdGet(userId?: number, organisationId?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<RoleUserOrgAssociationDto>> {
            return localVarFp.apiRoleUserOrgAssociationGetByUserOrgIdGet(userId, organisationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RoleUserOrgAssociationApi - object-oriented interface
 * @export
 * @class RoleUserOrgAssociationApi
 * @extends {BaseAPI}
 */
export class RoleUserOrgAssociationApi extends BaseAPI {
    /**
     * 
     * @param {BulkAssignUsersToOrganisationRequest} [bulkAssignUsersToOrganisationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleUserOrgAssociationApi
     */
    public apiRoleUserOrgAssociationBulkAssignToOrganisationPost(bulkAssignUsersToOrganisationRequest?: BulkAssignUsersToOrganisationRequest, options?: RawAxiosRequestConfig) {
        return RoleUserOrgAssociationApiFp(this.configuration).apiRoleUserOrgAssociationBulkAssignToOrganisationPost(bulkAssignUsersToOrganisationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpsertRoleUserOrgAssociationRequest} [upsertRoleUserOrgAssociationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleUserOrgAssociationApi
     */
    public apiRoleUserOrgAssociationBulkPost(upsertRoleUserOrgAssociationRequest?: UpsertRoleUserOrgAssociationRequest, options?: RawAxiosRequestConfig) {
        return RoleUserOrgAssociationApiFp(this.configuration).apiRoleUserOrgAssociationBulkPost(upsertRoleUserOrgAssociationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [organisationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleUserOrgAssociationApi
     */
    public apiRoleUserOrgAssociationGetByOrganisationIdGet(organisationId?: number, options?: RawAxiosRequestConfig) {
        return RoleUserOrgAssociationApiFp(this.configuration).apiRoleUserOrgAssociationGetByOrganisationIdGet(organisationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [userId] 
     * @param {number} [organisationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleUserOrgAssociationApi
     */
    public apiRoleUserOrgAssociationGetByUserOrgIdGet(userId?: number, organisationId?: number, options?: RawAxiosRequestConfig) {
        return RoleUserOrgAssociationApiFp(this.configuration).apiRoleUserOrgAssociationGetByUserOrgIdGet(userId, organisationId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RuleConfigurationApi - axios parameter creator
 * @export
 */
export const RuleConfigurationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRuleConfigurationIdDelete: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiRuleConfigurationIdDelete', 'id', id)
            const localVarPath = `/api/RuleConfiguration/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRuleConfigurationIdGet: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiRuleConfigurationIdGet', 'id', id)
            const localVarPath = `/api/RuleConfiguration/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [ruleId] 
         * @param {number} [roleId] 
         * @param {number} [entityDetailId] 
         * @param {string} [entityDetailValue] 
         * @param {number} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRuleConfigurationMatchGet: async (ruleId?: number, roleId?: number, entityDetailId?: number, entityDetailValue?: string, organisationId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/RuleConfiguration/match`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (ruleId !== undefined) {
                localVarQueryParameter['ruleId'] = ruleId;
            }

            if (roleId !== undefined) {
                localVarQueryParameter['roleId'] = roleId;
            }

            if (entityDetailId !== undefined) {
                localVarQueryParameter['entityDetailId'] = entityDetailId;
            }

            if (entityDetailValue !== undefined) {
                localVarQueryParameter['entityDetailValue'] = entityDetailValue;
            }

            if (organisationId !== undefined) {
                localVarQueryParameter['organisationId'] = organisationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRuleConfigurationOrganisationGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/RuleConfiguration/organisation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertRuleConfigurationRequest} [upsertRuleConfigurationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRuleConfigurationUpsertPost: async (upsertRuleConfigurationRequest?: UpsertRuleConfigurationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/RuleConfiguration/upsert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertRuleConfigurationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RuleConfigurationApi - functional programming interface
 * @export
 */
export const RuleConfigurationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RuleConfigurationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRuleConfigurationIdDelete(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRuleConfigurationIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RuleConfigurationApi.apiRuleConfigurationIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRuleConfigurationIdGet(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RuleConfigurationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRuleConfigurationIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RuleConfigurationApi.apiRuleConfigurationIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [ruleId] 
         * @param {number} [roleId] 
         * @param {number} [entityDetailId] 
         * @param {string} [entityDetailValue] 
         * @param {number} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRuleConfigurationMatchGet(ruleId?: number, roleId?: number, entityDetailId?: number, entityDetailValue?: string, organisationId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RuleConfigurationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRuleConfigurationMatchGet(ruleId, roleId, entityDetailId, entityDetailValue, organisationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RuleConfigurationApi.apiRuleConfigurationMatchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRuleConfigurationOrganisationGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RuleConfigurationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRuleConfigurationOrganisationGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RuleConfigurationApi.apiRuleConfigurationOrganisationGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertRuleConfigurationRequest} [upsertRuleConfigurationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRuleConfigurationUpsertPost(upsertRuleConfigurationRequest?: UpsertRuleConfigurationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RuleConfigurationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRuleConfigurationUpsertPost(upsertRuleConfigurationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RuleConfigurationApi.apiRuleConfigurationUpsertPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RuleConfigurationApi - factory interface
 * @export
 */
export const RuleConfigurationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RuleConfigurationApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRuleConfigurationIdDelete(id: number, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiRuleConfigurationIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRuleConfigurationIdGet(id: number, options?: RawAxiosRequestConfig): AxiosPromise<RuleConfigurationDto> {
            return localVarFp.apiRuleConfigurationIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [ruleId] 
         * @param {number} [roleId] 
         * @param {number} [entityDetailId] 
         * @param {string} [entityDetailValue] 
         * @param {number} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRuleConfigurationMatchGet(ruleId?: number, roleId?: number, entityDetailId?: number, entityDetailValue?: string, organisationId?: number, options?: RawAxiosRequestConfig): AxiosPromise<RuleConfigurationDto> {
            return localVarFp.apiRuleConfigurationMatchGet(ruleId, roleId, entityDetailId, entityDetailValue, organisationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRuleConfigurationOrganisationGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<RuleConfigurationDto>> {
            return localVarFp.apiRuleConfigurationOrganisationGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertRuleConfigurationRequest} [upsertRuleConfigurationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRuleConfigurationUpsertPost(upsertRuleConfigurationRequest?: UpsertRuleConfigurationRequest, options?: RawAxiosRequestConfig): AxiosPromise<RuleConfigurationDto> {
            return localVarFp.apiRuleConfigurationUpsertPost(upsertRuleConfigurationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RuleConfigurationApi - object-oriented interface
 * @export
 * @class RuleConfigurationApi
 * @extends {BaseAPI}
 */
export class RuleConfigurationApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleConfigurationApi
     */
    public apiRuleConfigurationIdDelete(id: number, options?: RawAxiosRequestConfig) {
        return RuleConfigurationApiFp(this.configuration).apiRuleConfigurationIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleConfigurationApi
     */
    public apiRuleConfigurationIdGet(id: number, options?: RawAxiosRequestConfig) {
        return RuleConfigurationApiFp(this.configuration).apiRuleConfigurationIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [ruleId] 
     * @param {number} [roleId] 
     * @param {number} [entityDetailId] 
     * @param {string} [entityDetailValue] 
     * @param {number} [organisationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleConfigurationApi
     */
    public apiRuleConfigurationMatchGet(ruleId?: number, roleId?: number, entityDetailId?: number, entityDetailValue?: string, organisationId?: number, options?: RawAxiosRequestConfig) {
        return RuleConfigurationApiFp(this.configuration).apiRuleConfigurationMatchGet(ruleId, roleId, entityDetailId, entityDetailValue, organisationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleConfigurationApi
     */
    public apiRuleConfigurationOrganisationGet(options?: RawAxiosRequestConfig) {
        return RuleConfigurationApiFp(this.configuration).apiRuleConfigurationOrganisationGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpsertRuleConfigurationRequest} [upsertRuleConfigurationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleConfigurationApi
     */
    public apiRuleConfigurationUpsertPost(upsertRuleConfigurationRequest?: UpsertRuleConfigurationRequest, options?: RawAxiosRequestConfig) {
        return RuleConfigurationApiFp(this.configuration).apiRuleConfigurationUpsertPost(upsertRuleConfigurationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RuleDryRunTestOverrideApi - axios parameter creator
 * @export
 */
export const RuleDryRunTestOverrideApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} ruleId 
         * @param {number} [scopeEntityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRuleDryRunTestOverrideRuleIdDelete: async (ruleId: number, scopeEntityId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('apiRuleDryRunTestOverrideRuleIdDelete', 'ruleId', ruleId)
            const localVarPath = `/api/RuleDryRunTestOverride/{ruleId}`
                .replace(`{${"ruleId"}}`, encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (scopeEntityId !== undefined) {
                localVarQueryParameter['scopeEntityId'] = scopeEntityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {number} [scopeEntityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRuleDryRunTestOverrideRuleIdGet: async (ruleId: number, scopeEntityId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('apiRuleDryRunTestOverrideRuleIdGet', 'ruleId', ruleId)
            const localVarPath = `/api/RuleDryRunTestOverride/{ruleId}`
                .replace(`{${"ruleId"}}`, encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (scopeEntityId !== undefined) {
                localVarQueryParameter['scopeEntityId'] = scopeEntityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {SaveRuleDryRunTestOverrideRequest} [saveRuleDryRunTestOverrideRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRuleDryRunTestOverrideRuleIdPut: async (ruleId: number, saveRuleDryRunTestOverrideRequest?: SaveRuleDryRunTestOverrideRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('apiRuleDryRunTestOverrideRuleIdPut', 'ruleId', ruleId)
            const localVarPath = `/api/RuleDryRunTestOverride/{ruleId}`
                .replace(`{${"ruleId"}}`, encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveRuleDryRunTestOverrideRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RuleDryRunTestOverrideApi - functional programming interface
 * @export
 */
export const RuleDryRunTestOverrideApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RuleDryRunTestOverrideApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} ruleId 
         * @param {number} [scopeEntityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRuleDryRunTestOverrideRuleIdDelete(ruleId: number, scopeEntityId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRuleDryRunTestOverrideRuleIdDelete(ruleId, scopeEntityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RuleDryRunTestOverrideApi.apiRuleDryRunTestOverrideRuleIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {number} [scopeEntityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRuleDryRunTestOverrideRuleIdGet(ruleId: number, scopeEntityId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RuleDryRunTestOverrideDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRuleDryRunTestOverrideRuleIdGet(ruleId, scopeEntityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RuleDryRunTestOverrideApi.apiRuleDryRunTestOverrideRuleIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {SaveRuleDryRunTestOverrideRequest} [saveRuleDryRunTestOverrideRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRuleDryRunTestOverrideRuleIdPut(ruleId: number, saveRuleDryRunTestOverrideRequest?: SaveRuleDryRunTestOverrideRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RuleDryRunTestOverrideDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRuleDryRunTestOverrideRuleIdPut(ruleId, saveRuleDryRunTestOverrideRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RuleDryRunTestOverrideApi.apiRuleDryRunTestOverrideRuleIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RuleDryRunTestOverrideApi - factory interface
 * @export
 */
export const RuleDryRunTestOverrideApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RuleDryRunTestOverrideApiFp(configuration)
    return {
        /**
         * 
         * @param {number} ruleId 
         * @param {number} [scopeEntityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRuleDryRunTestOverrideRuleIdDelete(ruleId: number, scopeEntityId?: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiRuleDryRunTestOverrideRuleIdDelete(ruleId, scopeEntityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {number} [scopeEntityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRuleDryRunTestOverrideRuleIdGet(ruleId: number, scopeEntityId?: number, options?: RawAxiosRequestConfig): AxiosPromise<RuleDryRunTestOverrideDto> {
            return localVarFp.apiRuleDryRunTestOverrideRuleIdGet(ruleId, scopeEntityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {SaveRuleDryRunTestOverrideRequest} [saveRuleDryRunTestOverrideRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRuleDryRunTestOverrideRuleIdPut(ruleId: number, saveRuleDryRunTestOverrideRequest?: SaveRuleDryRunTestOverrideRequest, options?: RawAxiosRequestConfig): AxiosPromise<RuleDryRunTestOverrideDto> {
            return localVarFp.apiRuleDryRunTestOverrideRuleIdPut(ruleId, saveRuleDryRunTestOverrideRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RuleDryRunTestOverrideApi - object-oriented interface
 * @export
 * @class RuleDryRunTestOverrideApi
 * @extends {BaseAPI}
 */
export class RuleDryRunTestOverrideApi extends BaseAPI {
    /**
     * 
     * @param {number} ruleId 
     * @param {number} [scopeEntityId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleDryRunTestOverrideApi
     */
    public apiRuleDryRunTestOverrideRuleIdDelete(ruleId: number, scopeEntityId?: number, options?: RawAxiosRequestConfig) {
        return RuleDryRunTestOverrideApiFp(this.configuration).apiRuleDryRunTestOverrideRuleIdDelete(ruleId, scopeEntityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} ruleId 
     * @param {number} [scopeEntityId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleDryRunTestOverrideApi
     */
    public apiRuleDryRunTestOverrideRuleIdGet(ruleId: number, scopeEntityId?: number, options?: RawAxiosRequestConfig) {
        return RuleDryRunTestOverrideApiFp(this.configuration).apiRuleDryRunTestOverrideRuleIdGet(ruleId, scopeEntityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} ruleId 
     * @param {SaveRuleDryRunTestOverrideRequest} [saveRuleDryRunTestOverrideRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleDryRunTestOverrideApi
     */
    public apiRuleDryRunTestOverrideRuleIdPut(ruleId: number, saveRuleDryRunTestOverrideRequest?: SaveRuleDryRunTestOverrideRequest, options?: RawAxiosRequestConfig) {
        return RuleDryRunTestOverrideApiFp(this.configuration).apiRuleDryRunTestOverrideRuleIdPut(ruleId, saveRuleDryRunTestOverrideRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RuleExecutionApi - axios parameter creator
 * @export
 */
export const RuleExecutionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {RuleTriggerRequest} [ruleTriggerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRuleExecutionExecuteTriggeredRulesPost: async (ruleTriggerRequest?: RuleTriggerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/RuleExecution/ExecuteTriggeredRules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ruleTriggerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RuleExecutionApi - functional programming interface
 * @export
 */
export const RuleExecutionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RuleExecutionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {RuleTriggerRequest} [ruleTriggerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRuleExecutionExecuteTriggeredRulesPost(ruleTriggerRequest?: RuleTriggerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ActionInstruction>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRuleExecutionExecuteTriggeredRulesPost(ruleTriggerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RuleExecutionApi.apiRuleExecutionExecuteTriggeredRulesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RuleExecutionApi - factory interface
 * @export
 */
export const RuleExecutionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RuleExecutionApiFp(configuration)
    return {
        /**
         * 
         * @param {RuleTriggerRequest} [ruleTriggerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRuleExecutionExecuteTriggeredRulesPost(ruleTriggerRequest?: RuleTriggerRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ActionInstruction>> {
            return localVarFp.apiRuleExecutionExecuteTriggeredRulesPost(ruleTriggerRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RuleExecutionApi - object-oriented interface
 * @export
 * @class RuleExecutionApi
 * @extends {BaseAPI}
 */
export class RuleExecutionApi extends BaseAPI {
    /**
     * 
     * @param {RuleTriggerRequest} [ruleTriggerRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RuleExecutionApi
     */
    public apiRuleExecutionExecuteTriggeredRulesPost(ruleTriggerRequest?: RuleTriggerRequest, options?: RawAxiosRequestConfig) {
        return RuleExecutionApiFp(this.configuration).apiRuleExecutionExecuteTriggeredRulesPost(ruleTriggerRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ScreenApi - axios parameter creator
 * @export
 */
export const ScreenApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [screenId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScreenDelete: async (screenId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Screen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (screenId !== undefined) {
                localVarQueryParameter['screenId'] = screenId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [screenId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScreenGetScreenByIdGet: async (screenId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Screen/GetScreenById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (screenId !== undefined) {
                localVarQueryParameter['screenId'] = screenId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} organisationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScreenOrganisationIdGet: async (organisationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationId' is not null or undefined
            assertParamExists('apiScreenOrganisationIdGet', 'organisationId', organisationId)
            const localVarPath = `/api/Screen/{organisationId}`
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<UpsertScreenRequest>} [upsertScreenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScreenPost: async (upsertScreenRequest?: Array<UpsertScreenRequest>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Screen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertScreenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ScreenApi - functional programming interface
 * @export
 */
export const ScreenApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ScreenApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [screenId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiScreenDelete(screenId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiScreenDelete(screenId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScreenApi.apiScreenDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [screenId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiScreenGetScreenByIdGet(screenId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScreenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiScreenGetScreenByIdGet(screenId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScreenApi.apiScreenGetScreenByIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} organisationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiScreenOrganisationIdGet(organisationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ScreenDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiScreenOrganisationIdGet(organisationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScreenApi.apiScreenOrganisationIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<UpsertScreenRequest>} [upsertScreenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiScreenPost(upsertScreenRequest?: Array<UpsertScreenRequest>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ScreenDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiScreenPost(upsertScreenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScreenApi.apiScreenPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ScreenApi - factory interface
 * @export
 */
export const ScreenApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ScreenApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [screenId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScreenDelete(screenId?: number, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiScreenDelete(screenId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [screenId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScreenGetScreenByIdGet(screenId?: number, options?: RawAxiosRequestConfig): AxiosPromise<ScreenDto> {
            return localVarFp.apiScreenGetScreenByIdGet(screenId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} organisationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScreenOrganisationIdGet(organisationId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ScreenDto>> {
            return localVarFp.apiScreenOrganisationIdGet(organisationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<UpsertScreenRequest>} [upsertScreenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScreenPost(upsertScreenRequest?: Array<UpsertScreenRequest>, options?: RawAxiosRequestConfig): AxiosPromise<Array<ScreenDto>> {
            return localVarFp.apiScreenPost(upsertScreenRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ScreenApi - object-oriented interface
 * @export
 * @class ScreenApi
 * @extends {BaseAPI}
 */
export class ScreenApi extends BaseAPI {
    /**
     * 
     * @param {number} [screenId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScreenApi
     */
    public apiScreenDelete(screenId?: number, options?: RawAxiosRequestConfig) {
        return ScreenApiFp(this.configuration).apiScreenDelete(screenId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [screenId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScreenApi
     */
    public apiScreenGetScreenByIdGet(screenId?: number, options?: RawAxiosRequestConfig) {
        return ScreenApiFp(this.configuration).apiScreenGetScreenByIdGet(screenId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} organisationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScreenApi
     */
    public apiScreenOrganisationIdGet(organisationId: number, options?: RawAxiosRequestConfig) {
        return ScreenApiFp(this.configuration).apiScreenOrganisationIdGet(organisationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<UpsertScreenRequest>} [upsertScreenRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScreenApi
     */
    public apiScreenPost(upsertScreenRequest?: Array<UpsertScreenRequest>, options?: RawAxiosRequestConfig) {
        return ScreenApiFp(this.configuration).apiScreenPost(upsertScreenRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SolrSyncApi - axios parameter creator
 * @export
 */
export const SolrSyncApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSolrSyncJobsJobIdCancelPost: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('apiSolrSyncJobsJobIdCancelPost', 'jobId', jobId)
            const localVarPath = `/api/SolrSync/jobs/{jobId}/cancel`
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSolrSyncJobsJobIdGet: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('apiSolrSyncJobsJobIdGet', 'jobId', jobId)
            const localVarPath = `/api/SolrSync/jobs/{jobId}`
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SolrSyncAllRequest} [solrSyncAllRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSolrSyncSyncAllPost: async (solrSyncAllRequest?: SolrSyncAllRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/SolrSync/sync-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(solrSyncAllRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SolrSyncApiRequest} [solrSyncApiRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSolrSyncSyncPost: async (solrSyncApiRequest?: SolrSyncApiRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/SolrSync/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(solrSyncApiRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SolrSyncApi - functional programming interface
 * @export
 */
export const SolrSyncApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SolrSyncApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSolrSyncJobsJobIdCancelPost(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSolrSyncJobsJobIdCancelPost(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SolrSyncApi.apiSolrSyncJobsJobIdCancelPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSolrSyncJobsJobIdGet(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SolrSyncJob>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSolrSyncJobsJobIdGet(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SolrSyncApi.apiSolrSyncJobsJobIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SolrSyncAllRequest} [solrSyncAllRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSolrSyncSyncAllPost(solrSyncAllRequest?: SolrSyncAllRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SolrSyncJob>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSolrSyncSyncAllPost(solrSyncAllRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SolrSyncApi.apiSolrSyncSyncAllPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SolrSyncApiRequest} [solrSyncApiRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSolrSyncSyncPost(solrSyncApiRequest?: SolrSyncApiRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SolrSyncJob>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSolrSyncSyncPost(solrSyncApiRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SolrSyncApi.apiSolrSyncSyncPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SolrSyncApi - factory interface
 * @export
 */
export const SolrSyncApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SolrSyncApiFp(configuration)
    return {
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSolrSyncJobsJobIdCancelPost(jobId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiSolrSyncJobsJobIdCancelPost(jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSolrSyncJobsJobIdGet(jobId: string, options?: RawAxiosRequestConfig): AxiosPromise<SolrSyncJob> {
            return localVarFp.apiSolrSyncJobsJobIdGet(jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SolrSyncAllRequest} [solrSyncAllRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSolrSyncSyncAllPost(solrSyncAllRequest?: SolrSyncAllRequest, options?: RawAxiosRequestConfig): AxiosPromise<SolrSyncJob> {
            return localVarFp.apiSolrSyncSyncAllPost(solrSyncAllRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SolrSyncApiRequest} [solrSyncApiRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSolrSyncSyncPost(solrSyncApiRequest?: SolrSyncApiRequest, options?: RawAxiosRequestConfig): AxiosPromise<SolrSyncJob> {
            return localVarFp.apiSolrSyncSyncPost(solrSyncApiRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SolrSyncApi - object-oriented interface
 * @export
 * @class SolrSyncApi
 * @extends {BaseAPI}
 */
export class SolrSyncApi extends BaseAPI {
    /**
     * 
     * @param {string} jobId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolrSyncApi
     */
    public apiSolrSyncJobsJobIdCancelPost(jobId: string, options?: RawAxiosRequestConfig) {
        return SolrSyncApiFp(this.configuration).apiSolrSyncJobsJobIdCancelPost(jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} jobId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolrSyncApi
     */
    public apiSolrSyncJobsJobIdGet(jobId: string, options?: RawAxiosRequestConfig) {
        return SolrSyncApiFp(this.configuration).apiSolrSyncJobsJobIdGet(jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SolrSyncAllRequest} [solrSyncAllRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolrSyncApi
     */
    public apiSolrSyncSyncAllPost(solrSyncAllRequest?: SolrSyncAllRequest, options?: RawAxiosRequestConfig) {
        return SolrSyncApiFp(this.configuration).apiSolrSyncSyncAllPost(solrSyncAllRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SolrSyncApiRequest} [solrSyncApiRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolrSyncApi
     */
    public apiSolrSyncSyncPost(solrSyncApiRequest?: SolrSyncApiRequest, options?: RawAxiosRequestConfig) {
        return SolrSyncApiFp(this.configuration).apiSolrSyncSyncPost(solrSyncApiRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SystemApi - axios parameter creator
 * @export
 */
export const SystemApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemApplyMigrationsPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/System/apply-migrations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemAuthCheckGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/System/auth-check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EntityTypeCode} [entityTypeCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemCreateDefaultScreenPost: async (entityTypeCode?: EntityTypeCode, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/System/Create-Default-Screen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (entityTypeCode !== undefined) {
                localVarQueryParameter['entityTypeCode'] = entityTypeCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddOrganisationRequest} [addOrganisationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemCreateEmptyOrganisationPost: async (addOrganisationRequest?: AddOrganisationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/System/create-empty-organisation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addOrganisationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GenerateAnimalRequest} [generateAnimalRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemGenerateAnimalsPost: async (generateAnimalRequest?: GenerateAnimalRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/System/generate-animals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateAnimalRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GenerateMemberRequest} [generateMemberRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemGenerateEnterprisesPost: async (generateMemberRequest?: GenerateMemberRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/System/generate-enterprises`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateMemberRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GenerateRequest} [generateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemGeneratePost: async (generateRequest?: GenerateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/System/generate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemResetAllEntitiesPost: async (organisationId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/System/reset-all-entities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (organisationId !== undefined) {
                localVarQueryParameter['organisationId'] = organisationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemResetConfigurationPost: async (organisationId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/System/reset-configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (organisationId !== undefined) {
                localVarQueryParameter['organisationId'] = organisationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [organisationId] 
         * @param {EntityTypeCode} [entityTypeCode] 
         * @param {boolean} [addOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemResetEntityDetailsPost: async (organisationId?: number, entityTypeCode?: EntityTypeCode, addOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/System/reset-entity-details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (organisationId !== undefined) {
                localVarQueryParameter['organisationId'] = organisationId;
            }

            if (entityTypeCode !== undefined) {
                localVarQueryParameter['entityTypeCode'] = entityTypeCode;
            }

            if (addOnly !== undefined) {
                localVarQueryParameter['addOnly'] = addOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemResetItemCodesPost: async (organisationId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/System/reset-item-codes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (organisationId !== undefined) {
                localVarQueryParameter['organisationId'] = organisationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemSeedBillingRulesPost: async (organisationId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/System/seed-billing-rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (organisationId !== undefined) {
                localVarQueryParameter['organisationId'] = organisationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemTestAuthPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/System/test-auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SystemApi - functional programming interface
 * @export
 */
export const SystemApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SystemApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSystemApplyMigrationsPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSystemApplyMigrationsPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SystemApi.apiSystemApplyMigrationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSystemAuthCheckGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSystemAuthCheckGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SystemApi.apiSystemAuthCheckGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EntityTypeCode} [entityTypeCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSystemCreateDefaultScreenPost(entityTypeCode?: EntityTypeCode, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSystemCreateDefaultScreenPost(entityTypeCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SystemApi.apiSystemCreateDefaultScreenPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AddOrganisationRequest} [addOrganisationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSystemCreateEmptyOrganisationPost(addOrganisationRequest?: AddOrganisationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganisationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSystemCreateEmptyOrganisationPost(addOrganisationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SystemApi.apiSystemCreateEmptyOrganisationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GenerateAnimalRequest} [generateAnimalRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSystemGenerateAnimalsPost(generateAnimalRequest?: GenerateAnimalRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSystemGenerateAnimalsPost(generateAnimalRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SystemApi.apiSystemGenerateAnimalsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GenerateMemberRequest} [generateMemberRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSystemGenerateEnterprisesPost(generateMemberRequest?: GenerateMemberRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSystemGenerateEnterprisesPost(generateMemberRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SystemApi.apiSystemGenerateEnterprisesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GenerateRequest} [generateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSystemGeneratePost(generateRequest?: GenerateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSystemGeneratePost(generateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SystemApi.apiSystemGeneratePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSystemResetAllEntitiesPost(organisationId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSystemResetAllEntitiesPost(organisationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SystemApi.apiSystemResetAllEntitiesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSystemResetConfigurationPost(organisationId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSystemResetConfigurationPost(organisationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SystemApi.apiSystemResetConfigurationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [organisationId] 
         * @param {EntityTypeCode} [entityTypeCode] 
         * @param {boolean} [addOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSystemResetEntityDetailsPost(organisationId?: number, entityTypeCode?: EntityTypeCode, addOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSystemResetEntityDetailsPost(organisationId, entityTypeCode, addOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SystemApi.apiSystemResetEntityDetailsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSystemResetItemCodesPost(organisationId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSystemResetItemCodesPost(organisationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SystemApi.apiSystemResetItemCodesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSystemSeedBillingRulesPost(organisationId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSystemSeedBillingRulesPost(organisationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SystemApi.apiSystemSeedBillingRulesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSystemTestAuthPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSystemTestAuthPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SystemApi.apiSystemTestAuthPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SystemApi - factory interface
 * @export
 */
export const SystemApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SystemApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemApplyMigrationsPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiSystemApplyMigrationsPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemAuthCheckGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiSystemAuthCheckGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EntityTypeCode} [entityTypeCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemCreateDefaultScreenPost(entityTypeCode?: EntityTypeCode, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiSystemCreateDefaultScreenPost(entityTypeCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AddOrganisationRequest} [addOrganisationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemCreateEmptyOrganisationPost(addOrganisationRequest?: AddOrganisationRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrganisationDto> {
            return localVarFp.apiSystemCreateEmptyOrganisationPost(addOrganisationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GenerateAnimalRequest} [generateAnimalRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemGenerateAnimalsPost(generateAnimalRequest?: GenerateAnimalRequest, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.apiSystemGenerateAnimalsPost(generateAnimalRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GenerateMemberRequest} [generateMemberRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemGenerateEnterprisesPost(generateMemberRequest?: GenerateMemberRequest, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.apiSystemGenerateEnterprisesPost(generateMemberRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GenerateRequest} [generateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemGeneratePost(generateRequest?: GenerateRequest, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.apiSystemGeneratePost(generateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemResetAllEntitiesPost(organisationId?: number, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiSystemResetAllEntitiesPost(organisationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemResetConfigurationPost(organisationId?: number, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiSystemResetConfigurationPost(organisationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [organisationId] 
         * @param {EntityTypeCode} [entityTypeCode] 
         * @param {boolean} [addOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemResetEntityDetailsPost(organisationId?: number, entityTypeCode?: EntityTypeCode, addOnly?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiSystemResetEntityDetailsPost(organisationId, entityTypeCode, addOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemResetItemCodesPost(organisationId?: number, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiSystemResetItemCodesPost(organisationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [organisationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemSeedBillingRulesPost(organisationId?: number, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiSystemSeedBillingRulesPost(organisationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemTestAuthPost(options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiSystemTestAuthPost(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SystemApi - object-oriented interface
 * @export
 * @class SystemApi
 * @extends {BaseAPI}
 */
export class SystemApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public apiSystemApplyMigrationsPost(options?: RawAxiosRequestConfig) {
        return SystemApiFp(this.configuration).apiSystemApplyMigrationsPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public apiSystemAuthCheckGet(options?: RawAxiosRequestConfig) {
        return SystemApiFp(this.configuration).apiSystemAuthCheckGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EntityTypeCode} [entityTypeCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public apiSystemCreateDefaultScreenPost(entityTypeCode?: EntityTypeCode, options?: RawAxiosRequestConfig) {
        return SystemApiFp(this.configuration).apiSystemCreateDefaultScreenPost(entityTypeCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AddOrganisationRequest} [addOrganisationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public apiSystemCreateEmptyOrganisationPost(addOrganisationRequest?: AddOrganisationRequest, options?: RawAxiosRequestConfig) {
        return SystemApiFp(this.configuration).apiSystemCreateEmptyOrganisationPost(addOrganisationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GenerateAnimalRequest} [generateAnimalRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public apiSystemGenerateAnimalsPost(generateAnimalRequest?: GenerateAnimalRequest, options?: RawAxiosRequestConfig) {
        return SystemApiFp(this.configuration).apiSystemGenerateAnimalsPost(generateAnimalRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GenerateMemberRequest} [generateMemberRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public apiSystemGenerateEnterprisesPost(generateMemberRequest?: GenerateMemberRequest, options?: RawAxiosRequestConfig) {
        return SystemApiFp(this.configuration).apiSystemGenerateEnterprisesPost(generateMemberRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GenerateRequest} [generateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public apiSystemGeneratePost(generateRequest?: GenerateRequest, options?: RawAxiosRequestConfig) {
        return SystemApiFp(this.configuration).apiSystemGeneratePost(generateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [organisationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public apiSystemResetAllEntitiesPost(organisationId?: number, options?: RawAxiosRequestConfig) {
        return SystemApiFp(this.configuration).apiSystemResetAllEntitiesPost(organisationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [organisationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public apiSystemResetConfigurationPost(organisationId?: number, options?: RawAxiosRequestConfig) {
        return SystemApiFp(this.configuration).apiSystemResetConfigurationPost(organisationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [organisationId] 
     * @param {EntityTypeCode} [entityTypeCode] 
     * @param {boolean} [addOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public apiSystemResetEntityDetailsPost(organisationId?: number, entityTypeCode?: EntityTypeCode, addOnly?: boolean, options?: RawAxiosRequestConfig) {
        return SystemApiFp(this.configuration).apiSystemResetEntityDetailsPost(organisationId, entityTypeCode, addOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [organisationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public apiSystemResetItemCodesPost(organisationId?: number, options?: RawAxiosRequestConfig) {
        return SystemApiFp(this.configuration).apiSystemResetItemCodesPost(organisationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [organisationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public apiSystemSeedBillingRulesPost(organisationId?: number, options?: RawAxiosRequestConfig) {
        return SystemApiFp(this.configuration).apiSystemSeedBillingRulesPost(organisationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public apiSystemTestAuthPost(options?: RawAxiosRequestConfig) {
        return SystemApiFp(this.configuration).apiSystemTestAuthPost(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TimelineApi - axios parameter creator
 * @export
 */
export const TimelineApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [entityId] 
         * @param {EntityTypeCode} [entityType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTimelineGet: async (entityId?: string, entityType?: EntityTypeCode, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Timeline`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (entityType !== undefined) {
                localVarQueryParameter['entityType'] = entityType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TimelineApi - functional programming interface
 * @export
 */
export const TimelineApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TimelineApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [entityId] 
         * @param {EntityTypeCode} [entityType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTimelineGet(entityId?: string, entityType?: EntityTypeCode, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TimelineDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTimelineGet(entityId, entityType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimelineApi.apiTimelineGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TimelineApi - factory interface
 * @export
 */
export const TimelineApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TimelineApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [entityId] 
         * @param {EntityTypeCode} [entityType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTimelineGet(entityId?: string, entityType?: EntityTypeCode, options?: RawAxiosRequestConfig): AxiosPromise<Array<TimelineDto>> {
            return localVarFp.apiTimelineGet(entityId, entityType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TimelineApi - object-oriented interface
 * @export
 * @class TimelineApi
 * @extends {BaseAPI}
 */
export class TimelineApi extends BaseAPI {
    /**
     * 
     * @param {string} [entityId] 
     * @param {EntityTypeCode} [entityType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimelineApi
     */
    public apiTimelineGet(entityId?: string, entityType?: EntityTypeCode, options?: RawAxiosRequestConfig) {
        return TimelineApiFp(this.configuration).apiTimelineGet(entityId, entityType, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserConfigApi - axios parameter creator
 * @export
 */
export const UserConfigApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {UpsertUserConfigRequest} [upsertUserConfigRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserConfigPost: async (upsertUserConfigRequest?: UpsertUserConfigRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/UserConfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertUserConfigRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserConfigUserIdDelete: async (userId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiUserConfigUserIdDelete', 'userId', userId)
            const localVarPath = `/api/UserConfig/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserConfigUserIdGet: async (userId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiUserConfigUserIdGet', 'userId', userId)
            const localVarPath = `/api/UserConfig/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserConfigApi - functional programming interface
 * @export
 */
export const UserConfigApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserConfigApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {UpsertUserConfigRequest} [upsertUserConfigRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserConfigPost(upsertUserConfigRequest?: UpsertUserConfigRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserConfigPost(upsertUserConfigRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserConfigApi.apiUserConfigPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserConfigUserIdDelete(userId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserConfigUserIdDelete(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserConfigApi.apiUserConfigUserIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserConfigUserIdGet(userId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserConfigUserIdGet(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserConfigApi.apiUserConfigUserIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserConfigApi - factory interface
 * @export
 */
export const UserConfigApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserConfigApiFp(configuration)
    return {
        /**
         * 
         * @param {UpsertUserConfigRequest} [upsertUserConfigRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserConfigPost(upsertUserConfigRequest?: UpsertUserConfigRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserConfigDto> {
            return localVarFp.apiUserConfigPost(upsertUserConfigRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserConfigUserIdDelete(userId: number, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiUserConfigUserIdDelete(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserConfigUserIdGet(userId: number, options?: RawAxiosRequestConfig): AxiosPromise<UserConfigDto> {
            return localVarFp.apiUserConfigUserIdGet(userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserConfigApi - object-oriented interface
 * @export
 * @class UserConfigApi
 * @extends {BaseAPI}
 */
export class UserConfigApi extends BaseAPI {
    /**
     * 
     * @param {UpsertUserConfigRequest} [upsertUserConfigRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserConfigApi
     */
    public apiUserConfigPost(upsertUserConfigRequest?: UpsertUserConfigRequest, options?: RawAxiosRequestConfig) {
        return UserConfigApiFp(this.configuration).apiUserConfigPost(upsertUserConfigRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserConfigApi
     */
    public apiUserConfigUserIdDelete(userId: number, options?: RawAxiosRequestConfig) {
        return UserConfigApiFp(this.configuration).apiUserConfigUserIdDelete(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserConfigApi
     */
    public apiUserConfigUserIdGet(userId: number, options?: RawAxiosRequestConfig) {
        return UserConfigApiFp(this.configuration).apiUserConfigUserIdGet(userId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserRoleApi - axios parameter creator
 * @export
 */
export const UserRoleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserRolePost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/UserRole`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserRoleApi - functional programming interface
 * @export
 */
export const UserRoleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserRoleApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserRolePost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserProfileDtoPagedResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserRolePost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserRoleApi.apiUserRolePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserRoleApi - factory interface
 * @export
 */
export const UserRoleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserRoleApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserRolePost(options?: RawAxiosRequestConfig): AxiosPromise<UserProfileDtoPagedResult> {
            return localVarFp.apiUserRolePost(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserRoleApi - object-oriented interface
 * @export
 * @class UserRoleApi
 * @extends {BaseAPI}
 */
export class UserRoleApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRoleApi
     */
    public apiUserRolePost(options?: RawAxiosRequestConfig) {
        return UserRoleApiFp(this.configuration).apiUserRolePost(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ValidationApi - axios parameter creator
 * @export
 */
export const ValidationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {EvaluateJsonRuleRequest} [evaluateJsonRuleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValidationEvaluateJsonRulePost: async (evaluateJsonRuleRequest?: EvaluateJsonRuleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Validation/evaluate-json-rule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(evaluateJsonRuleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ResolveTestCaseRequest} [resolveTestCaseRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValidationResolveTestCasePost: async (resolveTestCaseRequest?: ResolveTestCaseRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Validation/resolve-test-case`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resolveTestCaseRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValidationRuleExamplesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Validation/rule-examples`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkSetRuleEnabledRequest} [bulkSetRuleEnabledRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValidationRulesBulkEnabledPost: async (bulkSetRuleEnabledRequest?: BulkSetRuleEnabledRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Validation/rules/bulk-enabled`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkSetRuleEnabledRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EvaluateRuleByFunctionBatchRequestBody} [evaluateRuleByFunctionBatchRequestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValidationRulesEvaluateByFunctionBatchPost: async (evaluateRuleByFunctionBatchRequestBody?: EvaluateRuleByFunctionBatchRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Validation/rules/evaluate-by-function/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(evaluateRuleByFunctionBatchRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EvaluateRuleByFunctionBatchRequestBody} [evaluateRuleByFunctionBatchRequestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValidationRulesEvaluateByFunctionPost: async (evaluateRuleByFunctionBatchRequestBody?: EvaluateRuleByFunctionBatchRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Validation/rules/evaluate-by-function`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(evaluateRuleByFunctionBatchRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddRuleRequest} [addRuleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValidationRulesPost: async (addRuleRequest?: AddRuleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Validation/rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addRuleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValidationRulesRecentGet: async (count?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Validation/rules/recent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValidationRulesRuleIdDelete: async (ruleId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('apiValidationRulesRuleIdDelete', 'ruleId', ruleId)
            const localVarPath = `/api/Validation/rules/{ruleId}`
                .replace(`{${"ruleId"}}`, encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValidationRulesRuleIdGet: async (ruleId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('apiValidationRulesRuleIdGet', 'ruleId', ruleId)
            const localVarPath = `/api/Validation/rules/{ruleId}`
                .replace(`{${"ruleId"}}`, encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {UpdateRuleRequest} [updateRuleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValidationRulesRuleIdPut: async (ruleId: number, updateRuleRequest?: UpdateRuleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('apiValidationRulesRuleIdPut', 'ruleId', ruleId)
            const localVarPath = `/api/Validation/rules/{ruleId}`
                .replace(`{${"ruleId"}}`, encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRuleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValidationRulesRuleIdSampleCasesGet: async (ruleId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('apiValidationRulesRuleIdSampleCasesGet', 'ruleId', ruleId)
            const localVarPath = `/api/Validation/rules/{ruleId}/sample-cases`
                .replace(`{${"ruleId"}}`, encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SearchRuleRequest} [searchRuleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValidationRulesSearchPost: async (searchRuleRequest?: SearchRuleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Validation/rules/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchRuleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [refresh] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValidationSampleCasesDiagnosticsGet: async (refresh?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Validation/sample-cases/diagnostics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (refresh !== undefined) {
                localVarQueryParameter['refresh'] = refresh;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TestJsonRuleRequest} [testJsonRuleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValidationTestJsonRulePost: async (testJsonRuleRequest?: TestJsonRuleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Validation/test-json-rule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testJsonRuleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TestRuleDefinitionRequest} [testRuleDefinitionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValidationTestPost: async (testRuleDefinitionRequest?: TestRuleDefinitionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Validation/test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testRuleDefinitionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ValidationApi - functional programming interface
 * @export
 */
export const ValidationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ValidationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {EvaluateJsonRuleRequest} [evaluateJsonRuleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiValidationEvaluateJsonRulePost(evaluateJsonRuleRequest?: EvaluateJsonRuleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RuleEvaluationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiValidationEvaluateJsonRulePost(evaluateJsonRuleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValidationApi.apiValidationEvaluateJsonRulePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ResolveTestCaseRequest} [resolveTestCaseRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiValidationResolveTestCasePost(resolveTestCaseRequest?: ResolveTestCaseRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResolveTestCaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiValidationResolveTestCasePost(resolveTestCaseRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValidationApi.apiValidationResolveTestCasePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiValidationRuleExamplesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RuleExamplesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiValidationRuleExamplesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValidationApi.apiValidationRuleExamplesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BulkSetRuleEnabledRequest} [bulkSetRuleEnabledRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiValidationRulesBulkEnabledPost(bulkSetRuleEnabledRequest?: BulkSetRuleEnabledRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkSetRuleEnabledResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiValidationRulesBulkEnabledPost(bulkSetRuleEnabledRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValidationApi.apiValidationRulesBulkEnabledPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EvaluateRuleByFunctionBatchRequestBody} [evaluateRuleByFunctionBatchRequestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiValidationRulesEvaluateByFunctionBatchPost(evaluateRuleByFunctionBatchRequestBody?: EvaluateRuleByFunctionBatchRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RuleEvaluationBatchResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiValidationRulesEvaluateByFunctionBatchPost(evaluateRuleByFunctionBatchRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValidationApi.apiValidationRulesEvaluateByFunctionBatchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EvaluateRuleByFunctionBatchRequestBody} [evaluateRuleByFunctionBatchRequestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiValidationRulesEvaluateByFunctionPost(evaluateRuleByFunctionBatchRequestBody?: EvaluateRuleByFunctionBatchRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiValidationRulesEvaluateByFunctionPost(evaluateRuleByFunctionBatchRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValidationApi.apiValidationRulesEvaluateByFunctionPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AddRuleRequest} [addRuleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiValidationRulesPost(addRuleRequest?: AddRuleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RuleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiValidationRulesPost(addRuleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValidationApi.apiValidationRulesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiValidationRulesRecentGet(count?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RuleDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiValidationRulesRecentGet(count, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValidationApi.apiValidationRulesRecentGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiValidationRulesRuleIdDelete(ruleId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiValidationRulesRuleIdDelete(ruleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValidationApi.apiValidationRulesRuleIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiValidationRulesRuleIdGet(ruleId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RuleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiValidationRulesRuleIdGet(ruleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValidationApi.apiValidationRulesRuleIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {UpdateRuleRequest} [updateRuleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiValidationRulesRuleIdPut(ruleId: number, updateRuleRequest?: UpdateRuleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RuleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiValidationRulesRuleIdPut(ruleId, updateRuleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValidationApi.apiValidationRulesRuleIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiValidationRulesRuleIdSampleCasesGet(ruleId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SampleRuleCaseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiValidationRulesRuleIdSampleCasesGet(ruleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValidationApi.apiValidationRulesRuleIdSampleCasesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SearchRuleRequest} [searchRuleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiValidationRulesSearchPost(searchRuleRequest?: SearchRuleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RuleDtoPagedResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiValidationRulesSearchPost(searchRuleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValidationApi.apiValidationRulesSearchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [refresh] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiValidationSampleCasesDiagnosticsGet(refresh?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SampleCaseSchemaDiagnosticsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiValidationSampleCasesDiagnosticsGet(refresh, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValidationApi.apiValidationSampleCasesDiagnosticsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TestJsonRuleRequest} [testJsonRuleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiValidationTestJsonRulePost(testJsonRuleRequest?: TestJsonRuleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RuleTestResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiValidationTestJsonRulePost(testJsonRuleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValidationApi.apiValidationTestJsonRulePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TestRuleDefinitionRequest} [testRuleDefinitionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiValidationTestPost(testRuleDefinitionRequest?: TestRuleDefinitionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RuleTestResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiValidationTestPost(testRuleDefinitionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValidationApi.apiValidationTestPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ValidationApi - factory interface
 * @export
 */
export const ValidationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ValidationApiFp(configuration)
    return {
        /**
         * 
         * @param {EvaluateJsonRuleRequest} [evaluateJsonRuleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValidationEvaluateJsonRulePost(evaluateJsonRuleRequest?: EvaluateJsonRuleRequest, options?: RawAxiosRequestConfig): AxiosPromise<RuleEvaluationResultDto> {
            return localVarFp.apiValidationEvaluateJsonRulePost(evaluateJsonRuleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ResolveTestCaseRequest} [resolveTestCaseRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValidationResolveTestCasePost(resolveTestCaseRequest?: ResolveTestCaseRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResolveTestCaseResponse> {
            return localVarFp.apiValidationResolveTestCasePost(resolveTestCaseRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValidationRuleExamplesGet(options?: RawAxiosRequestConfig): AxiosPromise<RuleExamplesDto> {
            return localVarFp.apiValidationRuleExamplesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BulkSetRuleEnabledRequest} [bulkSetRuleEnabledRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValidationRulesBulkEnabledPost(bulkSetRuleEnabledRequest?: BulkSetRuleEnabledRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkSetRuleEnabledResponseDto> {
            return localVarFp.apiValidationRulesBulkEnabledPost(bulkSetRuleEnabledRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EvaluateRuleByFunctionBatchRequestBody} [evaluateRuleByFunctionBatchRequestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValidationRulesEvaluateByFunctionBatchPost(evaluateRuleByFunctionBatchRequestBody?: EvaluateRuleByFunctionBatchRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<RuleEvaluationBatchResultDto> {
            return localVarFp.apiValidationRulesEvaluateByFunctionBatchPost(evaluateRuleByFunctionBatchRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EvaluateRuleByFunctionBatchRequestBody} [evaluateRuleByFunctionBatchRequestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValidationRulesEvaluateByFunctionPost(evaluateRuleByFunctionBatchRequestBody?: EvaluateRuleByFunctionBatchRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiValidationRulesEvaluateByFunctionPost(evaluateRuleByFunctionBatchRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AddRuleRequest} [addRuleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValidationRulesPost(addRuleRequest?: AddRuleRequest, options?: RawAxiosRequestConfig): AxiosPromise<RuleDto> {
            return localVarFp.apiValidationRulesPost(addRuleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValidationRulesRecentGet(count?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<RuleDto>> {
            return localVarFp.apiValidationRulesRecentGet(count, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValidationRulesRuleIdDelete(ruleId: number, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiValidationRulesRuleIdDelete(ruleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValidationRulesRuleIdGet(ruleId: number, options?: RawAxiosRequestConfig): AxiosPromise<RuleDto> {
            return localVarFp.apiValidationRulesRuleIdGet(ruleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {UpdateRuleRequest} [updateRuleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValidationRulesRuleIdPut(ruleId: number, updateRuleRequest?: UpdateRuleRequest, options?: RawAxiosRequestConfig): AxiosPromise<RuleDto> {
            return localVarFp.apiValidationRulesRuleIdPut(ruleId, updateRuleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValidationRulesRuleIdSampleCasesGet(ruleId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<SampleRuleCaseDto>> {
            return localVarFp.apiValidationRulesRuleIdSampleCasesGet(ruleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SearchRuleRequest} [searchRuleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValidationRulesSearchPost(searchRuleRequest?: SearchRuleRequest, options?: RawAxiosRequestConfig): AxiosPromise<RuleDtoPagedResult> {
            return localVarFp.apiValidationRulesSearchPost(searchRuleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} [refresh] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValidationSampleCasesDiagnosticsGet(refresh?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<SampleCaseSchemaDiagnosticsDto> {
            return localVarFp.apiValidationSampleCasesDiagnosticsGet(refresh, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TestJsonRuleRequest} [testJsonRuleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValidationTestJsonRulePost(testJsonRuleRequest?: TestJsonRuleRequest, options?: RawAxiosRequestConfig): AxiosPromise<RuleTestResultDto> {
            return localVarFp.apiValidationTestJsonRulePost(testJsonRuleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TestRuleDefinitionRequest} [testRuleDefinitionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValidationTestPost(testRuleDefinitionRequest?: TestRuleDefinitionRequest, options?: RawAxiosRequestConfig): AxiosPromise<RuleTestResultDto> {
            return localVarFp.apiValidationTestPost(testRuleDefinitionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ValidationApi - object-oriented interface
 * @export
 * @class ValidationApi
 * @extends {BaseAPI}
 */
export class ValidationApi extends BaseAPI {
    /**
     * 
     * @param {EvaluateJsonRuleRequest} [evaluateJsonRuleRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationApi
     */
    public apiValidationEvaluateJsonRulePost(evaluateJsonRuleRequest?: EvaluateJsonRuleRequest, options?: RawAxiosRequestConfig) {
        return ValidationApiFp(this.configuration).apiValidationEvaluateJsonRulePost(evaluateJsonRuleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ResolveTestCaseRequest} [resolveTestCaseRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationApi
     */
    public apiValidationResolveTestCasePost(resolveTestCaseRequest?: ResolveTestCaseRequest, options?: RawAxiosRequestConfig) {
        return ValidationApiFp(this.configuration).apiValidationResolveTestCasePost(resolveTestCaseRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationApi
     */
    public apiValidationRuleExamplesGet(options?: RawAxiosRequestConfig) {
        return ValidationApiFp(this.configuration).apiValidationRuleExamplesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BulkSetRuleEnabledRequest} [bulkSetRuleEnabledRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationApi
     */
    public apiValidationRulesBulkEnabledPost(bulkSetRuleEnabledRequest?: BulkSetRuleEnabledRequest, options?: RawAxiosRequestConfig) {
        return ValidationApiFp(this.configuration).apiValidationRulesBulkEnabledPost(bulkSetRuleEnabledRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EvaluateRuleByFunctionBatchRequestBody} [evaluateRuleByFunctionBatchRequestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationApi
     */
    public apiValidationRulesEvaluateByFunctionBatchPost(evaluateRuleByFunctionBatchRequestBody?: EvaluateRuleByFunctionBatchRequestBody, options?: RawAxiosRequestConfig) {
        return ValidationApiFp(this.configuration).apiValidationRulesEvaluateByFunctionBatchPost(evaluateRuleByFunctionBatchRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EvaluateRuleByFunctionBatchRequestBody} [evaluateRuleByFunctionBatchRequestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationApi
     */
    public apiValidationRulesEvaluateByFunctionPost(evaluateRuleByFunctionBatchRequestBody?: EvaluateRuleByFunctionBatchRequestBody, options?: RawAxiosRequestConfig) {
        return ValidationApiFp(this.configuration).apiValidationRulesEvaluateByFunctionPost(evaluateRuleByFunctionBatchRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AddRuleRequest} [addRuleRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationApi
     */
    public apiValidationRulesPost(addRuleRequest?: AddRuleRequest, options?: RawAxiosRequestConfig) {
        return ValidationApiFp(this.configuration).apiValidationRulesPost(addRuleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [count] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationApi
     */
    public apiValidationRulesRecentGet(count?: number, options?: RawAxiosRequestConfig) {
        return ValidationApiFp(this.configuration).apiValidationRulesRecentGet(count, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} ruleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationApi
     */
    public apiValidationRulesRuleIdDelete(ruleId: number, options?: RawAxiosRequestConfig) {
        return ValidationApiFp(this.configuration).apiValidationRulesRuleIdDelete(ruleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} ruleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationApi
     */
    public apiValidationRulesRuleIdGet(ruleId: number, options?: RawAxiosRequestConfig) {
        return ValidationApiFp(this.configuration).apiValidationRulesRuleIdGet(ruleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} ruleId 
     * @param {UpdateRuleRequest} [updateRuleRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationApi
     */
    public apiValidationRulesRuleIdPut(ruleId: number, updateRuleRequest?: UpdateRuleRequest, options?: RawAxiosRequestConfig) {
        return ValidationApiFp(this.configuration).apiValidationRulesRuleIdPut(ruleId, updateRuleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} ruleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationApi
     */
    public apiValidationRulesRuleIdSampleCasesGet(ruleId: number, options?: RawAxiosRequestConfig) {
        return ValidationApiFp(this.configuration).apiValidationRulesRuleIdSampleCasesGet(ruleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SearchRuleRequest} [searchRuleRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationApi
     */
    public apiValidationRulesSearchPost(searchRuleRequest?: SearchRuleRequest, options?: RawAxiosRequestConfig) {
        return ValidationApiFp(this.configuration).apiValidationRulesSearchPost(searchRuleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {boolean} [refresh] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationApi
     */
    public apiValidationSampleCasesDiagnosticsGet(refresh?: boolean, options?: RawAxiosRequestConfig) {
        return ValidationApiFp(this.configuration).apiValidationSampleCasesDiagnosticsGet(refresh, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TestJsonRuleRequest} [testJsonRuleRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationApi
     */
    public apiValidationTestJsonRulePost(testJsonRuleRequest?: TestJsonRuleRequest, options?: RawAxiosRequestConfig) {
        return ValidationApiFp(this.configuration).apiValidationTestJsonRulePost(testJsonRuleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TestRuleDefinitionRequest} [testRuleDefinitionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationApi
     */
    public apiValidationTestPost(testRuleDefinitionRequest?: TestRuleDefinitionRequest, options?: RawAxiosRequestConfig) {
        return ValidationApiFp(this.configuration).apiValidationTestPost(testRuleDefinitionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WorkOrderApi - axios parameter creator
 * @export
 */
export const WorkOrderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AppendWorkOrderItemsRequest} [appendWorkOrderItemsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrderAppendWorkOrderItemsPost: async (appendWorkOrderItemsRequest?: AppendWorkOrderItemsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/WorkOrder/AppendWorkOrderItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appendWorkOrderItemsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteWorkOrderItemsRequest} [deleteWorkOrderItemsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrderDeleteWorkOrderItemsPost: async (deleteWorkOrderItemsRequest?: DeleteWorkOrderItemsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/WorkOrder/DeleteWorkOrderItems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteWorkOrderItemsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [workOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrderGetWorkOrderByIdGet: async (workOrderId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/WorkOrder/GetWorkOrderById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (workOrderId !== undefined) {
                localVarQueryParameter['workOrderId'] = workOrderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [enterpriseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrderGetWorkOrdersGroupedByOrganisationGet: async (enterpriseId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/WorkOrder/GetWorkOrdersGroupedByOrganisation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (enterpriseId !== undefined) {
                localVarQueryParameter['enterpriseId'] = enterpriseId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PagedWorkOrderRequest} [pagedWorkOrderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrderPagedWorkOrdersByEnterprisePost: async (pagedWorkOrderRequest?: PagedWorkOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/WorkOrder/PagedWorkOrdersByEnterprise`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pagedWorkOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {WorkOrderSearchSortFilterRequest} [workOrderSearchSortFilterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrderSearchSortFilterPost: async (workOrderSearchSortFilterRequest?: WorkOrderSearchSortFilterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/WorkOrder/SearchSortFilter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workOrderSearchSortFilterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SubmitWorkOrdersRequest} [submitWorkOrdersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrderSubmitWorkOrdersPost: async (submitWorkOrdersRequest?: SubmitWorkOrdersRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/WorkOrder/SubmitWorkOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication X-Organisation-Id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Organisation-Id", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submitWorkOrdersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkOrderApi - functional programming interface
 * @export
 */
export const WorkOrderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkOrderApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AppendWorkOrderItemsRequest} [appendWorkOrderItemsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkOrderAppendWorkOrderItemsPost(appendWorkOrderItemsRequest?: AppendWorkOrderItemsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkOrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWorkOrderAppendWorkOrderItemsPost(appendWorkOrderItemsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrderApi.apiWorkOrderAppendWorkOrderItemsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeleteWorkOrderItemsRequest} [deleteWorkOrderItemsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkOrderDeleteWorkOrderItemsPost(deleteWorkOrderItemsRequest?: DeleteWorkOrderItemsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkOrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWorkOrderDeleteWorkOrderItemsPost(deleteWorkOrderItemsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrderApi.apiWorkOrderDeleteWorkOrderItemsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [workOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkOrderGetWorkOrderByIdGet(workOrderId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkOrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWorkOrderGetWorkOrderByIdGet(workOrderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrderApi.apiWorkOrderGetWorkOrderByIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [enterpriseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkOrderGetWorkOrdersGroupedByOrganisationGet(enterpriseId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganisationGroupedWorkOrders>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWorkOrderGetWorkOrdersGroupedByOrganisationGet(enterpriseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrderApi.apiWorkOrderGetWorkOrdersGroupedByOrganisationGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PagedWorkOrderRequest} [pagedWorkOrderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkOrderPagedWorkOrdersByEnterprisePost(pagedWorkOrderRequest?: PagedWorkOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkOrderDtoPagedResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWorkOrderPagedWorkOrdersByEnterprisePost(pagedWorkOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrderApi.apiWorkOrderPagedWorkOrdersByEnterprisePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {WorkOrderSearchSortFilterRequest} [workOrderSearchSortFilterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkOrderSearchSortFilterPost(workOrderSearchSortFilterRequest?: WorkOrderSearchSortFilterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkOrderDtoPagedResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWorkOrderSearchSortFilterPost(workOrderSearchSortFilterRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrderApi.apiWorkOrderSearchSortFilterPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SubmitWorkOrdersRequest} [submitWorkOrdersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkOrderSubmitWorkOrdersPost(submitWorkOrdersRequest?: SubmitWorkOrdersRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkOrderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWorkOrderSubmitWorkOrdersPost(submitWorkOrdersRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrderApi.apiWorkOrderSubmitWorkOrdersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorkOrderApi - factory interface
 * @export
 */
export const WorkOrderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkOrderApiFp(configuration)
    return {
        /**
         * 
         * @param {AppendWorkOrderItemsRequest} [appendWorkOrderItemsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrderAppendWorkOrderItemsPost(appendWorkOrderItemsRequest?: AppendWorkOrderItemsRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkOrderDto> {
            return localVarFp.apiWorkOrderAppendWorkOrderItemsPost(appendWorkOrderItemsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteWorkOrderItemsRequest} [deleteWorkOrderItemsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrderDeleteWorkOrderItemsPost(deleteWorkOrderItemsRequest?: DeleteWorkOrderItemsRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkOrderDto> {
            return localVarFp.apiWorkOrderDeleteWorkOrderItemsPost(deleteWorkOrderItemsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [workOrderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrderGetWorkOrderByIdGet(workOrderId?: number, options?: RawAxiosRequestConfig): AxiosPromise<WorkOrderDto> {
            return localVarFp.apiWorkOrderGetWorkOrderByIdGet(workOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [enterpriseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrderGetWorkOrdersGroupedByOrganisationGet(enterpriseId?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<OrganisationGroupedWorkOrders>> {
            return localVarFp.apiWorkOrderGetWorkOrdersGroupedByOrganisationGet(enterpriseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PagedWorkOrderRequest} [pagedWorkOrderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrderPagedWorkOrdersByEnterprisePost(pagedWorkOrderRequest?: PagedWorkOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkOrderDtoPagedResult> {
            return localVarFp.apiWorkOrderPagedWorkOrdersByEnterprisePost(pagedWorkOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WorkOrderSearchSortFilterRequest} [workOrderSearchSortFilterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrderSearchSortFilterPost(workOrderSearchSortFilterRequest?: WorkOrderSearchSortFilterRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkOrderDtoPagedResult> {
            return localVarFp.apiWorkOrderSearchSortFilterPost(workOrderSearchSortFilterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubmitWorkOrdersRequest} [submitWorkOrdersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrderSubmitWorkOrdersPost(submitWorkOrdersRequest?: SubmitWorkOrdersRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<WorkOrderDto>> {
            return localVarFp.apiWorkOrderSubmitWorkOrdersPost(submitWorkOrdersRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkOrderApi - object-oriented interface
 * @export
 * @class WorkOrderApi
 * @extends {BaseAPI}
 */
export class WorkOrderApi extends BaseAPI {
    /**
     * 
     * @param {AppendWorkOrderItemsRequest} [appendWorkOrderItemsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrderApi
     */
    public apiWorkOrderAppendWorkOrderItemsPost(appendWorkOrderItemsRequest?: AppendWorkOrderItemsRequest, options?: RawAxiosRequestConfig) {
        return WorkOrderApiFp(this.configuration).apiWorkOrderAppendWorkOrderItemsPost(appendWorkOrderItemsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteWorkOrderItemsRequest} [deleteWorkOrderItemsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrderApi
     */
    public apiWorkOrderDeleteWorkOrderItemsPost(deleteWorkOrderItemsRequest?: DeleteWorkOrderItemsRequest, options?: RawAxiosRequestConfig) {
        return WorkOrderApiFp(this.configuration).apiWorkOrderDeleteWorkOrderItemsPost(deleteWorkOrderItemsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [workOrderId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrderApi
     */
    public apiWorkOrderGetWorkOrderByIdGet(workOrderId?: number, options?: RawAxiosRequestConfig) {
        return WorkOrderApiFp(this.configuration).apiWorkOrderGetWorkOrderByIdGet(workOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [enterpriseId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrderApi
     */
    public apiWorkOrderGetWorkOrdersGroupedByOrganisationGet(enterpriseId?: number, options?: RawAxiosRequestConfig) {
        return WorkOrderApiFp(this.configuration).apiWorkOrderGetWorkOrdersGroupedByOrganisationGet(enterpriseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PagedWorkOrderRequest} [pagedWorkOrderRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrderApi
     */
    public apiWorkOrderPagedWorkOrdersByEnterprisePost(pagedWorkOrderRequest?: PagedWorkOrderRequest, options?: RawAxiosRequestConfig) {
        return WorkOrderApiFp(this.configuration).apiWorkOrderPagedWorkOrdersByEnterprisePost(pagedWorkOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WorkOrderSearchSortFilterRequest} [workOrderSearchSortFilterRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrderApi
     */
    public apiWorkOrderSearchSortFilterPost(workOrderSearchSortFilterRequest?: WorkOrderSearchSortFilterRequest, options?: RawAxiosRequestConfig) {
        return WorkOrderApiFp(this.configuration).apiWorkOrderSearchSortFilterPost(workOrderSearchSortFilterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubmitWorkOrdersRequest} [submitWorkOrdersRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrderApi
     */
    public apiWorkOrderSubmitWorkOrdersPost(submitWorkOrdersRequest?: SubmitWorkOrdersRequest, options?: RawAxiosRequestConfig) {
        return WorkOrderApiFp(this.configuration).apiWorkOrderSubmitWorkOrdersPost(submitWorkOrdersRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



